/* Editor de banderas de tela · Imprimirlo
 * El cliente elige talla y base, sube su diseño y lo coloca sobre la forma REAL de su bandera
 * (contornos de las plantillas del proveedor en assets/banderas-formas.js, en cm):
 *   - línea amarilla = CORTE: el color llega hasta ahí
 *   - línea roja     = SEGURIDAD: nada importante fuera (ahí cosen)
 * Al carrito va el archivo ORIGINAL más la posición (_posicion, en cm sobre la caja de corte).
 * El archivo final a 150 ppp lo monta .taller/panel/montaje_bandera.py: el navegador no puede
 * (una XXL a 150 ppp son 226 megapíxeles).
 */
(function () {
  'use strict';

  // lo que dice la ficha del proveedor de cada base (adivin.com)
  var DESC_BASE = {
    'Tela normal': 'Poliéster de 115 g, impresión por sublimación. Dobladillo cosido alrededor. Interior y exterior.',
    'Tela impermeable': 'Poliéster impermeable de 180 g, impresión UV. Resiste líquidos y lluvia: ideal para exterior y catering.',
    'Estructura + bolsa': 'Estructura de aluminio extensible (tubos telescópicos negros, 2 pies de hierro) y bolsa de transporte. Montaje en 10 minutos. Interior y exterior.',
    'Tela normal · ollaos cada 1 m': 'Tela de bandera de 115 g. Ollaos metálicos cada metro y dobladillo cosido. Para interior y exterior.',
    'Tela normal · ollaos cada 50 cm': 'Tela de bandera de 115 g con más ollaos (cada 50 cm): queda más tensa y aguanta mejor el viento.',
    'Impermeable · ollaos cada 1 m': 'Tela impermeable. Ollaos cada metro. Ideal si va a estar siempre a la intemperie.',
    'Impermeable · ollaos cada 50 cm': 'Tela impermeable con ollaos cada 50 cm: la más resistente a lluvia y viento.',
    'Pica': 'Se clava en el suelo: césped, campo, parque o playa. Hierro cromado de 50 cm.',
    'Cruceta con flotador': 'Cruceta plegable de hierro. El flotador se rellena de agua para dar peso. Interior y exterior.',
    'Tornillo rosca': 'Se enrosca en tierra o arena: playa, jardín, campo. Solo para exterior.',
    'Rueda de coche': 'Se coloca bajo la rueda de un coche, furgoneta o moto. Hierro cromado.',
    'Pared': 'Fija la bandera a una pared o fachada, con 45° de inclinación. Solo tallas S y M.',
    'Agua 20 L': 'Depósito de plástico de 43 × 43 cm. Se llena de agua o arena hasta 20 kg. Interior y exterior.',
    'Deluxe 4 kg': 'Plancha de hierro negro mate de 4 kg (30 × 30 cm). Recomendada para interior.',
    'Hércules 12 kg': 'Plancha de hierro negro mate de 12 kg (48 × 48 cm). Interior y exterior.'
  };

  /* ESTILOS: lo que elige quien no sabe de diseño. Cada uno trae color de fondo, color y tipo de letra y una
     composición. Las miniaturas se pintan con la forma real de SU bandera. */
  /* ESTILOS: cada uno con su letra, su composición y 4 combinaciones de color (como las de Vistaprint).
     f = fondo liso · deg = degradado [arriba, abajo] · t = color del texto · p y s = colores de los adornos (P y S). */
  var ESTILOS = [
    { id: 'negro', cat: 'negocio', nombre: 'Negro', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#111111', t: '#ffffff', p: '#ffe500', s: '#e31b23' }, { f: '#111111', t: '#ffffff', p: '#22d3ee', s: '#1d4ed8' },
      { f: '#111111', t: '#ffffff', p: '#a3e635', s: '#1fb324' }, { f: '#111111', t: '#ffffff', p: '#f97316', s: '#ffe500' } ] },
    { id: 'sol', cat: 'ofertas', nombre: 'Amarillo', fuente: 'deportiva', layout: 'vertical', vars: [
      { f: '#ffe500', t: '#111111', p: '#111111', s: '#e31b23' }, { f: '#ffe500', t: '#111111', p: '#1d4ed8', s: '#111111' },
      { f: '#f97316', t: '#ffffff', p: '#111111', s: '#ffe500' }, { f: '#ffffff', t: '#111111', p: '#ffe500', s: '#111111' } ] },
    { id: 'azul', cat: 'negocio', nombre: 'Azul', fuente: 'redonda', layout: 'logo-texto', vars: [
      { f: '#1d4ed8', t: '#ffffff', p: '#60a5fa', s: '#ffffff' }, { f: '#0f766e', t: '#ffffff', p: '#5eead4', s: '#ffffff' },
      { f: '#7c3aed', t: '#ffffff', p: '#c4b5fd', s: '#ffffff' }, { f: '#e31b23', t: '#ffffff', p: '#fca5a5', s: '#ffffff' } ] },
    { id: 'rojo', cat: 'ofertas', nombre: 'Rojo', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { f: '#e31b23', t: '#ffffff', p: '#ffffff', s: '#ffffff' }, { f: '#111111', t: '#ffffff', p: '#e31b23', s: '#e31b23' },
      { f: '#1d4ed8', t: '#ffffff', p: '#ffffff', s: '#ffffff' }, { f: '#1fb324', t: '#ffffff', p: '#ffffff', s: '#ffffff' } ] },
    { id: 'verde', cat: 'negocio', nombre: 'Verde', fuente: 'deportiva', layout: 'vertical', vars: [
      { f: '#1fb324', t: '#ffffff', p: '#a3e635', s: '#14532d' }, { f: '#1d4ed8', t: '#ffffff', p: '#93c5fd', s: '#1e3a8a' },
      { f: '#e31b23', t: '#ffffff', p: '#fca5a5', s: '#7f1d1d' }, { f: '#7c3aed', t: '#ffffff', p: '#ddd6fe', s: '#4c1d95' } ] },
    { id: 'clasico', cat: 'negocio', nombre: 'Clásico', fuente: 'clasica', layout: 'logo-texto', vars: [
      { f: '#ffffff', t: '#111111', p: '#111111', s: '#c9a227' }, { f: '#f5f0e6', t: '#14532d', p: '#14532d', s: '#c9a227' },
      { f: '#ffffff', t: '#1e3a8a', p: '#1e3a8a', s: '#e31b23' }, { f: '#ffffff', t: '#7f1d1d', p: '#7f1d1d', s: '#c9a227' } ] },
    { id: 'atardecer', cat: 'fiestas', nombre: 'Atardecer', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { deg: ['#fbbf24', '#e31b23'], t: '#ffffff', p: '#fff7ae', s: '#7f1d1d' }, { deg: ['#f9a8d4', '#7c3aed'], t: '#ffffff', p: '#fde7f3', s: '#4c1d95' },
      { deg: ['#fde68a', '#f97316'], t: '#111111', p: '#ffffff', s: '#9a3412' }, { deg: ['#fb7185', '#1e1b4b'], t: '#ffffff', p: '#fecdd3', s: '#312e81' } ] },
    { id: 'oceano', cat: 'negocio', nombre: 'Océano', fuente: 'redonda', layout: 'logo-texto', vars: [
      { deg: ['#22d3ee', '#1e3a8a'], t: '#ffffff', p: '#ffffff', s: '#0b1f4d' }, { deg: ['#5eead4', '#134e4a'], t: '#ffffff', p: '#ffffff', s: '#042f2e' },
      { deg: ['#93c5fd', '#312e81'], t: '#ffffff', p: '#ffffff', s: '#1e1b4b' }, { deg: ['#e0f2fe', '#0369a1'], t: '#0b1f4d', p: '#ffffff', s: '#0c4a6e' } ] },
    { id: 'neon', cat: 'fiestas', nombre: 'Neón', fuente: 'deportiva', layout: 'vertical', vars: [
      { deg: ['#ec4899', '#4c1d95'], t: '#ffffff', p: '#ffffff', s: '#f9a8d4' }, { deg: ['#22d3ee', '#7c3aed'], t: '#ffffff', p: '#ffffff', s: '#a5f3fc' },
      { deg: ['#a3e635', '#0f766e'], t: '#ffffff', p: '#ffffff', s: '#d9f99d' }, { deg: ['#f97316', '#be123c'], t: '#ffffff', p: '#ffffff', s: '#fed7aa' } ] },
    { id: 'bosque', cat: 'negocio', nombre: 'Bosque', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { deg: ['#a3e635', '#14532d'], t: '#ffffff', p: '#ecfccb', s: '#052e16' }, { deg: ['#fde047', '#15803d'], t: '#111111', p: '#fef9c3', s: '#052e16' },
      { deg: ['#6ee7b7', '#064e3b'], t: '#ffffff', p: '#d1fae5', s: '#022c22' }, { deg: ['#bef264', '#365314'], t: '#ffffff', p: '#f7fee7', s: '#1a2e05' } ] },
    { id: 'dorado', cat: 'negocio', nombre: 'Dorado', fuente: 'clasica', layout: 'logo-texto', vars: [
      { f: '#111111', t: '#f5c518', p: '#f5c518', s: '#f5c518' }, { f: '#0b1f4d', t: '#f5c518', p: '#f5c518', s: '#f5c518' },
      { f: '#14532d', t: '#f5c518', p: '#f5c518', s: '#f5c518' }, { f: '#4c0519', t: '#f5c518', p: '#f5c518', s: '#f5c518' } ] },
    { id: 'marino', cat: 'negocio', nombre: 'Marino', fuente: 'college', layout: 'vertical', vars: [
      { f: '#0b1f4d', t: '#ffffff', p: '#ffffff', s: '#e31b23' }, { f: '#7f1d1d', t: '#ffffff', p: '#ffffff', s: '#f5c518' },
      { f: '#14532d', t: '#ffffff', p: '#ffffff', s: '#f5c518' }, { f: '#111111', t: '#ffffff', p: '#ffffff', s: '#ffe500' } ] },
    { id: 'bicolor', cat: 'negocio', nombre: 'Dos tonos', fuente: 'redonda', layout: 'logo-texto', vars: [
      { f: '#1d4ed8', t: '#ffffff', p: '#ffffff', s: '#0b1f4d' }, { f: '#e31b23', t: '#ffffff', p: '#ffffff', s: '#7f1d1d' },
      { f: '#1fb324', t: '#ffffff', p: '#ffffff', s: '#14532d' }, { f: '#111111', t: '#ffffff', p: '#ffffff', s: '#ffe500' } ] },
    { id: 'lineas', cat: 'negocio', nombre: 'Líneas', fuente: 'clasica', layout: 'vertical', vars: [
      { f: '#14532d', t: '#ffffff', p: '#86efac', s: '#14532d' }, { f: '#0b1f4d', t: '#ffffff', p: '#93c5fd', s: '#0b1f4d' },
      { f: '#4c1d95', t: '#ffffff', p: '#ddd6fe', s: '#4c1d95' }, { f: '#7f1d1d', t: '#ffffff', p: '#fecaca', s: '#7f1d1d' } ] },
    { id: 'rayas', cat: 'deporte', nombre: 'Rayas', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { f: '#ffffff', t: '#111111', p: '#111111', s: '#111111' }, { f: '#ffe500', t: '#111111', p: '#111111', s: '#111111' },
      { f: '#111111', t: '#ffffff', p: '#ffffff', s: '#ffffff' }, { f: '#e31b23', t: '#ffffff', p: '#111111', s: '#111111' } ] },
    { id: 'dividido', cat: 'negocio', nombre: 'Dividida', fuente: 'redonda', layout: 'vertical', vars: [
      { f: '#ffffff', t: '#0f3d3a', p: '#0f3d3a', s: '#7fd6c8' }, { f: '#ffffff', t: '#111111', p: '#111111', s: '#ff4fa3' },
      { f: '#ffffff', t: '#0b1f4d', p: '#0b1f4d', s: '#7cc4ff' }, { f: '#fff7cc', t: '#7f1d1d', p: '#7f1d1d', s: '#fb923c' } ] },
    { id: 'brillo', cat: 'negocio', nombre: 'Satinada', fuente: 'gruesa', layout: 'vertical', vars: [
      { deg: ['#22a447', '#0b5a2a'], t: '#ffffff', p: '#ffffff', s: '#ffffff' }, { deg: ['#3b82f6', '#1e3a8a'], t: '#ffffff', p: '#ffffff', s: '#ffffff' },
      { deg: ['#a855f7', '#4c1d95'], t: '#ffffff', p: '#ffffff', s: '#ffffff' }, { deg: ['#ef4444', '#7f1d1d'], t: '#ffffff', p: '#ffffff', s: '#ffffff' } ] },
    { id: 'oferta', cat: 'ofertas', nombre: 'Oferta', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { f: '#e31b23', t: '#ffffff', p: '#ffe500', s: '#ffffff' }, { f: '#ffe500', t: '#e31b23', p: '#e31b23', s: '#ffffff' },
      { f: '#111111', t: '#ffe500', p: '#e31b23', s: '#ffe500' }, { f: '#f97316', t: '#ffffff', p: '#fde047', s: '#ffffff' } ] },
    { id: 'cinta', cat: 'ofertas', nombre: 'Cinta', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { f: '#ffffff', t: '#e31b23', p: '#e31b23', s: '#111111' }, { f: '#111111', t: '#ffffff', p: '#ffe500', s: '#ffe500' },
      { f: '#1d4ed8', t: '#ffffff', p: '#ffffff', s: '#ffe500' }, { f: '#ffe500', t: '#111111', p: '#111111', s: '#e31b23' } ] },
    { id: 'rayos', cat: 'ofertas', nombre: 'Rayos', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { f: '#ffe500', t: '#e31b23', p: '#f97316', s: '#f97316' }, { f: '#e31b23', t: '#ffffff', p: '#ffffff', s: '#ffffff' },
      { f: '#1d4ed8', t: '#ffffff', p: '#60a5fa', s: '#60a5fa' }, { f: '#111111', t: '#ffe500', p: '#ffe500', s: '#ffe500' } ] },
    { id: 'confeti', cat: 'fiestas', nombre: 'Confeti', fuente: 'redonda', layout: 'logo-texto', vars: [
      { f: '#ffffff', t: '#111111', p: '#ec4899', s: '#22d3ee' }, { f: '#fde047', t: '#111111', p: '#ec4899', s: '#3b82f6' },
      { f: '#111111', t: '#ffffff', p: '#fde047', s: '#22d3ee' }, { f: '#7c3aed', t: '#ffffff', p: '#fde047', s: '#f9a8d4' } ] },
    { id: 'arcoiris', cat: 'fiestas', nombre: 'Arcos', fuente: 'redonda', layout: 'logo-texto', vars: [
      { f: '#ffffff', t: '#111111', p: '#f97316', s: '#22d3ee' }, { f: '#fde68a', t: '#7f1d1d', p: '#ef4444', s: '#f97316' },
      { f: '#dbeafe', t: '#1e3a8a', p: '#3b82f6', s: '#ec4899' }, { f: '#111111', t: '#ffffff', p: '#ec4899', s: '#22d3ee' } ] },
    { id: 'noche', cat: 'fiestas', nombre: 'Noche', fuente: 'clasica', layout: 'vertical', vars: [
      { deg: ['#0f172a', '#312e81'], t: '#ffffff', p: '#ffffff', s: '#fde047' }, { deg: ['#111111', '#4c1d95'], t: '#ffffff', p: '#ffffff', s: '#f9a8d4' },
      { deg: ['#022c22', '#064e3b'], t: '#ffffff', p: '#ffffff', s: '#fde047' }, { deg: ['#1e1b4b', '#be123c'], t: '#ffffff', p: '#ffffff', s: '#fde047' } ] },
    { id: 'pastel', cat: 'negocio', nombre: 'Pastel', fuente: 'redonda', layout: 'logo-texto', vars: [
      { f: '#fce7f3', t: '#831843', p: '#f9a8d4', s: '#fbcfe8' }, { f: '#dbeafe', t: '#1e3a8a', p: '#93c5fd', s: '#bfdbfe' },
      { f: '#dcfce7', t: '#14532d', p: '#86efac', s: '#bbf7d0' }, { f: '#fef3c7', t: '#78350f', p: '#fcd34d', s: '#fde68a' } ] },
    { id: 'triangulos', cat: 'negocio', nombre: 'Geométrica', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#0b1f4d', t: '#ffffff', p: '#3b82f6', s: '#ffe500' }, { f: '#111111', t: '#ffffff', p: '#e31b23', s: '#ffffff' },
      { f: '#14532d', t: '#ffffff', p: '#4ade80', s: '#fde047' }, { f: '#ffffff', t: '#111111', p: '#111111', s: '#f97316' } ] },
    { id: 'deportivo', cat: 'deporte', nombre: 'Deportiva', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#111111', t: '#ffffff', p: '#a3e635', s: '#ffffff' }, { f: '#1d4ed8', t: '#ffffff', p: '#ffffff', s: '#ffe500' },
      { f: '#e31b23', t: '#ffffff', p: '#111111', s: '#ffffff' }, { f: '#ffffff', t: '#111111', p: '#e31b23', s: '#111111' } ] },
    { id: 'tropical', cat: 'fiestas', nombre: 'Tropical', fuente: 'redonda', layout: 'logo-texto', vars: [
      { deg: ['#fde047', '#f97316'], t: '#14532d', p: '#16a34a', s: '#ec4899' }, { deg: ['#22d3ee', '#0ea5e9'], t: '#ffffff', p: '#fde047', s: '#f97316' },
      { deg: ['#34d399', '#047857'], t: '#ffffff', p: '#fde047', s: '#ec4899' }, { deg: ['#fb7185', '#f97316'], t: '#ffffff', p: '#fde047', s: '#16a34a' } ] },
    { id: 'playa', cat: 'playa', nombre: 'Playa', fuente: 'redonda', layout: 'logo-texto', vars: [
      { f: '#22d3ee', t: '#ffffff', p: '#0e7490', s: '#fde047' }, { f: '#fef3c7', t: '#0e7490', p: '#38bdf8', s: '#f97316' },
      { f: '#fb923c', t: '#ffffff', p: '#0ea5e9', s: '#fde047' }, { f: '#0ea5e9', t: '#ffffff', p: '#fde68a', s: '#ffffff' } ] },
    { id: 'verano', cat: 'playa', nombre: 'Atardecer playa', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { deg: ['#38bdf8', '#fde68a'], t: '#0c4a6e', p: '#f97316', s: '#fde047' }, { deg: ['#f97316', '#fde047'], t: '#7c2d12', p: '#0ea5e9', s: '#ffffff' },
      { deg: ['#ec4899', '#fb923c'], t: '#ffffff', p: '#fde047', s: '#fff7ed' }, { deg: ['#0ea5e9', '#e0f2fe'], t: '#0c4a6e', p: '#fde047', s: '#f97316' } ] },
    { id: 'toldo', cat: 'playa', nombre: 'Chiringuito', fuente: 'clasica', layout: 'logo-texto', vars: [
      { f: '#ffffff', t: '#7f1d1d', p: '#e31b23', s: '#ffffff' }, { f: '#ffffff', t: '#0b1f4d', p: '#1d4ed8', s: '#ffffff' },
      { f: '#fff7ed', t: '#7c2d12', p: '#f97316', s: '#ffffff' }, { f: '#ffffff', t: '#14532d', p: '#16a34a', s: '#ffffff' } ] },
    { id: 'expo', cat: 'ferias', nombre: 'Feria profesional', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#0b1f4d', t: '#ffffff', p: '#38bdf8', s: '#ffe500' }, { f: '#111111', t: '#ffffff', p: '#e31b23', s: '#ffffff' },
      { f: '#ffffff', t: '#0b1f4d', p: '#1d4ed8', s: '#38bdf8' }, { f: '#064e3b', t: '#ffffff', p: '#34d399', s: '#fde047' } ] },
    { id: 'banderines', cat: 'ferias', nombre: 'Feria popular', fuente: 'redonda', layout: 'logo-texto', vars: [
      { f: '#fff7ed', t: '#7c2d12', p: '#e31b23', s: '#fde047' }, { f: '#dbeafe', t: '#1e3a8a', p: '#3b82f6', s: '#f97316' },
      { f: '#fef9c3', t: '#14532d', p: '#16a34a', s: '#ec4899' }, { f: '#111111', t: '#ffffff', p: '#fde047', s: '#ec4899' } ] },
    { id: 'mercado', cat: 'ferias', nombre: 'Mercadillo', fuente: 'clasica', layout: 'logo-texto', vars: [
      { f: '#f5e6c8', t: '#3b2a14', p: '#b45309', s: '#15803d' }, { f: '#fef3c7', t: '#78350f', p: '#d97706', s: '#92400e' },
      { f: '#ecfccb', t: '#365314', p: '#65a30d', s: '#a16207' }, { f: '#ffe4e6', t: '#881337', p: '#e11d48', s: '#be185d' } ] },
    { id: 'coches', cat: 'coches', nombre: 'Meta', fuente: 'gruesa', layout: 'texto-grande', vars: [
      { f: '#111111', t: '#ffffff', p: '#ffffff', s: '#e31b23' }, { f: '#e31b23', t: '#ffffff', p: '#ffffff', s: '#111111' },
      { f: '#ffffff', t: '#111111', p: '#111111', s: '#e31b23' }, { f: '#ffe500', t: '#111111', p: '#111111', s: '#e31b23' } ] },
    { id: 'faros', cat: 'coches', nombre: 'Faros', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#0b1220', t: '#ffffff', p: '#fde047', s: '#ffffff' }, { f: '#111111', t: '#ffffff', p: '#e31b23', s: '#ffffff' },
      { f: '#0f172a', t: '#ffffff', p: '#38bdf8', s: '#ffffff' }, { f: '#1c1917', t: '#ffffff', p: '#f97316', s: '#fde047' } ] },
    { id: 'premium', cat: 'coches', nombre: 'Premium', fuente: 'clasica', layout: 'vertical', vars: [
      { deg: ['#1f2937', '#000000'], t: '#e5e7eb', p: '#9ca3af', s: '#e5e7eb' }, { deg: ['#1c1917', '#000000'], t: '#fde68a', p: '#d4a017', s: '#fde68a' },
      { deg: ['#7f1d1d', '#000000'], t: '#ffffff', p: '#fca5a5', s: '#ffffff' }, { deg: ['#1e3a8a', '#000000'], t: '#ffffff', p: '#93c5fd', s: '#ffffff' } ] },
    { id: 'montana', cat: 'naturaleza', nombre: 'Montaña', fuente: 'redonda', layout: 'logo-texto', vars: [
      { deg: ['#7dd3fc', '#fde68a'], t: '#0c4a6e', p: '#1e3a5f', s: '#fb923c' }, { deg: ['#c4b5fd', '#fda4af'], t: '#3b0764', p: '#4c1d95', s: '#fde047' },
      { deg: ['#99f6e4', '#fef08a'], t: '#134e4a', p: '#115e59', s: '#fb7185' }, { deg: ['#fdba74', '#fef3c7'], t: '#7c2d12', p: '#7f1d1d', s: '#ffffff' } ] },
    { id: 'campo', cat: 'naturaleza', nombre: 'Campo', fuente: 'clasica', layout: 'logo-texto', vars: [
      { deg: ['#bae6fd', '#ecfccb'], t: '#14532d', p: '#4d7c0f', s: '#facc15' }, { deg: ['#fde68a', '#fed7aa'], t: '#78350f', p: '#a16207', s: '#ef4444' },
      { deg: ['#a7f3d0', '#fef9c3'], t: '#064e3b', p: '#047857', s: '#fb923c' }, { deg: ['#fecaca', '#fef3c7'], t: '#7f1d1d', p: '#65a30d', s: '#dc2626' } ] },
    { id: 'ciudad', cat: 'ciudad', nombre: 'Ciudad de noche', fuente: 'gruesa', layout: 'vertical', vars: [
      { deg: ['#0f172a', '#4338ca'], t: '#ffffff', p: '#0b1020', s: '#fde047' }, { deg: ['#1e1b4b', '#be185d'], t: '#ffffff', p: '#0f0a24', s: '#fef08a' },
      { deg: ['#022c22', '#0e7490'], t: '#ffffff', p: '#031a17', s: '#a7f3d0' }, { deg: ['#111827', '#ea580c'], t: '#ffffff', p: '#0a0f1a', s: '#fed7aa' } ] },
    { id: 'casas', cat: 'ciudad', nombre: 'Inmobiliaria', fuente: 'redonda', layout: 'logo-texto', vars: [
      { deg: ['#7dd3fc', '#f0f9ff'], t: '#0c4a6e', p: '#1d4ed8', s: '#fde047' }, { deg: ['#fde68a', '#fff7ed'], t: '#7c2d12', p: '#c2410c', s: '#38bdf8' },
      { deg: ['#a7f3d0', '#f0fdf4'], t: '#064e3b', p: '#047857', s: '#fde047' }, { deg: ['#c7d2fe', '#faf5ff'], t: '#312e81', p: '#4f46e5', s: '#fda4af' } ] },
    { id: 'navidad', cat: 'navidad', nombre: 'Navidad', fuente: 'clasica', layout: 'vertical', vars: [
      { deg: ['#b91c1c', '#7f1d1d'], t: '#ffffff', p: '#14532d', s: '#fde047' }, { deg: ['#14532d', '#052e16'], t: '#ffffff', p: '#0f3d22', s: '#fde047' },
      { deg: ['#1e3a8a', '#172554'], t: '#ffffff', p: '#e2e8f0', s: '#fde047' }, { deg: ['#f8fafc', '#cbd5e1'], t: '#7f1d1d', p: '#14532d', s: '#dc2626' } ] },
    { id: 'halloween', cat: 'navidad', nombre: 'Halloween', fuente: 'gruesa', layout: 'vertical', vars: [
      { deg: ['#2e1065', '#f97316'], t: '#ffffff', p: '#0f0720', s: '#fde047' }, { deg: ['#111111', '#7c2d12'], t: '#fb923c', p: '#050505', s: '#fb923c' },
      { deg: ['#1e1b4b', '#16a34a'], t: '#bef264', p: '#0a0a1a', s: '#d9f99d' }, { deg: ['#3b0764', '#db2777'], t: '#ffffff', p: '#1a0330', s: '#fde047' } ] },
    { id: 'barberia', cat: 'bares', nombre: 'Barbería', fuente: 'clasica', layout: 'logo-texto', vars: [
      { f: '#fffbeb', t: '#1e3a8a', p: '#dc2626', s: '#1d4ed8' }, { f: '#111111', t: '#fefce8', p: '#dc2626', s: '#f5f5f4' },
      { f: '#f5f5f4', t: '#7f1d1d', p: '#b91c1c', s: '#0f172a' }, { f: '#fef3c7', t: '#1c1917', p: '#b45309', s: '#78350f' } ] },
    { id: 'cafe', cat: 'bares', nombre: 'Café', fuente: 'redonda', layout: 'logo-texto', vars: [
      { deg: ['#78350f', '#2a140a'], t: '#fef3c7', p: '#fde68a', s: '#d97706' }, { deg: ['#fef3c7', '#d6b88a'], t: '#451a03', p: '#92400e', s: '#78350f' },
      { deg: ['#292524', '#0c0a09'], t: '#fcd34d', p: '#a8a29e', s: '#fcd34d' }, { deg: ['#fecaca', '#fda4af'], t: '#4c0519', p: '#9f1239', s: '#ffffff' } ] },
    { id: 'gimnasio', cat: 'deporte', nombre: 'Gimnasio', fuente: 'gruesa', layout: 'vertical', vars: [
      { deg: ['#171717', '#7f1d1d'], t: '#ffffff', p: '#ef4444', s: '#ffffff' }, { deg: ['#0f172a', '#0e7490'], t: '#ffffff', p: '#22d3ee', s: '#ffffff' },
      { deg: ['#18181b', '#4d7c0f'], t: '#ffffff', p: '#a3e635', s: '#ffffff' }, { deg: ['#1c1917', '#c2410c'], t: '#ffffff', p: '#fb923c', s: '#fef3c7' } ] },
    { id: 'cometa', cat: 'integral', solo: 'vela', nombre: 'Cometa', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#e31b23', t: '#ffffff', p: '#ffdd00', s: '#ffffff' }, { f: '#111111', t: '#ffffff', p: '#a3e635', s: '#ffffff' },
      { f: '#1d4ed8', t: '#ffffff', p: '#38bdf8', s: '#ffe500' }, { f: '#ffffff', t: '#111111', p: '#e31b23', s: '#111111' } ] },
    { id: 'diana', cat: 'integral', solo: 'vela', nombre: 'Diana', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#0b1f4d', t: '#ffffff', p: '#38bdf8', s: '#ffe500' }, { f: '#111111', t: '#ffffff', p: '#e31b23', s: '#ffffff' },
      { f: '#14532d', t: '#ffffff', p: '#4ade80', s: '#fde047' }, { f: '#7c2d12', t: '#ffffff', p: '#fb923c', s: '#fde68a' } ] },
    { id: 'chevrones', cat: 'integral', solo: 'vela', nombre: 'Chevrones', fuente: 'deportiva', layout: 'vertical', vars: [
      { f: '#111111', t: '#ffffff', p: '#a3e635', s: '#ffffff' }, { f: '#0b1f4d', t: '#ffffff', p: '#38bdf8', s: '#ffe500' },
      { f: '#e31b23', t: '#ffffff', p: '#111111', s: '#ffffff' }, { f: '#ffffff', t: '#111111', p: '#1d4ed8', s: '#e31b23' } ] },
    { id: 'oleaje', cat: 'integral', solo: 'vela', nombre: 'Oleaje', fuente: 'redonda', layout: 'vertical', vars: [
      { deg: ['#e0f2fe', '#7dd3fc'], t: '#0c4a6e', p: '#0ea5e9', s: '#0369a1' }, { deg: ['#fef3c7', '#fdba74'], t: '#7c2d12', p: '#f97316', s: '#dc2626' },
      { deg: ['#dcfce7', '#86efac'], t: '#14532d', p: '#16a34a', s: '#15803d' }, { deg: ['#fce7f3', '#f9a8d4'], t: '#831843', p: '#ec4899', s: '#be185d' } ] },
    { id: 'solnaciente', cat: 'integral', solo: 'vela', nombre: 'Sol naciente', fuente: 'clasica', layout: 'vertical', vars: [
      { deg: ['#f97316', '#fde047'], t: '#7c2d12', p: '#ffffff', s: '#ef4444' }, { deg: ['#0f172a', '#1d4ed8'], t: '#ffffff', p: '#fde047', s: '#f97316' },
      { deg: ['#be123c', '#fb923c'], t: '#ffffff', p: '#fde047', s: '#ffffff' }, { deg: ['#0f766e', '#99f6e4'], t: '#ffffff', p: '#fde047', s: '#ffffff' } ] },
    { id: 'llamas', cat: 'integral', solo: 'vela', nombre: 'Llamas', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#111111', t: '#ffffff', p: '#f97316', s: '#fde047' }, { f: '#0b1f4d', t: '#ffffff', p: '#22d3ee', s: '#a3e635' },
      { f: '#1c1917', t: '#ffffff', p: '#e31b23', s: '#f97316' }, { f: '#052e16', t: '#ffffff', p: '#a3e635', s: '#22d3ee' } ] },
    { id: 'facetas', cat: 'integral', solo: 'vela', nombre: 'Facetas', fuente: 'gruesa', layout: 'vertical', vars: [
      { f: '#1d4ed8', t: '#ffffff', p: '#93c5fd', s: '#ffffff' }, { f: '#111111', t: '#ffffff', p: '#a3e635', s: '#ffffff' },
      { f: '#0f766e', t: '#ffffff', p: '#5eead4', s: '#ffffff' }, { f: '#7c3aed', t: '#ffffff', p: '#c4b5fd', s: '#ffffff' } ] },
    { id: 'franjas', cat: 'integral', solo: 'vela', nombre: 'Franjas', fuente: 'gruesa', layout: 'cabeza', vars: [
      { f: '#111827', t: '#ffffff', p: '#ff9f1c', s: '#2563eb' }, { f: '#111111', t: '#ffffff', p: '#a3e635', s: '#e31b23' },
      { f: '#0b1f4d', t: '#ffffff', p: '#fde047', s: '#e31b23' }, { f: '#ffffff', t: '#111111', p: '#e31b23', s: '#1d4ed8' } ] },
    { id: 'cristal', cat: 'integral', solo: 'vela', nombre: 'Cristal', fuente: 'gruesa', layout: 'cabeza', vars: [
      { f: '#1f2937', t: '#ffffff', p: '#ec4899', s: '#7c3aed' }, { f: '#111111', t: '#ffffff', p: '#f97316', s: '#e31b23' },
      { f: '#0b1f4d', t: '#ffffff', p: '#22d3ee', s: '#2563eb' }, { f: '#064e3b', t: '#ffffff', p: '#a3e635', s: '#16a34a' } ] },
    { id: 'dientes', cat: 'integral', solo: 'vela', nombre: 'Dientes', fuente: 'redonda', layout: 'cabeza', vars: [
      { f: '#ffffff', t: '#111111', p: '#f59e0b', s: '#111111' }, { f: '#fff7ed', t: '#7f1d1d', p: '#e31b23', s: '#111111' },
      { f: '#ecfeff', t: '#0c4a6e', p: '#0ea5e9', s: '#0c4a6e' }, { f: '#111111', t: '#ffffff', p: '#a3e635', s: '#ffffff' } ] },
    { id: 'citricos', cat: 'integral', solo: 'vela', nombre: 'Cítricos', fuente: 'redonda', layout: 'cabeza', vars: [
      { f: '#06b6d4', t: '#ffffff', p: '#fb923c', s: '#fde047' }, { f: '#ec4899', t: '#ffffff', p: '#ffffff', s: '#fde047' },
      { f: '#84cc16', t: '#ffffff', p: '#fde047', s: '#ffffff' }, { f: '#1d4ed8', t: '#ffffff', p: '#fb923c', s: '#ffffff' } ] }
  ];

  /* ADORNOS de cada estilo. Coordenadas relativas a la bandera (x: 0-1 del ancho, y: 0-1 del alto). Tipos:
       franja {y0,y1}              banda de lado a lado
       poly   {p:[[x,y]...]}       polígono (franjas en diagonal, etc.)
       circ   {x,y,r}              círculo (r relativo al ancho)
       ola    {y,amp,ciclos}       ola que rellena hacia abajo
       linea  {y,amp,ciclos,g}     línea fina ondulada (g = grosor)
     c = color (P y S son los de la combinación elegida), a = opacidad. Viajan al pedido ya resueltos en cm. */
  function rayasDiag(n, y0, y1, c) {
    var o = [], paso = (y1 - y0) / n;
    for (var q = 0; q < n; q++) {
      var a = y0 + q * paso;
      o.push({ k: 'poly', p: [[-0.1, a + 0.10], [1.1, a - 0.06], [1.1, a - 0.06 + paso * 0.45], [-0.1, a + 0.10 + paso * 0.45]], c: c, a: 1 });
    }
    return o;
  }
  function lineasOnda(n, y0, y1, c, a) {
    var o = [];
    for (var q = 0; q < n; q++) o.push({ k: 'linea', y: y0 + (y1 - y0) * q / (n - 1), amp: 0.025, ciclos: 1.5, g: 0.004, c: c, a: a });
    return o;
  }
  function rayasV(n, y0, c, a) {
    var o = [], w = 1 / n;
    for (var q = 0; q < n; q += 2) o.push({ k: 'poly', p: [[q * w, y0], [(q + 1) * w, y0], [(q + 1) * w, 1.1], [q * w, 1.1]], c: c, a: a || 1 });
    return o;
  }
  function rayosSol(n, cx, cy, c, a) {
    var o = [], pasoA = Math.PI / n;
    for (var q = 0; q < n; q++) {
      var a0 = Math.PI + q * pasoA * 1.0 + pasoA * 0.1, a1 = a0 + pasoA * 0.55, R = 3;
      o.push({ k: 'poly', p: [[cx, cy], [cx + R * Math.cos(a0), cy + R * Math.sin(a0)], [cx + R * Math.cos(a1), cy + R * Math.sin(a1)]], c: c, a: a });
    }
    return o;
  }
  function confeti(n) {
    var o = [];
    for (var i = 0; i < n; i++) {
      var f1 = fr(Math.sin(i * 12.9898) * 43758.5453), f2 = fr(Math.sin(i * 78.233 + 1.7) * 43758.5453), f3 = fr(Math.sin(i * 39.346 + 5.1) * 43758.5453);
      o.push({ k: 'circ', x: 0.04 + f1 * 0.92, y: 0.04 + f2 * 0.92, r: 0.04 + f3 * 0.07, c: i % 2 ? 'P' : 'S', a: 0.9 });
    }
    return o;
  }
  function estrellas(n) {
    var o = [];
    for (var i = 0; i < n; i++) {
      var f1 = fr(Math.sin(i * 12.9898) * 43758.5453), f2 = fr(Math.sin(i * 78.233 + 1.7) * 43758.5453), f3 = fr(Math.sin(i * 39.346 + 5.1) * 43758.5453);
      o.push({ k: 'circ', x: 0.04 + f1 * 0.92, y: 0.03 + f2 * 0.8, r: 0.006 + f3 * 0.014, c: 'P', a: 0.55 + f3 * 0.4 });
    }
    return o;
  }
  // en las pancartas (apaisadas) algunos adornos cambian de sitio para no cruzar el texto
  var DECO_P = {
    cinta: [ { k: 'franja', y0: 0, y1: 0.075, c: 'S', a: 1 }, { k: 'franja', y0: 0.925, y1: 1, c: 'S', a: 1 }, { k: 'franja', y0: 0.86, y1: 0.885, c: 'P', a: 1 } ]
  };
  var DECO = {
    negro: [ { k: 'poly', p: [[-0.1, 0.84], [1.1, 0.70], [1.1, 0.76], [-0.1, 0.90]], c: 'P', a: 1 },
             { k: 'poly', p: [[-0.1, 0.92], [1.1, 0.78], [1.1, 0.82], [-0.1, 0.96]], c: 'S', a: 1 } ],
    sol: [ { k: 'ola', y: 0.84, amp: 0.018, ciclos: 2, c: 'P', a: 1 }, { k: 'ola', y: 0.91, amp: 0.014, ciclos: 3, c: 'S', a: 1 } ],
    azul: [ { k: 'ola', y: 0.76, amp: 0.025, ciclos: 2.5, c: 'P', a: 0.55 }, { k: 'ola', y: 0.85, amp: 0.02, ciclos: 3, c: 'S', a: 0.35 } ],
    rojo: [ { k: 'poly', p: [[-0.1, 0.80], [1.1, 0.64], [1.1, 0.70], [-0.1, 0.86]], c: 'P', a: 0.92 },
            { k: 'poly', p: [[-0.1, 0.89], [1.1, 0.73], [1.1, 0.75], [-0.1, 0.91]], c: 'P', a: 0.6 } ],
    verde: [ { k: 'circ', x: 0.95, y: 0.07, r: 0.42, c: 'P', a: 0.45 }, { k: 'ola', y: 0.80, amp: 0.025, ciclos: 2, c: 'S', a: 0.85 } ],
    clasico: [ { k: 'franja', y0: 0, y1: 0.035, c: 'P', a: 1 }, { k: 'franja', y0: 0.043, y1: 0.052, c: 'S', a: 1 },
               { k: 'franja', y0: 0.948, y1: 0.957, c: 'S', a: 1 }, { k: 'franja', y0: 0.965, y1: 1, c: 'P', a: 1 } ],
    atardecer: [ { k: 'circ', x: 0.5, y: 0.93, r: 0.5, c: 'P', a: 0.35 }, { k: 'ola', y: 0.88, amp: 0.02, ciclos: 2, c: 'S', a: 0.45 } ],
    oceano: [ { k: 'ola', y: 0.70, amp: 0.03, ciclos: 2, c: 'P', a: 0.18 }, { k: 'ola', y: 0.80, amp: 0.025, ciclos: 3, c: 'P', a: 0.25 },
              { k: 'ola', y: 0.90, amp: 0.02, ciclos: 2.5, c: 'S', a: 0.4 } ],
    neon: [ { k: 'poly', p: [[-0.1, 0.20], [1.1, 0.05], [1.1, 0.12], [-0.1, 0.27]], c: 'P', a: 0.2 },
            { k: 'poly', p: [[-0.1, 0.58], [1.1, 0.43], [1.1, 0.46], [-0.1, 0.61]], c: 'P', a: 0.14 },
            { k: 'circ', x: 0.05, y: 0.78, r: 0.32, c: 'S', a: 0.25 } ],
    bosque: [ { k: 'circ', x: 0.1, y: 0.1, r: 0.28, c: 'P', a: 0.35 }, { k: 'monte', y: 0.86, h: 0.5, n: 3, seed: 2, c: 'S', a: 0.35 }, { k: 'pino', x: 0.18, y: 0.97, s: 0.7, c: 'S', a: 0.8 }, { k: 'pino', x: 0.62, y: 1.0, s: 0.6, c: 'S', a: 0.7 }, { k: 'ola', y: 0.94, amp: 0.02, ciclos: 2, c: 'S', a: 0.6 } ],
    dorado: [ { k: 'franja', y0: 0.04, y1: 0.046, c: 'P', a: 1 }, { k: 'franja', y0: 0.055, y1: 0.058, c: 'P', a: 1 },
              { k: 'franja', y0: 0.942, y1: 0.945, c: 'P', a: 1 }, { k: 'franja', y0: 0.954, y1: 0.96, c: 'P', a: 1 } ],
    marino: [ { k: 'franja', y0: 0.78, y1: 0.805, c: 'P', a: 0.95 }, { k: 'franja', y0: 0.835, y1: 0.86, c: 'P', a: 0.95 },
              { k: 'franja', y0: 0.89, y1: 0.915, c: 'S', a: 1 } ],
    bicolor: [ { k: 'poly', p: [[-0.1, 0.72], [1.1, 0.50], [1.1, 1.1], [-0.1, 1.1]], c: 'S', a: 1 },
               { k: 'poly', p: [[-0.1, 0.72], [1.1, 0.50], [1.1, 0.52], [-0.1, 0.74]], c: 'P', a: 0.9 } ],
    lineas: lineasOnda(7, 0.74, 0.96, 'P', 0.55),
    rayas: rayasDiag(7, 0.72, 0.98, 'P'),
    dividido: [ { k: 'poly', p: [[-0.1, 0.44], [1.1, 0.36], [1.1, 1.1], [-0.1, 1.1]], c: 'S', a: 1 } ],
    brillo: [ { k: 'poly', p: [[0.05, -0.1], [0.40, -0.1], [-0.05, 1.1], [-0.4, 1.1]], c: 'P', a: 0.07 },
              { k: 'poly', p: [[0.50, -0.1], [0.62, -0.1], [0.17, 1.1], [0.05, 1.1]], c: 'P', a: 0.05 },
              { k: 'poly', p: [[0.95, -0.1], [1.30, -0.1], [0.85, 1.1], [0.50, 1.1]], c: 'P', a: 0.06 } ],
    oferta: [ { k: 'circ', x: 0.88, y: 0.12, r: 0.55, c: 'P', a: 1 }, { k: 'circ', x: 0.88, y: 0.12, r: 0.40, c: 'S', a: 0.25 },
              { k: 'poly', p: [[-0.1, 0.86], [1.1, 0.74], [1.1, 0.80], [-0.1, 0.92]], c: 'P', a: 1 } ],
    cinta: [ { k: 'poly', p: [[-0.1, 0.30], [1.1, 0.22], [1.1, 0.30], [-0.1, 0.38]], c: 'S', a: 1 },
             { k: 'poly', p: [[-0.1, 0.80], [1.1, 0.72], [1.1, 0.78], [-0.1, 0.86]], c: 'S', a: 1 },
             { k: 'franja', y0: 0.96, y1: 1, c: 'P', a: 1 } ],
    rayos: rayosSol(18, 0.5, 1.02, 'P', 0.28),
    confeti: confeti(26),
    arcoiris: [ { k: 'circ', x: 0.5, y: 1.0, r: 0.95, c: 'P', a: 0.9 }, { k: 'circ', x: 0.5, y: 1.0, r: 0.75, c: 'S', a: 0.9 },
                { k: 'circ', x: 0.5, y: 1.0, r: 0.55, c: 'P', a: 0.55 }, { k: 'circ', x: 0.5, y: 1.0, r: 0.36, c: 'S', a: 0.55 } ],
    noche: estrellas(26).concat([ { k: 'circ', x: 0.8, y: 0.84, r: 0.2, c: 'S', a: 0.95 }, { k: 'ciudad', y: 1.0, h: 0.8, n: 6, c: 'P', a: 0.55 } ]),
    pastel: [ { k: 'circ', x: 0.0, y: 1.0, r: 0.75, c: 'P', a: 0.8 }, { k: 'circ', x: 1.0, y: 0.0, r: 0.45, c: 'S', a: 0.9 },
              { k: 'circ', x: 0.85, y: 0.9, r: 0.22, c: 'S', a: 0.9 } ],
    triangulos: [ { k: 'poly', p: [[-0.1, 1.1], [0.55, 0.62], [1.1, 1.1]], c: 'P', a: 0.85 },
                  { k: 'poly', p: [[-0.1, 1.1], [-0.1, 0.78], [0.62, 1.1]], c: 'S', a: 0.95 },
                  { k: 'poly', p: [[0.4, 1.1], [1.1, 0.74], [1.1, 1.1]], c: 'S', a: 0.5 } ],
    deportivo: [ { k: 'poly', p: [[-0.1, 0.60], [0.35, 0.60], [-0.1, 1.1]], c: 'P', a: 1 },
                 { k: 'poly', p: [[0.38, 0.60], [0.62, 0.60], [0.0, 1.1], [-0.1, 1.1]], c: 'S', a: 1 },
                 { k: 'poly', p: [[1.1, 0.30], [1.1, 1.1], [0.55, 1.1]], c: 'P', a: 0.9 } ],
    tropical: [ { k: 'circ', x: 0.0, y: 0.80, r: 0.50, c: 'P', a: 0.9 }, { k: 'circ', x: 1.0, y: 0.92, r: 0.42, c: 'P', a: 0.8 },
                { k: 'circ', x: 0.75, y: 0.84, r: 0.20, c: 'S', a: 0.95 }, { k: 'palmera', x: 0.15, y: 1.0, s: 0.9, c: 'P', a: 1 }, { k: 'palmera', x: 0.7, y: 1.0, s: 0.75, flip: 1, c: 'P', a: 0.95 }, { k: 'ola', y: 0.96, amp: 0.02, ciclos: 2, c: 'P', a: 1 } ],
    playa: [ { k: 'circ', x: 0.90, y: 0.05, r: 0.34, c: 'S', a: 0.95 }, { k: 'nube', x: 0.25, y: 0.56, s: 0.08, c: 'S', a: 0.35 },
             { k: 'ola', y: 0.60, amp: 0.02, ciclos: 2, c: 'P', a: 0.45 }, { k: 'ola', y: 0.70, amp: 0.018, ciclos: 2.5, c: 'P', a: 0.7 },
             { k: 'ola', y: 0.80, amp: 0.016, ciclos: 3, c: 'P', a: 0.9 }, { k: 'ola', y: 0.90, amp: 0.014, ciclos: 2, c: 'S', a: 0.95 }, { k: 'palmera', x: 0.12, y: 0.99, s: 0.9, c: 'P', a: 1 }, { k: 'palmera', x: 0.62, y: 1.0, s: 0.7, flip: 1, c: 'P', a: 0.9 } ],
    verano: [ { k: 'circ', x: 0.5, y: 1.02, r: 0.62, c: 'P', a: 0.95 }, { k: 'palmera', x: 0.18, y: 1.0, s: 0.9, c: 'S', a: 0.85 } ].concat(rayosSol(14, 0.5, 1.02, 'S', 0.22)).concat([ { k: 'ola', y: 0.94, amp: 0.012, ciclos: 3, c: 'S', a: 0.5 } ]),
    toldo: rayasV(8, -0.1, 'P', 0.18).concat([ { k: 'franja', y0: 0.66, y1: 0.685, c: 'P', a: 1 } ]).concat(rayasV(8, 0.685, 'P')),
    expo: [ { k: 'poly', p: [[0.35, -0.1], [1.1, -0.1], [1.1, 0.40]], c: 'P', a: 0.9 },
            { k: 'poly', p: [[-0.1, 0.74], [-0.1, 1.1], [0.75, 1.1]], c: 'S', a: 1 },
            { k: 'poly', p: [[-0.1, 0.70], [-0.1, 0.72], [0.85, 1.1], [0.85, 1.1]], c: 'P', a: 0.9 } ],
    banderines: [ { k: 'banderines', y: 0.58, n: 5, sag: 0.03 }, { k: 'banderines', y: 0.72, n: 5, sag: 0.03, off: 1 }, { k: 'banderines', y: 0.86, n: 5, sag: 0.03 } ],
    mercado: [ { k: 'franja', y0: 0, y1: 0.03, c: 'P', a: 1 }, { k: 'franja', y0: 0.04, y1: 0.046, c: 'S', a: 1 }, { k: 'franja', y0: 0.954, y1: 0.96, c: 'S', a: 1 }, { k: 'franja', y0: 0.97, y1: 1, c: 'P', a: 1 }, { k: 'circ', x: 0.5, y: 0.5, r: 0.5, c: 'P', a: 0.07 } ],
    coches: [ { k: 'tablero', y0: 0, rows: 2, n: 10, c: 'P', a: 1 }, { k: 'franja', y0: 0.062, y1: 0.075, c: 'S', a: 1 }, { k: 'franja', y0: 0.94, y1: 0.955, c: 'S', a: 1 }, { k: 'tablero', y0: 0.965, rows: 1, n: 10, c: 'P', a: 1 } ],
    faros: [ { k: 'circ', x: 0.5, y: 0.80, r: 1.0, c: 'P', a: 0.12 }, { k: 'circ', x: 0.5, y: 0.80, r: 0.72, c: 'P', a: 0.2 },
             { k: 'circ', x: 0.5, y: 0.80, r: 0.45, c: 'P', a: 0.4 }, { k: 'circ', x: 0.5, y: 0.80, r: 0.2, c: 'S', a: 0.9 } ],
    premium: [ { k: 'franja', y0: 0.03, y1: 0.036, c: 'P', a: 1 }, { k: 'franja', y0: 0.045, y1: 0.048, c: 'P', a: 0.7 },
               { k: 'poly', p: [[-0.1, 0.90], [1.1, 0.74], [1.1, 0.745], [-0.1, 0.905]], c: 'P', a: 1 },
               { k: 'poly', p: [[-0.1, 0.94], [1.1, 0.78], [1.1, 0.782], [-0.1, 0.942]], c: 'P', a: 0.6 },
               { k: 'franja', y0: 0.964, y1: 0.97, c: 'P', a: 1 } ],
    montana: [ { k: 'circ', x: 0.72, y: 0.60, r: 0.26, c: 'S', a: 0.92 }, { k: 'nube', x: 0.28, y: 0.50, s: 0.10, c: 'S', a: 0.5 },
               { k: 'monte', y: 0.84, h: 0.8, n: 2.2, seed: 1, c: 'P', a: 0.30 }, { k: 'monte', y: 0.92, h: 0.7, n: 3.1, seed: 4, c: 'P', a: 0.55 },
               { k: 'monte', y: 1.02, h: 0.55, n: 4.3, seed: 7, c: 'P', a: 0.95 } ],
    campo: [ { k: 'circ', x: 0.2, y: 0.52, r: 0.2, c: 'S', a: 0.95 },
             { k: 'ola', y: 0.66, amp: 0.03, ciclos: 1, c: 'P', a: 0.45 }, { k: 'ola', y: 0.76, amp: 0.035, ciclos: 1.5, c: 'P', a: 0.7 },
             { k: 'casa', x: 0.52, y: 0.80, s: 0.2, c: 'S', a: 1, win: 'P' }, { k: 'ola', y: 0.86, amp: 0.03, ciclos: 2, c: 'P', a: 1 } ],
    ciudad: estrellas(22).concat([ { k: 'circ', x: 0.8, y: 0.34, r: 0.17, c: 'S', a: 0.95 },
            { k: 'ciudad', y: 0.80, h: 0.9, n: 7, c: 'P', a: 0.45 }, { k: 'ciudad', y: 1.0, h: 1.1, n: 6, c: 'P', a: 1, win: 'S' } ]),
    casas: [ { k: 'circ', x: 0.86, y: 0.10, r: 0.22, c: 'S', a: 0.9 }, { k: 'nube', x: 0.2, y: 0.40, s: 0.08, c: 'P', a: 0.12 },
             { k: 'casa', x: 0.06, y: 0.80, s: 0.34, c: 'P', a: 0.9, win: 'S' }, { k: 'casa', x: 0.50, y: 0.86, s: 0.28, c: 'P', a: 0.6, win: 'S' },
             { k: 'ola', y: 0.93, amp: 0.012, ciclos: 2, c: 'P', a: 0.8 } ],
    navidad: estrellas(30).concat([ { k: 'pino', x: 0.14, y: 0.88, s: 0.8, c: 'P', a: 1 }, { k: 'pino', x: 0.55, y: 0.95, s: 0.65, c: 'P', a: 0.85 },
             { k: 'pino', x: 0.9, y: 0.86, s: 0.7, c: 'P', a: 1 }, { k: 'ola', y: 0.93, amp: 0.012, ciclos: 3, c: 'S', a: 0.9 } ]),
    halloween: [ { k: 'circ', x: 0.7, y: 0.30, r: 0.3, c: 'S', a: 0.95 }, { k: 'monte', y: 0.88, h: 0.6, n: 2.6, seed: 3, c: 'P', a: 0.7 },
                 { k: 'casa', x: 0.18, y: 0.92, s: 0.4, c: 'P', a: 1 }, { k: 'pino', x: 0.78, y: 0.97, s: 0.5, c: 'P', a: 1 } ],
    barberia: rayasDiag(10, 0.0, 0.07, 'P').concat(rayasDiag(10, 0.93, 1.0, 'S')),
    cafe: [ { k: 'circ', x: 0.15, y: 0.70, r: 0.18, c: 'P', a: 0.18 }, { k: 'circ', x: 0.88, y: 0.55, r: 0.14, c: 'P', a: 0.14 },
            { k: 'ola', y: 0.84, amp: 0.02, ciclos: 2, c: 'S', a: 0.9 }, { k: 'ola', y: 0.92, amp: 0.016, ciclos: 3, c: 'P', a: 0.35 } ],
    gimnasio: [ { k: 'poly', p: [[-0.1, 0.55], [0.45, 0.30], [0.60, 0.30], [-0.1, 0.65]], c: 'P', a: 0.85 },
                { k: 'poly', p: [[0.50, 1.1], [1.1, 0.62], [1.1, 0.72], [0.62, 1.1]], c: 'P', a: 0.85 },
                { k: 'poly', p: [[0.20, 1.1], [1.1, 0.50], [1.1, 0.53], [0.25, 1.1]], c: 'S', a: 0.55 } ]
  };

  /* DEGRADADOS del fondo. c = colores (2 o 3), t = tipo: v vertical, d diagonal, r radial (luz arriba). */
  var DEGRADADOS = [
    { c: ['#fbbf24', '#e31b23'], t: 'v' }, { c: ['#22d3ee', '#1e3a8a'], t: 'v' }, { c: ['#ec4899', '#4c1d95'], t: 'v' }, { c: ['#a3e635', '#14532d'], t: 'v' },
    { c: ['#f5f5f5', '#6b7280'], t: 'v' }, { c: ['#facc15', '#f97316'], t: 'v' }, { c: ['#60a5fa', '#7c3aed'], t: 'v' }, { c: ['#e31b23', '#450a0a'], t: 'v' },
    { c: ['#fde047', '#f97316', '#be123c'], t: 'v' }, { c: ['#22d3ee', '#3b82f6', '#7c3aed'], t: 'v' },
    { c: ['#34d399', '#0ea5e9', '#1e3a8a'], t: 'v' }, { c: ['#f9a8d4', '#c084fc', '#6366f1'], t: 'v' },
    { c: ['#f97316', '#ec4899'], t: 'd' }, { c: ['#06b6d4', '#6366f1'], t: 'd' }, { c: ['#fde047', '#22c55e'], t: 'd' }, { c: ['#1e1b4b', '#a21caf'], t: 'd' },
    { c: ['#fde68a', '#f97316'], t: 'r' }, { c: ['#60a5fa', '#1e3a8a'], t: 'r' }, { c: ['#ffffff', '#9ca3af'], t: 'r' }, { c: ['#fca5a5', '#7f1d1d'], t: 'r' }
  ];
  // el degradado se rellena igual en la web y en el archivo final (montaje_bandera.py): mismas fórmulas
  function dirDeg(w, h, tipo) { return tipo === 'd' ? [w, h * 0.4] : [0, 1]; }
  function rellenarDeg(ctx, w, h, cols, tipo) {
    ctx.save();
    var g, n = cols.length;
    if (tipo === 'r') {
      var rx = w, ry = h * 0.75;
      ctx.translate(w / 2, h * 0.3); ctx.scale(1, ry / rx);
      g = ctx.createRadialGradient(0, 0, 0, 0, 0, rx);
      cols.forEach(function (c, i) { g.addColorStop(i / (n - 1), c); });
      ctx.fillStyle = g; ctx.fillRect(-w, -(h * 0.3 + 10) * rx / ry, w * 2, (h + 20) * rx / ry);
    } else {
      var d = dirDeg(w, h, tipo), hi = d[0] * w + d[1] * h, m = d[0] * d[0] + d[1] * d[1];
      g = ctx.createLinearGradient(0, 0, d[0] * hi / m, d[1] * hi / m);
      cols.forEach(function (c, i) { g.addColorStop(i / (n - 1), c); });
      ctx.fillStyle = g; ctx.fillRect(-10, -10, w + 20, h + 20);
    }
    ctx.restore();
  }
  function cssDeg(par) {
    var l = par.c.join(',');
    return par.t === 'r' ? 'radial-gradient(ellipse at 50% 30%,' + l + ')' : 'linear-gradient(' + (par.t === 'd' ? '115deg' : 'to bottom') + ',' + l + ')';
  }

  /* Todas las plantillas llevan degradado y una textura propia de su tema (nada plano). Si el estilo no trae degradado,
     se saca del color de fondo: más claro arriba y más oscuro abajo (o con luz en el centro). */
  /* DISEÑO INTEGRAL: adornos pensados para la silueta de la bandera (cabeza redonda, cola que se estrecha). */
  function ondaDiag(y0, drop, amp, ciclos, ph, c, a) {
    var p = [], i, x;
    for (i = 0; i <= 40; i++) { x = -0.1 + 1.2 * i / 40; p.push([x, y0 - drop * x + amp * Math.sin(6.2832 * ciclos * x + ph)]); }
    p.push([1.1, 1.1]); p.push([-0.1, 1.1]);
    return { k: 'poly', p: p, c: c, a: a };
  }
  function chevron(y, h, g, c, a) { return { k: 'poly', p: [[-0.1, y], [0.5, y + h], [1.1, y], [1.1, y + g], [0.5, y + h + g], [-0.1, y + g]], c: c, a: a }; }
  function llama(x0, w, h, lean, c, a) {
    var izq = [], der = [], t, i, sw;
    for (i = 0; i <= 14; i++) {
      t = i / 14; sw = 0.03 * Math.sin(t * 6.2832 * 1.1);
      var cx = x0 + lean * Math.pow(t, 1.7) + sw, hw = (w / 2) * Math.pow(1 - t, 0.75), y = 1.1 - h * t;
      izq.push([cx - hw, y]); der.unshift([cx + hw, y]);
    }
    return { k: 'poly', p: izq.concat(der), c: c, a: a };
  }
  function facetas(n, m, c) {
    var o = [], i, j, f1, f2;
    for (i = 0; i < n; i++) for (j = 0; j < m; j++) {
      var x0 = i / n, x1 = (i + 1) / n, y0 = j / m, y1 = (j + 1) / m;
      f1 = fr(Math.sin((i * 7 + j * 13) * 12.9898) * 43758.5453); f2 = fr(Math.sin((i * 5 + j * 11 + 3) * 78.233) * 43758.5453);
      o.push({ k: 'poly', p: [[x0, y0], [x1, y0], [x0, y1]], c: c, a: 0.03 + 0.2 * f1 });
      o.push({ k: 'poly', p: [[x1, y0], [x1, y1], [x0, y1]], c: c, a: 0.03 + 0.2 * f2 });
    }
    return o;
  }
  DECO.cometa = [ { k: 'circ', x: 0.96, y: 0.04, r: 0.58, c: 'P', a: 1 }, { k: 'circ', x: 0.96, y: 0.04, r: 0.46, c: 'S', a: 0.22 },
    { k: 'poly', p: [[-0.1, 0.88], [1.1, 0.58], [1.1, 0.70], [-0.1, 1.00]], c: 'P', a: 1 },
    { k: 'poly', p: [[-0.1, 0.99], [1.1, 0.70], [1.1, 0.74], [-0.1, 1.03]], c: 'S', a: 1 },
    { k: 'poly', p: [[-0.1, 1.04], [1.1, 0.75], [1.1, 0.78], [-0.1, 1.07]], c: 'P', a: 0.85 } ];
  DECO.diana = [ { k: 'circ', x: 0.78, y: 0.10, r: 0.46, c: 'P', a: 0.9 }, { k: 'circ', x: 0.78, y: 0.10, r: 0.36, c: 'S', a: 0.95 },
    { k: 'circ', x: 0.78, y: 0.10, r: 0.26, c: 'P', a: 1 }, { k: 'circ', x: 0.78, y: 0.10, r: 0.15, c: 'S', a: 1 },
    { k: 'poly', p: [[-0.1, 0.94], [1.1, 0.70], [1.1, 0.75], [-0.1, 0.99]], c: 'S', a: 1 }, { k: 'poly', p: [[-0.1, 1.00], [1.1, 0.77], [1.1, 0.79], [-0.1, 1.02]], c: 'P', a: 1 } ];
  DECO.chevrones = [ chevron(0.74, 0.06, 0.022, 'P', 1), chevron(0.79, 0.06, 0.022, 'S', 1), chevron(0.84, 0.06, 0.03, 'P', 1),
    chevron(0.895, 0.06, 0.022, 'S', 1), chevron(0.945, 0.06, 0.03, 'P', 0.9) ];
  DECO.oleaje = [ ondaDiag(0.66, 0.16, 0.025, 1.5, 0.0, 'P', 0.45), ondaDiag(0.74, 0.16, 0.025, 1.8, 1.4, 'S', 0.55),
    ondaDiag(0.82, 0.15, 0.022, 2.2, 2.6, 'P', 0.8), ondaDiag(0.90, 0.14, 0.02, 2.6, 4.0, 'S', 1), { k: 'circ', x: 0.88, y: 0.10, r: 0.18, c: 'P', a: 0.9 } ];
  DECO.solnaciente = rayosSol(18, 0.92, 0.06, 'P', 0.22).concat([ { k: 'circ', x: 0.92, y: 0.06, r: 0.44, c: 'P', a: 0.95 }, { k: 'circ', x: 0.92, y: 0.06, r: 0.32, c: 'S', a: 0.35 },
    { k: 'poly', p: [[-0.1, 0.96], [1.1, 0.74], [1.1, 0.78], [-0.1, 1.00]], c: 'P', a: 1 }, { k: 'poly', p: [[-0.1, 1.03], [1.1, 0.81], [1.1, 0.83], [-0.1, 1.05]], c: 'S', a: 1 } ]);
  DECO.llamas = [ llama(0.30, 0.55, 0.40, 0.10, 'P', 0.95), llama(0.62, 0.50, 0.50, -0.12, 'P', 0.9), llama(0.46, 0.46, 0.30, 0.06, 'S', 0.95),
    llama(0.12, 0.40, 0.26, 0.12, 'S', 0.85), llama(0.86, 0.40, 0.30, -0.08, 'S', 0.8) ];
  DECO.facetas = facetas(3, 9, 'P').concat([ { k: 'poly', p: [[-0.1, 0.90], [1.1, 0.66], [1.1, 0.69], [-0.1, 0.93]], c: 'S', a: 0.9 }, { k: 'poly', p: [[-0.1, 0.96], [1.1, 0.72], [1.1, 0.74], [-0.1, 0.98]], c: 'S', a: 0.6 } ]);

  function cristal(y0, y1, n, m, seed) {
    var v = [], i, j, o = [];
    for (j = 0; j <= m; j++) { v[j] = []; for (i = 0; i <= n; i++) {
      var jx = (i === 0 || i === n) ? 0 : (fr(Math.sin((i * 7 + j * 13 + seed) * 12.9898) * 43758.5453) - 0.5) * 0.12 / n * n,
          jy = (fr(Math.sin((i * 5 + j * 11 + seed) * 78.233) * 43758.5453) - 0.5) * (y1 - y0) / m * 0.9;
      v[j][i] = [-0.1 + 1.2 * i / n + jx, y0 + (y1 - y0) * j / m + jy - 0.10 * (i / n)];     // la banda baja hacia la derecha
    } }
    for (j = 0; j < m; j++) for (i = 0; i < n; i++) {
      var a = v[j][i], b = v[j][i + 1], c = v[j + 1][i + 1], d = v[j + 1][i], q = fr(Math.sin((i * 3 + j * 17 + seed) * 39.346) * 43758.5453);
      o.push({ k: 'poly', p: [a, b, d], c: q > 0.5 ? 'P' : 'S', a: 0.55 + 0.45 * fr(q * 7.7) });
      o.push({ k: 'poly', p: [b, c, d], c: q > 0.5 ? 'S' : 'P', a: 0.55 + 0.45 * fr(q * 3.1) });
    }
    return o;
  }
  function dientesSierra(y, h, n, c) {
    var p = [], i;
    for (i = 0; i <= n; i++) { p.push([-0.1 + 1.2 * (i / n), y + (i % 2 ? h : 0) - 0.06 * (i / n)]); }
    p.push([1.1, 1.1]); p.push([-0.1, 1.1]);
    return { k: 'poly', p: p, c: c, a: 1 };
  }
  function citricos(n, m) {
    var o = [], i, j;
    for (j = 0; j < m; j++) for (i = 0; i < n + 1; i++) {
      var x = (i + (j % 2 ? 0.5 : 0)) / n, y = (j + 0.5) / m;
      o.push({ k: 'circ', x: x, y: y, r: 0.40 / n * 1.25, c: 'P', a: 1 }, { k: 'circ', x: x, y: y, r: 0.31 / n * 1.25, c: 'S', a: 0.9 }, { k: 'circ', x: x, y: y, r: 0.10 / n * 1.25, c: 'P', a: 0.9 });
    }
    return o;
  }
  DECO.franjas = [ { k: 'poly', p: [[-0.1, -0.1], [1.1, -0.1], [1.1, 0.40], [-0.1, 0.20]], c: 'S', a: 1 },
    { k: 'poly', p: [[-0.1, 0.205], [1.1, 0.405], [1.1, 0.435], [-0.1, 0.235]], c: 'P', a: 1 },
    { k: 'poly', p: [[-0.1, 0.245], [1.1, 0.445], [1.1, 0.470], [-0.1, 0.270]], c: '#ffffff', a: 0.95 },
    { k: 'poly', p: [[-0.1, 0.280], [1.1, 0.480], [1.1, 0.505], [-0.1, 0.305]], c: 'P', a: 0.75 } ];
  DECO.cristal = cristal(0.30, 0.46, 4, 3, 5);
  DECO.dientes = [ { k: 'circ', x: 0.5, y: 0.17, r: 0.46, c: 'P', a: 1 }, dientesSierra(0.76, 0.05, 8, 'P') ];
  DECO.citricos = citricos(3, 9).concat([ { k: 'poly', p: [[-0.1, 0.44], [1.1, 0.40], [1.1, 0.72], [-0.1, 0.76]], c: '#111111', a: 0.93 } ]);
  var STYLE_GRAD = { sol: 'r', atardecer: 'r', neon: 'd', brillo: 'd', faros: 'r', oferta: 'r', rayos: 'r', rojo: 'd', azul: 'd', coches: 'd', gimnasio: 'd', halloween: 'r', premium: 'v', cometa: 'd', diana: 'r', chevrones: 'd', oleaje: 'v', solnaciente: 'r', llamas: 'v', facetas: 'd', franjas: 'd', cristal: 'd', dientes: 'v', citricos: 'v' };
  var STYLE_TX = { negro: ['hexagonos', 0.5], sol: ['rayos', 0.5], azul: ['olas', 0.6], rojo: ['chevron', 0.5], verde: ['selva', 0.7], clasico: ['marmol', 0.6],
    atardecer: ['rayos', 0.45], oceano: ['agua', 0.8], neon: ['puntos', 0.7], bosque: ['selva', 0.7], dorado: ['marmol', 0.7], marino: ['olas', 0.5],
    bicolor: ['puntos', 0.6], lineas: ['rombos', 0.4], dividido: ['puntos', 0.5], brillo: ['rayos', 0.4], oferta: ['rayos', 0.45], cinta: ['chevron', 0.35],
    confeti: ['puntos', 0.45], arcoiris: ['puntos', 0.5], noche: ['estrellas', 0.8], pastel: ['puntos', 0.6], triangulos: ['rombos', 0.5], deportivo: ['chevron', 0.5],
    tropical: ['selva', 0.9], playa: ['agua', 0.7], verano: ['puntos', 0.4], toldo: ['puntos', 0.4], expo: ['hexagonos', 0.5], banderines: ['puntos', 0.5],
    mercado: ['madera', 0.7], coches: ['hexagonos', 0.5], faros: ['trama', 0.5], premium: ['marmol', 0.8], montana: ['nieve', 0.6], ciudad: ['estrellas', 0.8],
    campo: ['hojas', 0.45], navidad: ['nieve', 1], halloween: ['marmol', 0.6], barberia: ['ladrillo', 0.35], cafe: ['madera', 0.6], gimnasio: ['hexagonos', 0.6], casas: ['ladrillo', 0.4],
    rayas: ['puntos', 0.4], cometa: ['rayos', 0.25], diana: ['puntos', 0.4], chevrones: ['chevron', 0.35], oleaje: ['agua', 0.6], solnaciente: ['rayos', 0.3], llamas: ['marmol', 0.5], facetas: ['trama', 0.35], franjas: ['chevron', 0.2], cristal: ['trama', 0.3], dientes: ['puntos', 0.2], citricos: ['puntos', 0.15] };
  function mezcla(a, b, t) {
    var x = parseInt(a.slice(1), 16), y = parseInt(b.slice(1), 16), o = 0;
    [16, 8, 0].forEach(function (sh) { o = o * 256 + Math.round(((x >> sh) & 255) * (1 - t) + ((y >> sh) & 255) * t); });
    return '#' + ('000000' + o.toString(16)).slice(-6);
  }
  function degDe(e, v) {            // degradado de una combinación de un estilo: { c: colores, t: tipo }
    if (v.deg) return { c: v.deg, t: e.dt || 'v' };
    var l = luminosidad(v.f), tipo = STYLE_GRAD[e.id] || 'v';
    if (l > 0.85) return { c: [v.f, mezcla(v.f, '#000000', 0.12)], t: tipo };
    if (l < 0.12) return { c: [mezcla(v.f, '#ffffff', 0.22), mezcla(v.f, '#000000', 0.6)], t: tipo };
    return tipo === 'r' ? { c: [mezcla(v.f, '#ffffff', 0.28), v.f, mezcla(v.f, '#000000', 0.32)], t: tipo } : { c: [mezcla(v.f, '#ffffff', 0.16), mezcla(v.f, '#000000', 0.30)], t: tipo };
  }
  function texDe(e, cols) {          // textura temática del estilo con el tono que le va a su fondo
    var d = STYLE_TX[e.id]; if (!d) return null;
    var l = (luminosidad(cols[0]) + luminosidad(cols[cols.length - 1])) / 2, c = l < 0.55;
    return { t: d[0], c: c ? '#ffffff' : '#000000', a: (c ? 0.18 : 0.13) * d[1], f: d[1] };
  }

  /* TEXTURAS: dibujos repetidos (puntos, rayas...) que se superponen al fondo con poca opacidad. Son figuras
     en cm, calculadas con la misma fórmula en montaje_bandera.py, así que el archivo final sale igual. */
  var TEXTURAS = [ ['puntos', 'Puntos'], ['rayas', 'Rayas'], ['cuadros', 'Cuadros'], ['zigzag', 'Zigzag'], ['burbujas', 'Burbujas'], ['trama', 'Trama'],
    ['tablero', 'Tablero'], ['rombos', 'Rombos'], ['olas', 'Olas'], ['hexagonos', 'Hexágonos'], ['estrellas', 'Estrellas'], ['camuflaje', 'Camuflaje'],
    ['chevron', 'Chevron'], ['rayos', 'Rayos de sol'], ['hojas', 'Hojas'],
    ['selva', 'Selva'], ['madera', 'Madera'], ['ladrillo', 'Ladrillo'], ['marmol', 'Mármol'], ['agua', 'Agua'], ['nieve', 'Nieve'] ];
  function fr(x) { return x - Math.floor(x); }
  function hs(i, k) { return fr(Math.sin(i * 12.9898 + k * 78.233) * 43758.5453); }
  function orient(p) {       // todos los polígonos con el mismo sentido, para que al juntarlos no se hagan huecos
    var a = 0, n = p.length;
    for (var i = 0; i < n; i++) { var q = p[(i + 1) % n]; a += p[i][0] * q[1] - q[0] * p[i][1]; }
    return a < 0 ? p.reverse() : p;
  }
  function cuad(x0, y0, x1, y1, x2, y2, x3, y3) { return orient([[x0, y0], [x1, y1], [x2, y2], [x3, y3]]); }
  function segq(ax, ay, bx, by, w) {        // trazo fino entre dos puntos
    var dx = bx - ax, dy = by - ay, l = Math.sqrt(dx * dx + dy * dy) || 1, nx = -dy / l * w / 2, ny = dx / l * w / 2;
    return cuad(ax + nx, ay + ny, bx + nx, by + ny, bx - nx, by - ny, ax - nx, ay - ny);
  }
  function texturaCapas(t, W, H) {
    var P = [], C = [], i, j, s, U = Math.min(W, H);
    if (t === 'puntos' || t === 'trama') {
      s = U / (t === 'puntos' ? 7 : 9);
      for (j = 0; j * s * 0.866 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var x = (i + (j % 2 ? 0.5 : 0)) * s, y = j * s * 0.866, r = s * 0.13;
        if (t === 'trama') { r = s * 0.5 * Math.pow(Math.min(1, Math.max(0, y / H)), 1.3); if (r < s * 0.03) continue; }
        C.push([x, y, r]);
      }
      return [{ p: P, c: C }];
    }
    if (t === 'rayas') {
      var per = U / 5, wd = per * 0.45;
      for (var c = 0; c < W + H + per; c += per) P.push(cuad(c, 0, c + wd, 0, c + wd - H, H, c - H, H));
      return [{ p: P, c: C }];
    }
    if (t === 'cuadros') {
      s = U / 6; var V = [], Hh = [];
      for (i = 0; i * s * 2 < W + s; i++) V.push(cuad(i * s * 2, 0, i * s * 2 + s, 0, i * s * 2 + s, H, i * s * 2, H));
      for (j = 0; j * s * 2 < H + s; j++) Hh.push(cuad(0, j * s * 2, W, j * s * 2, W, j * s * 2 + s, 0, j * s * 2 + s));
      return [{ p: V, c: C }, { p: Hh, c: C }];
    }
    if (t === 'zigzag') {
      s = U / 5; var sp = s * 1.1, g = s * 0.09, am = s * 0.3;
      for (j = 0; j * sp < H + s; j++) for (i = 0; i * s / 2 < W + s; i++) {
        var xa = i * s / 2, xb = xa + s / 2, ya = j * sp + (i % 2 ? am : 0), yb = j * sp + (i % 2 ? 0 : am);
        var dx = xb - xa, dy = yb - ya, l = Math.sqrt(dx * dx + dy * dy), ux = dx / l, uy = dy / l, nx = -uy * g / 2, ny = ux * g / 2, e = g / 2;
        P.push(cuad(xa - ux * e + nx, ya - uy * e + ny, xb + ux * e + nx, yb + uy * e + ny, xb + ux * e - nx, yb + uy * e - ny, xa - ux * e - nx, ya - uy * e - ny));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'tablero') {
      s = U / 6;
      for (j = 0; j * s < H + s; j++) for (i = 0; i * s < W + s; i++) if (!((i + j) % 2)) P.push(cuad(i * s, j * s, (i + 1) * s, j * s, (i + 1) * s, (j + 1) * s, i * s, (j + 1) * s));
      return [{ p: P, c: C }];
    }
    if (t === 'rombos') {
      s = U / 4; var rr = s * 0.22;
      for (j = 0; j * s * 0.5 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var xr = (i + (j % 2 ? 0.5 : 0)) * s, yr = j * s * 0.5;
        P.push(orient([[xr, yr - rr], [xr + rr, yr], [xr, yr + rr], [xr - rr, yr]]));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'olas') {
      var lam = U / 1.5, am2 = U * 0.05, gw = U * 0.04, sp2 = U * 0.18, nn = Math.ceil(W / (lam / 12)) + 1;
      for (j = 0; j * sp2 < H + sp2; j++) {
        var top = [], bot = [];
        for (i = 0; i <= nn; i++) { var xw = i * lam / 12, yw = j * sp2 + am2 * Math.sin(2 * Math.PI * xw / lam); top.push([xw, yw]); bot.push([xw, yw + gw]); }
        P.push(orient(top.concat(bot.reverse())));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'hexagonos') {
      s = U / 5; var R = s * 0.5;
      for (j = 0; j * s * 0.866 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var xh = (i + (j % 2 ? 0.5 : 0)) * s, yh = j * s * 0.866, hx = [];
        for (var k = 0; k < 6; k++) hx.push([xh + R * Math.cos(Math.PI / 3 * k + Math.PI / 6), yh + R * Math.sin(Math.PI / 3 * k + Math.PI / 6)]);
        P.push(orient(hx));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'estrellas') {
      s = U / 4; var Ro = s * 0.17, Ri = Ro * 0.42;
      for (j = 0; j * s * 0.5 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var xs = (i + (j % 2 ? 0.5 : 0)) * s, ys = j * s * 0.5, st = [];
        for (var k2 = 0; k2 < 10; k2++) { var rad = k2 % 2 ? Ri : Ro, an = -Math.PI / 2 + Math.PI / 5 * k2; st.push([xs + rad * Math.cos(an), ys + rad * Math.sin(an)]); }
        P.push(orient(st));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'camuflaje') {
      s = U / 5; var nb = Math.round(W * H / (s * s) * 1.1);
      for (i = 0; i < nb; i++) C.push([fr(Math.sin(i * 12.9898 + 3.3) * 43758.5453) * W, fr(Math.sin(i * 78.233 + 9.1) * 43758.5453) * H,
        s * (0.2 + 0.35 * fr(Math.sin(i * 39.346 + 2.2) * 43758.5453))]);
      return [{ p: P, c: C }];
    }
    if (t === 'chevron') {
      s = U / 3; var sp3 = s * 0.9, g3 = s * 0.2, am3 = s * 0.4;
      for (j = 0; j * sp3 < H + s; j++) for (i = 0; i * s / 2 < W + s; i++) {
        var xa2 = i * s / 2, xb2 = xa2 + s / 2, ya2 = j * sp3 + (i % 2 ? am3 : 0), yb2 = j * sp3 + (i % 2 ? 0 : am3);
        var dx2 = xb2 - xa2, dy2 = yb2 - ya2, l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2), ux2 = dx2 / l2, uy2 = dy2 / l2, nx3 = -uy2 * g3 / 2, ny3 = ux2 * g3 / 2, e2 = g3 / 2;
        P.push(cuad(xa2 - ux2 * e2 + nx3, ya2 - uy2 * e2 + ny3, xb2 + ux2 * e2 + nx3, yb2 + uy2 * e2 + ny3, xb2 + ux2 * e2 - nx3, yb2 + uy2 * e2 - ny3, xa2 - ux2 * e2 - nx3, ya2 - uy2 * e2 - ny3));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'rayos') {
      var cx0 = W / 2, cy0 = H * 0.08, RR = 2 * (W + H), nr = 22;
      for (i = 0; i < nr; i++) {
        var a0 = Math.PI * i / nr, a1 = a0 + Math.PI / nr * 0.5;
        P.push(orient([[cx0, cy0], [cx0 + RR * Math.cos(a0), cy0 + RR * Math.sin(a0)], [cx0 + RR * Math.cos(a1), cy0 + RR * Math.sin(a1)]]));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'hojas') {
      s = U / 4; var nh = Math.round(W * H / (s * s) * 1.6);
      for (i = 0; i < nh; i++) {
        var hx = hs(i, 3.1) * W, hy = hs(i, 5.7) * H, ha = hs(i, 9.3) * 6.2832, hL = s * (0.55 + 0.45 * hs(i, 1.7)), lado = [], lado2 = [], ca = Math.cos(ha), sa = Math.sin(ha);
        for (var q = 0; q <= 8; q++) {
          var tt = q / 8, al = hL * (tt - 0.5), wd = 0.17 * hL * Math.sin(Math.PI * tt);
          lado.push([hx + al * ca - wd * sa, hy + al * sa + wd * ca]); lado2.push([hx + al * ca + wd * sa, hy + al * sa - wd * ca]);
        }
        P.push(orient(lado.concat(lado2.reverse())));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'selva') {                     // hojas grandes de banano con sus nervios (2 capas: hoja y nervios)
      var nl = Math.round(W * H / (U * U) * 2.4) + 5, LA = [], VE = [];
      for (i = 0; i < nl; i++) {
        var lx = hs(i, 2.1) * W, ly = hs(i, 4.3) * H, la = -0.9 + (hs(i, 6.7) - 0.5) * 0.9 + (hs(i, 8.1) > 0.5 ? Math.PI : 0);
        var LL = U * (0.7 + 0.7 * hs(i, 1.3)), ca = Math.cos(la), sa = Math.sin(la), l1 = [], l2 = [];
        for (j = 0; j <= 12; j++) {
          var tt = j / 12, al = LL * (tt - 0.5), wd = 0.19 * LL * Math.pow(Math.sin(Math.PI * tt), 0.8);
          l1.push([lx + al * ca - wd * sa, ly + al * sa + wd * ca]); l2.push([lx + al * ca + wd * sa, ly + al * sa - wd * ca]);
        }
        LA.push(orient(l1.concat(l2.reverse())));
        VE.push(segq(lx - 0.5 * LL * ca, ly - 0.5 * LL * sa, lx + 0.5 * LL * ca, ly + 0.5 * LL * sa, LL * 0.014));
        for (j = 1; j <= 7; j++) {
          var tv = 0.12 + j * 0.11, ax = lx + LL * (tv - 0.5) * ca, ay = ly + LL * (tv - 0.5) * sa, tx2 = tv + 0.08;
          var wv = 0.19 * LL * Math.pow(Math.sin(Math.PI * tv), 0.8) * 0.92;
          [1, -1].forEach(function (sg) {
            VE.push(segq(ax, ay, lx + LL * (tx2 - 0.5) * ca - sg * wv * sa, ly + LL * (tx2 - 0.5) * sa + sg * wv * ca, LL * 0.007));
          });
        }
      }
      return [{ p: LA, c: C }, { p: VE, c: C }];
    }
    if (t === 'madera') {                    // vetas largas y onduladas
      var spm = U * 0.05;
      for (j = 0; j * spm < H + spm; j++) {
        var lam2 = U * (1.2 + 1.5 * hs(j, 1.1)), am = U * (0.01 + 0.03 * hs(j, 2.2)), ph = hs(j, 3.3) * lam2, th = U * (0.004 + 0.01 * hs(j, 4.4));
        var nn2 = Math.ceil(W / (lam2 / 12)) + 1, tp = [], bt = [];
        for (i = 0; i <= nn2; i++) { var xw = i * lam2 / 12, yw = j * spm + am * Math.sin(2 * Math.PI * (xw + ph) / lam2); tp.push([xw, yw]); bt.push([xw, yw + th]); }
        P.push(orient(tp.concat(bt.reverse())));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'ladrillo') {
      var bh = U / 12, bw = U / 5.5, gg = U * 0.012;
      for (j = 0; j * bh < H + bh; j++) for (i = -1; i * bw < W + bw; i++) {
        var bx = (i + (j % 2 ? 0.5 : 0)) * bw, by = j * bh;
        P.push(cuad(bx + gg, by + gg, bx + bw - gg, by + gg, bx + bw - gg, by + bh - gg, bx + gg, by + bh - gg));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'marmol') {                    // vetas que serpentean
      var nm = Math.round(W * H / (U * U) * 6) + 4;
      for (i = 0; i < nm; i++) {
        var mx = hs(i, 2.7) * W, my2 = hs(i, 3.9) * H, an = hs(i, 5.1) * 6.2832, wd0 = U * (0.012 + 0.02 * hs(i, 6.3)), ps = [[mx, my2]];
        for (j = 0; j < 18; j++) { an += (hs(i * 40 + j, 7.7) - 0.5) * 0.9; mx += Math.cos(an) * U * 0.09; my2 += Math.sin(an) * U * 0.09; ps.push([mx, my2]); }
        for (j = 0; j < 18; j++) P.push(segq(ps[j][0], ps[j][1], ps[j + 1][0], ps[j + 1][1], wd0 * (1 - j / 18) + 0.001));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'agua') {                      // ondas concéntricas
      var na = Math.round(W * H / (U * U) * 0.8) + 1;
      for (i = 0; i < na; i++) {
        var ax0 = hs(i, 2.2) * W, ay0 = hs(i, 4.4) * H;
        for (var rk = 0; rk < 4; rk++) {
          var rad = U * (0.12 + 0.17 * rk);
          for (j = 0; j < 28; j++) {
            var a0 = 6.2832 * j / 28, a1 = 6.2832 * (j + 1) / 28;
            P.push(segq(ax0 + rad * Math.cos(a0), ay0 + rad * Math.sin(a0), ax0 + rad * Math.cos(a1), ay0 + rad * Math.sin(a1), U * 0.012));
          }
        }
      }
      return [{ p: P, c: C }];
    }
    if (t === 'nieve') {
      var nn3 = Math.round(W * H / (U * U) * 45);
      for (i = 0; i < nn3; i++) C.push([hs(i, 2.3) * W, hs(i, 4.1) * H, U * (0.01 + 0.02 * hs(i, 6.2) * (hs(i, 8.4) > 0.85 ? 2.5 : 1))]);
      return [{ p: P, c: C }];
    }
    if (t === 'burbujas') {
      s = U / 5; var n = Math.round(W * H / (s * s) * 2.2);
      for (i = 0; i < n; i++) C.push([fr(Math.sin(i * 12.9898) * 43758.5453) * W, fr(Math.sin(i * 78.233 + 1.7) * 43758.5453) * H,
        s * (0.06 + 0.22 * Math.pow(fr(Math.sin(i * 39.346 + 5.1) * 43758.5453), 2))]);
      return [{ p: P, c: C }];
    }
    return [];
  }
  function luminosidad(hex) {
    var n = parseInt(hex.slice(1), 16); return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  }
  function pintarTextura(ctx, W, H, tx) {
    ctx.save(); ctx.fillStyle = tx.c; ctx.globalAlpha = tx.a;
    texturaCapas(tx.t, W, H).forEach(function (L) {
      ctx.beginPath();
      L.p.forEach(function (q) { q.forEach(function (pt, i) { if (i) ctx.lineTo(pt[0], pt[1]); else ctx.moveTo(pt[0], pt[1]); }); ctx.closePath(); });
      L.c.forEach(function (c) { ctx.moveTo(c[0] + c[2], c[1]); ctx.arc(c[0], c[1], c[2], 0, 6.2832); });
      ctx.fill();
    });
    ctx.restore();
  }


  /* COMPOSICIONES: huecos (l = qué va, b = banda de altura entre 0 y 1 de la zona segura). El tamaño se calcula
     con el ancho que deja la forma de la bandera en esa banda: una gota es ancha arriba y estrecha abajo. */
  // el contenido (logo y textos) ocupa la parte de arriba, hasta el 70 %; la de abajo se deja a los adornos del estilo
  var LAYOUTS = {
    'logo-texto':   [ { l: 'logo', b: [0.06, 0.30] }, { l: 't1', b: [0.33, 0.52] }, { l: 't2', b: [0.54, 0.64] } ],
    'texto-grande': [ { l: 't1', b: [0.08, 0.38] }, { l: 't2', b: [0.40, 0.50] }, { l: 'logo', b: [0.52, 0.68] } ],
    'vertical':     [ { l: 'logo', b: [0.05, 0.22] }, { l: 't2', b: [0.24, 0.32] }, { l: 't1', b: [0.34, 0.70], v: true } ],
    'cabeza':       [ { l: 'logo', b: [0.04, 0.27] }, { l: 't1', b: [0.47, 0.60] }, { l: 't2', b: [0.62, 0.70] } ]
  };

  // la gota solo es ancha arriba: allí se agrupa todo (si no, el texto sale diminuto en la cola)
  var LAYOUTS_GOTA = {
    'logo-texto':   [ { l: 'logo', b: [0.05, 0.30] }, { l: 't1', b: [0.32, 0.50] }, { l: 't2', b: [0.52, 0.62] } ],
    'texto-grande': [ { l: 't1', b: [0.08, 0.36] }, { l: 't2', b: [0.38, 0.48] }, { l: 'logo', b: [0.50, 0.68] } ],
    'vertical':     [ { l: 'logo', b: [0.05, 0.22] }, { l: 't2', b: [0.24, 0.32] }, { l: 't1', b: [0.34, 0.70], v: true } ],
    'cabeza':       [ { l: 'logo', b: [0.04, 0.27] }, { l: 't1', b: [0.47, 0.60] }, { l: 't2', b: [0.62, 0.70] } ]
  };

  /* GROSOR de la letra: [titular, subtítulo] como fracción del cuerpo. Se añade un trazo del mismo color para engordarla. */
  var MARGEN = 20;           // px alrededor de la bandera en el lienzo (caben las asas de la capa elegida)
  var GROSORES = [[0, 0], [0.012, 0.03], [0.028, 0.055]];
  var COLORES_TEXTO = ['#ffffff', '#111111', '#ffe500', '#1fb324', '#e31b23', '#1d4ed8', '#f97316'];
  /* Pancartas (apaisadas): los huecos llevan además un tramo horizontal x (0-1 del ancho seguro). */
  var LAYOUTS_ANCHO = {
    'logo-texto':   [ { l: 'logo', b: [0.13, 0.68], x: [0.03, 0.26] }, { l: 't1', b: [0.13, 0.50], x: [0.29, 0.97] }, { l: 't2', b: [0.53, 0.68], x: [0.29, 0.97] } ],
    'texto-grande': [ { l: 't1', b: [0.13, 0.52], x: [0.03, 0.80] }, { l: 't2', b: [0.55, 0.69], x: [0.03, 0.80] }, { l: 'logo', b: [0.13, 0.68], x: [0.82, 0.97] } ]
  };
  var MUESTRA = 'TU MARCA AQUÍ';
  /* TIPOGRAFÍAS de banderas y pancartas: de las que se ven en carteles de verdad (nada de letra de Word). Todas de licencia
     abierta. Cada estilo lleva su TITULAR y su SUBTÍTULO (otra letra, fina y con las letras separadas), como en un cartel. */
  function F(id, nombre, web, peso, css) { return { id: id, nombre: nombre, web: web, peso: peso, css: css }; }
  var FUENTES_B = [
    F('anton', 'Impacto', 'Anton', '400', '"Anton", Impact, sans-serif'), F('bebas', 'Estrecha', 'Bebas+Neue', '400', '"Bebas Neue", Impact, sans-serif'),
    F('archivo', 'Ultra negra', 'Archivo+Black', '400', '"Archivo Black", Impact, sans-serif'), F('oswald', 'Titular', 'Oswald:wght@700', '700', '"Oswald", Impact, sans-serif'),
    F('russo', 'Deportiva', 'Russo+One', '400', '"Russo One", Impact, sans-serif'), F('unbounded', 'Moderna', 'Unbounded:wght@900', '900', '"Unbounded", Arial, sans-serif'),
    F('syne', 'Galería', 'Syne:wght@800', '800', '"Syne", Arial, sans-serif'), F('montserrat', 'Limpia', 'Montserrat:wght@900', '900', '"Montserrat", Arial, sans-serif'),
    F('abril', 'Moda', 'Abril+Fatface', '400', '"Abril Fatface", Georgia, serif'), F('dmserif', 'Editorial', 'DM+Serif+Display', '400', '"DM Serif Display", Georgia, serif'),
    F('cinzel', 'Elegante', 'Cinzel:wght@900', '900', '"Cinzel", Georgia, serif'), F('shrikhand', 'Retro', 'Shrikhand', '400', '"Shrikhand", Georgia, serif'),
    F('lilita', 'Divertida', 'Lilita+One', '400', '"Lilita One", Arial, sans-serif'), F('fredoka', 'Redondita', 'Fredoka:wght@700', '700', '"Fredoka", Arial, sans-serif'),
    F('bungee', 'Urbana', 'Bungee', '400', '"Bungee", Impact, sans-serif'), F('righteous', 'Futurista', 'Righteous', '400', '"Righteous", Arial, sans-serif'),
    F('pacifico', 'Surf', 'Pacifico', '400', '"Pacifico", cursive'), F('lobster', 'Cafetería', 'Lobster', '400', '"Lobster", cursive'),
    F('yellowtail', 'Rotulada', 'Yellowtail', '400', '"Yellowtail", cursive'), F('vibes', 'Boda', 'Great+Vibes', '400', '"Great Vibes", cursive'),
    F('marker', 'Rotulador', 'Permanent+Marker', '400', '"Permanent Marker", cursive'), F('bangers', 'Cómic', 'Bangers', '400', '"Bangers", Impact, cursive'),
    F('luckiest', 'Dibujos', 'Luckiest+Guy', '400', '"Luckiest Guy", Impact, cursive'), F('creepster', 'Terror', 'Creepster', '400', '"Creepster", cursive'),
    F('blackops', 'Estarcido', 'Black+Ops+One', '400', '"Black Ops One", Impact, sans-serif'), F('rye', 'Western', 'Rye', '400', '"Rye", Georgia, serif'),
    F('caveat', 'Manuscrita', 'Caveat:wght@700', '700', '"Caveat", cursive'),
    // para subtítulos
    F('josefin', 'Fina', 'Josefin+Sans:wght@700', '700', '"Josefin Sans", Arial, sans-serif'), F('barlow', 'Fina estrecha', 'Barlow+Condensed:wght@800', '800', '"Barlow Condensed", Arial, sans-serif'),
    F('poppins', 'Suave', 'Poppins:wght@700', '700', '"Poppins", Arial, sans-serif')
  ];
  // [titular, subtítulo, separación del subtítulo (em), subtítulo en mayúsculas]
  var STYLE_FONT = {
    negro: ['anton', 'barlow', 0.18, 1], sol: ['bungee', 'barlow', 0.16, 1], azul: ['unbounded', 'montserrat', 0.12, 1], rojo: ['bebas', 'oswald', 0.14, 1],
    verde: ['lilita', 'fredoka', 0, 0], clasico: ['abril', 'josefin', 0.26, 1], atardecer: ['shrikhand', 'poppins', 0.04, 0], oceano: ['righteous', 'montserrat', 0.14, 1],
    neon: ['syne', 'josefin', 0.22, 1], bosque: ['dmserif', 'josefin', 0.22, 1], dorado: ['cinzel', 'josefin', 0.3, 1], marino: ['anton', 'oswald', 0.16, 1],
    bicolor: ['fredoka', 'poppins', 0.02, 0], lineas: ['dmserif', 'josefin', 0.28, 1], rayas: ['anton', 'barlow', 0.2, 1], dividido: ['unbounded', 'josefin', 0.2, 1],
    brillo: ['syne', 'josefin', 0.24, 1], oferta: ['luckiest', 'oswald', 0.1, 1], cinta: ['anton', 'barlow', 0.22, 1], rayos: ['bangers', 'oswald', 0.12, 1],
    confeti: ['lilita', 'fredoka', 0, 0], arcoiris: ['shrikhand', 'fredoka', 0, 0], noche: ['cinzel', 'josefin', 0.3, 1], pastel: ['yellowtail', 'josefin', 0.28, 1],
    triangulos: ['unbounded', 'barlow', 0.2, 1], deportivo: ['russo', 'barlow', 0.2, 1], tropical: ['lobster', 'poppins', 0.04, 0], playa: ['pacifico', 'poppins', 0.04, 0],
    verano: ['shrikhand', 'poppins', 0.04, 0], toldo: ['abril', 'josefin', 0.26, 1], expo: ['syne', 'montserrat', 0.14, 1], banderines: ['lilita', 'fredoka', 0, 0],
    mercado: ['abril', 'josefin', 0.24, 1], coches: ['russo', 'barlow', 0.22, 1], faros: ['archivo', 'barlow', 0.28, 1], premium: ['cinzel', 'josefin', 0.32, 1],
    montana: ['anton', 'josefin', 0.3, 1], campo: ['lobster', 'poppins', 0.04, 0], ciudad: ['anton', 'barlow', 0.3, 1], casas: ['dmserif', 'josefin', 0.22, 1],
    navidad: ['lobster', 'poppins', 0.04, 0], halloween: ['creepster', 'barlow', 0.2, 1], barberia: ['abril', 'josefin', 0.28, 1], cafe: ['lobster', 'josefin', 0.2, 1],
    gimnasio: ['anton', 'barlow', 0.24, 1],
    cometa: ['anton', 'barlow', 0.18, 1], diana: ['archivo', 'barlow', 0.28, 1], chevrones: ['russo', 'barlow', 0.22, 1], oleaje: ['righteous', 'montserrat', 0.14, 1],
    solnaciente: ['syne', 'josefin', 0.22, 1], llamas: ['anton', 'oswald', 0.16, 1], facetas: ['unbounded', 'barlow', 0.2, 1],
    franjas: ['anton', 'barlow', 0.2, 1], cristal: ['unbounded', 'barlow', 0.2, 1], dientes: ['fredoka', 'poppins', 0.04, 0], citricos: ['lilita', 'fredoka', 0, 0]
  };
  function fuentesDe(id) {          // titular y subtítulo de un estilo
    var d = STYLE_FONT[id] || ['anton', 'barlow', 0.18, 1];
    return { f1: d[0], f2: d[1], esp: d[2], may: !!d[3] };
  }

  var IDEAS = ['ABIERTO', 'OPEN', 'REBAJAS', 'OFERTA', 'SE VENDE', 'SE ALQUILA', 'INAUGURACIÓN', 'MENÚ DEL DÍA', 'NUEVO', 'BIENVENIDOS'];
  /* EJEMPLOS LISTOS: un clic y la bandera/pancarta sale con el texto, el estilo y los colores puestos. [texto 1, texto 2, estilo, combinación] */
  var CATS_PANCARTA = [['', 'Todos'], ['balcon', 'Balcón y vecinos'], ['comercio', 'Comercio'], ['obras', 'Obras'], ['eventos', 'Eventos y ferias'], ['fiestas', 'Fiestas'], ['deporte', 'Deporte y peñas'], ['naturaleza', 'Naturaleza'], ['inmo', 'Inmobiliaria'], ['navidad', 'Navidad y Halloween'], ['bares', 'Bares y cafés']];
  var CATS_BANDERA = [['', 'Todas'], ['integral', 'A medida de la forma'], ['negocio', 'Negocio'], ['ofertas', 'Ofertas'], ['playa', 'Playa'], ['ferias', 'Ferias'], ['coches', 'Coches'], ['fiestas', 'Fiestas'], ['deporte', 'Deporte'], ['naturaleza', 'Naturaleza'], ['ciudad', 'Ciudad e inmobiliaria'], ['navidad', 'Navidad y Halloween'], ['bares', 'Bares y cafés']];
  var CAT_ESTILO = { balcon: '', comercio: 'ofertas', obras: 'negocio', eventos: 'ferias', inmo: 'ciudad' };   // qué estilos enseña cada tema de pancarta
  var CATS_PHOTOCALL = [['', 'Todos'], ['bodas', 'Bodas y comuniones'], ['cumples', 'Cumpleaños'], ['marcas', 'Marcas y eventos'], ['infantil', 'Infantil y fiestas']];
  var CAT_ESTILO_PHOTO = { bodas: 'ciudad', cumples: 'fiestas', marcas: 'ofertas', infantil: 'fiestas' };
  var CATS_MANTEL = [['', 'Todos'], ['premios', 'Trofeos y clubes'], ['ferias', 'Ferias y stands'], ['bares', 'Bares y catering'], ['fiestas', 'Bodas y fiestas']];
  var CAT_ESTILO_MANTEL = { premios: 'deporte', ferias: 'ferias', bares: 'bares', fiestas: 'fiestas' };
  var EJ_MANTEL = [
    ['premios', 'ENTREGA DE TROFEOS', 'Temporada 2026', 'premium', 1], ['premios', 'CLUB DEPORTIVO', 'Campeones', 'deportivo', 0], ['premios', 'GALA DEL DEPORTE', 'Premios 2026', 'noche', 0],
    ['premios', 'CAMPEONES', 'Gracias por esta temporada', 'dorado', 0], ['premios', 'ASOCIACIÓN DE VECINOS', 'Fiestas del barrio', 'banderines', 1],
    ['ferias', 'STAND 12', 'Feria 2026', 'expo', 0], ['ferias', 'TU MARCA', 'www.tuweb.com', 'expo', 1], ['ferias', 'ARTESANÍA LOCAL', 'Hecho a mano', 'mercado', 0],
    ['ferias', 'BIENVENIDOS', 'Feria de muestras', 'banderines', 0], ['ferias', 'PRODUCTOS DEL CAMPO', 'Directos del agricultor', 'campo', 0],
    ['bares', 'BAR LA PLAZA', 'Desde 1990', 'cafe', 0], ['bares', 'MENÚ DEL DÍA', 'Desde 12,90 €', 'mercado', 0], ['bares', 'CAFÉ DE ESPECIALIDAD', 'Tuestes artesanos', 'cafe', 1],
    ['bares', 'BARBERÍA', 'Corte y barba', 'barberia', 0], ['bares', 'CHIRINGUITO', 'Abierto todo el día', 'playa', 0],
    ['fiestas', 'ANA & LUIS', 'Nos casamos', 'pastel', 0], ['fiestas', 'FELIZ CUMPLEAÑOS', 'Te queremos', 'confeti', 0], ['fiestas', 'FELIZ NAVIDAD', 'Os deseamos felices fiestas', 'navidad', 0],
    ['fiestas', 'COMUNIÓN', 'Gracias por acompañarnos', 'pastel', 1]
  ];
  var EJ_PHOTOCALL = [
    ['bodas', 'ANA & LUIS', 'Nos casamos · 14 de junio', 'pastel', 0], ['bodas', 'NUESTRA BODA', '#AnaYLuis', 'premium', 1], ['bodas', 'COMUNIÓN DE LUCÍA', '12 de mayo de 2027', 'pastel', 1],
    ['bodas', 'BIENVENIDOS', 'Gracias por celebrarlo con nosotros', 'arcoiris', 0], ['bodas', 'FELIZ NAVIDAD', '', 'navidad', 0],
    ['cumples', 'FELIZ CUMPLEAÑOS', '¡Hoy cumple 30!', 'confeti', 0], ['cumples', 'HAPPY BIRTHDAY', '', 'confeti', 1], ['cumples', 'LUCÍA CUMPLE 5', 'Gran fiesta de cumpleaños', 'arcoiris', 1],
    ['cumples', 'FIESTA', 'Esta noche', 'noche', 0], ['cumples', 'GRADUADOS', 'Promoción 2027', 'premium', 0],
    ['marcas', 'TU MARCA', 'Evento · 2026', 'expo', 0], ['marcas', 'INAUGURACIÓN', 'Estás invitado', 'oferta', 1], ['marcas', 'BIENVENIDOS', 'Feria de muestras', 'banderines', 0],
    ['marcas', 'PRESENTACIÓN', 'Nueva colección', 'brillo', 1], ['marcas', 'NOCHE DE GALA', '', 'ciudad', 0],
    ['infantil', 'HALLOWEEN', 'Noche de miedo', 'halloween', 0], ['infantil', 'FIESTA TROPICAL', 'Verano 2027', 'tropical', 0], ['infantil', 'FIESTA DE LA ESPUMA', '¡Ven a divertirte!', 'verano', 1],
    ['infantil', 'CARNAVAL', 'Disfraces y música', 'confeti', 2]
  ];
  var EJ_PANCARTA = [
    ['balcon', 'SE ALQUILA', 'Llama al 600 000 000', 'cinta', 3], ['balcon', 'SE VENDE', 'Información: 600 000 000', 'oferta', 0],
    ['balcon', 'NO MÁS RUIDOS', 'Respetemos el descanso', 'cinta', 1], ['balcon', 'SE TRASPASA', 'Local en pleno centro', 'clasico', 0],
    ['balcon', 'VADO PERMANENTE', 'Prohibido aparcar', 'rojo', 0], ['balcon', 'ALQUILER DE HABITACIONES', 'Estudiantes y trabajadores', 'azul', 0],
    ['balcon', 'NO AL BOTELLÓN', 'Queremos dormir', 'negro', 0], ['balcon', 'ATICO EN VENTA', 'Sin comisiones', 'marino', 0],
    ['comercio', 'REBAJAS', 'Hasta el 50% de descuento', 'oferta', 0], ['comercio', 'ABIERTO', 'Lunes a sábado de 9:00 a 20:00', 'clasico', 0],
    ['comercio', 'PRÓXIMA APERTURA', 'Muy pronto', 'marino', 1], ['comercio', 'LIQUIDACIÓN TOTAL', 'Por cierre de negocio', 'cinta', 1],
    ['comercio', 'NUEVO', 'Ya en tu tienda', 'neon', 0], ['comercio', 'MENÚ DEL DÍA', 'Desde 12,90 €', 'mercado', 0],
    ['comercio', 'OFERTA DE LANZAMIENTO', 'Solo esta semana', 'rayos', 1], ['comercio', 'VENTA DE COCHES', 'Financiación a tu medida', 'coches', 0],
    ['obras', 'OBRAS', 'Disculpen las molestias', 'sol', 0], ['obras', 'PRÓXIMAMENTE', 'Nueva promoción de viviendas', 'expo', 0],
    ['obras', 'SE REFORMA', 'Abrimos muy pronto', 'sol', 3], ['obras', 'ZONA EN OBRAS', 'Gracias por su paciencia', 'cinta', 3],
    ['eventos', 'FERIA DEL LIBRO', 'Del 10 al 13 de abril', 'banderines', 0], ['eventos', 'FIESTAS DEL BARRIO', 'Del 14 al 17 de agosto', 'banderines', 1],
    ['eventos', 'MERCADILLO', 'Sábados de 10:00 a 14:00', 'mercado', 2], ['eventos', 'BIENVENIDOS', 'Feria de artesanía', 'mercado', 0],
    ['eventos', 'CONCIERTO', 'Entrada libre', 'noche', 0], ['eventos', 'INAUGURACIÓN', 'Este sábado a las 12:00', 'oferta', 1],
    ['fiestas', 'FELIZ CUMPLEAÑOS', 'Te queremos', 'confeti', 0], ['fiestas', 'BIENVENIDO A CASA', 'Te echábamos de menos', 'arcoiris', 0],
    ['fiestas', 'FELICIDADES', 'Enhorabuena', 'confeti', 2], ['fiestas', 'ANA Y LUIS', 'Nos casamos', 'pastel', 0],
    ['fiestas', 'GRADUADOS', 'Promoción 2027', 'premium', 1], ['fiestas', 'CHIRINGUITO', 'Abierto todo el día', 'playa', 0],
    ['inmo', 'SE VENDE', 'Casa con jardín · 600 000 000', 'casas', 0], ['inmo', 'SE ALQUILA', 'Piso luminoso en el centro', 'casas', 1], ['inmo', 'LOFTS EN VENTA', 'Obra nueva', 'ciudad', 0],
    ['naturaleza', 'RUTAS DE MONTAÑA', 'Guías y excursiones', 'montana', 0], ['naturaleza', 'PRODUCTOS DEL CAMPO', 'Directos del agricultor', 'campo', 0],
    ['navidad', 'FELIZ NAVIDAD', 'Os deseamos felices fiestas', 'navidad', 0], ['navidad', 'HALLOWEEN', 'Noche de miedo · 31 de octubre', 'halloween', 0], ['navidad', 'ABIERTO EN NAVIDAD', 'Del 20 de dic. al 6 de enero', 'navidad', 1],
    ['bares', 'CAFÉ DE ESPECIALIDAD', 'Tuestes artesanos', 'cafe', 0], ['bares', 'BARBERÍA', 'Corte y barba', 'barberia', 0], ['bares', 'DESAYUNOS', 'Desde las 7:00', 'cafe', 1],
    ['deporte', 'GIMNASIO', 'Matrícula gratis', 'gimnasio', 0],
    ['deporte', 'VAMOS EQUIPO', 'Club Deportivo', 'deportivo', 0], ['deporte', 'CAMPEONES', 'Temporada 2026', 'deportivo', 1],
    ['deporte', 'PEÑA LOS CRACKS', 'Desde 1998', 'rayas', 1], ['deporte', 'CARRERA POPULAR', 'Domingo a las 10:00', 'deportivo', 2]
  ];
  var EJ_BANDERA = [
    ['integral', 'TU MARCA', 'Tu eslogan aquí', 'franjas', 0], ['integral', 'CLICK & COLLECT', 'Recoge en tienda', 'cristal', 1], ['integral', 'CAFETERÍA', 'Café de especialidad', 'dientes', 0],
    ['integral', 'FRUTA FRESCA', 'Zumos naturales', 'citricos', 0], ['integral', 'TECNOLOGÍA', 'Servicio técnico', 'cristal', 0], ['integral', 'PANADERÍA', 'Pan de leña', 'dientes', 1],
    ['integral', 'GIMNASIO', 'Matrícula gratis', 'franjas', 1], ['integral', 'HELADOS', 'Artesanos', 'citricos', 1], ['integral', 'TU MARCA', 'www.tuweb.com', 'cristal', 2],
    ['integral', 'TU MARCA', 'Calidad y confianza', 'cometa', 0], ['integral', 'ABIERTO', 'Cada día', 'cometa', 2], ['integral', 'TALLER', 'Mecánica rápida', 'llamas', 0],
    ['integral', 'FIESTA', 'Esta noche', 'diana', 0], ['integral', 'SURF SCHOOL', 'Clases todo el año', 'oleaje', 0], ['integral', 'VERANO', 'Chiringuito', 'solnaciente', 0],
    ['integral', 'INMOBILIARIA', 'Compra · Vende · Alquila', 'facetas', 0], ['integral', 'PROMOCIÓN', 'Entrega 2027', 'chevrones', 0], ['integral', 'GIMNASIO', 'Matrícula gratis', 'llamas', 3],
    ['integral', 'BIENVENIDOS', 'Os esperamos', 'diana', 1], ['integral', 'OFERTA', 'Solo esta semana', 'cometa', 1], ['integral', 'HELADOS', 'Artesanos', 'oleaje', 1],
    ['negocio', 'ABIERTO', '', 'cinta', 3], ['negocio', 'OPEN', '', 'clasico', 0], ['negocio', 'BIENVENIDOS', '', 'azul', 0],
    ['ofertas', 'REBAJAS', '-50%', 'oferta', 0], ['ofertas', 'OFERTA', 'Solo esta semana', 'rayos', 1], ['ofertas', 'SE VENDE', '', 'cinta', 1],
    ['ofertas', 'SE ALQUILA', '', 'oferta', 1], ['negocio', 'MENÚ DEL DÍA', 'Desde 12,90 €', 'mercado', 0],
    ['playa', 'CHIRINGUITO', 'Abierto todo el día', 'playa', 0], ['playa', 'BEACH BAR', '', 'verano', 0], ['playa', 'SURF SCHOOL', 'Clases todo el año', 'playa', 3],
    ['playa', 'HELADOS', 'Artesanos', 'toldo', 0], ['ferias', 'STAND 12', 'Feria 2026', 'expo', 0], ['ferias', 'FERIA', 'Del 10 al 13', 'banderines', 0],
    ['ferias', 'ARTESANÍA', 'Mercadillo', 'mercado', 0], ['coches', 'VENTA DE COCHES', 'Financiación', 'coches', 0],
    ['coches', 'KM 0', 'Entrega inmediata', 'faros', 0], ['coches', 'OCASIÓN', 'Seminuevos', 'coches', 1],
    ['fiestas', 'FIESTA', 'Esta noche', 'noche', 0], ['deporte', 'VAMOS EQUIPO', '', 'deportivo', 0], ['negocio', 'INAUGURACIÓN', 'Este sábado', 'oferta', 1],
    ['naturaleza', 'MONTAÑA', 'Rutas guiadas', 'montana', 0], ['naturaleza', 'DEL CAMPO', 'Producto local', 'campo', 0], ['ciudad', 'SE VENDE', 'Casa con jardín', 'casas', 0],
    ['ciudad', 'LOFTS', 'Obra nueva', 'ciudad', 0], ['navidad', 'FELIZ NAVIDAD', '', 'navidad', 0], ['navidad', 'HALLOWEEN', 'Noche de miedo', 'halloween', 0],
    ['bares', 'CAFÉ', 'Especialidad', 'cafe', 0], ['bares', 'BARBERÍA', 'Corte y barba', 'barberia', 0], ['deporte', 'GIMNASIO', 'Matrícula gratis', 'gimnasio', 0]
  ];
  var IDEAS_CAT = {
    playa: ['CHIRINGUITO', 'BEACH BAR', 'SURF SCHOOL', 'HELADOS', 'HAMACAS', 'SOMBRILLAS', 'ALQUILER', 'ABIERTO'],
    ferias: ['FERIA', 'STAND', 'BIENVENIDOS', 'ARTESANÍA', 'MERCADILLO', 'GASTRONOMÍA', 'FERIA DEL LIBRO', 'ENTRADA'],
    coches: ['VENTA DE COCHES', 'COMPRAMOS TU COCHE', 'OCASIÓN', 'KM 0', 'SEMINUEVOS', 'FINANCIACIÓN', 'TALLER', 'SE VENDE'],
    ofertas: ['REBAJAS', 'OFERTA', '-50%', 'OUTLET', 'LIQUIDACIÓN', 'NUEVO', 'SE VENDE', 'SE ALQUILA']
  };

  var VISTAS = /^image\/(png|jpe?g|webp)$/i;
  var EXT_OK = /\.(png|jpe?g|webp|pdf|ai|eps|psd)$/i;

  function eur(n) {
    return (Math.round(n * 100) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function cm(n) { return (Math.round(n * 10) / 10).toLocaleString('es-ES') + ' cm'; }

  function Bandera(raiz) {
    this.velo = document.querySelector('[data-bnd-velo]');          // la pantalla de carga que ya trae la página
    this.raiz = raiz;
    this.app = raiz.querySelector('[data-bnd-app]');
    this.cfg = JSON.parse(raiz.querySelector('[data-bnd-config]').textContent);
    this.formas = window.BanderasFormas || {};
    this.esPancarta = this.cfg.forma === 'pancarta';
    this.etqTalla = this.cfg.opTalla || 'Talla';
    this.etqBase = this.cfg.opBase || 'Base';
    this.esPhoto = this.cfg.objeto === 'photocall';
    this.esMantel = this.cfg.objeto === 'mantel';
    this.obj = this.esPhoto ? 'photocall' : (this.esMantel ? 'mantel' : (this.esPancarta ? 'pancarta' : 'bandera'));
    this.iTalla = this.cfg.opciones.indexOf(this.etqTalla);
    this.iBase = this.cfg.opciones.indexOf(this.etqBase);
    this.tallas = [];
    this.bases = [];
    var self = this;
    this.cfg.variantes.forEach(function (v) {
      var t = v.opts[self.iTalla], b = v.opts[self.iBase];
      if (self.tallas.indexOf(t) === -1) self.tallas.push(t);
      if (self.bases.indexOf(b) === -1) self.bases.push(b);
    });
    this.talla = this.tallas[0];
    // la que va por defecto (Xavi, 02/10): cruceta con flotador, y la primera de la lista
    var pref = this.bases.indexOf('Cruceta con flotador');
    if (pref > 0) { this.bases.splice(pref, 1); this.bases.unshift('Cruceta con flotador'); }
    this.base = this.bases[0];
    this.archivo = null;
    this.fondo = '#ffffff';   // color de la tela
    this.degradado = null;    // colores del degradado, si el fondo lo es
    this.gradTipo = 'v';      // v vertical, d diagonal, r radial
    this.textura = ''; this.tono = 'a';   // textura elegida y su tono (a = automático, c = clara, o = oscura)
    this.adornos = true;      // los adornos del estilo (franjas, olas...) se pueden quitar
    this.via = 'crear';       // 'crear' (estilos y texto) o 'propio' (ya tengo mi diseño preparado)
    this.fondoElegido = false; // ¿ha elegido color el cliente? (con color se puede comprar sin subir diseño)
    this.modo = 'cubrir';     // cubrir: la imagen llena la bandera · logo: pequeña y centrada
    this.transp = 0;
    this.layout = null;       // composición activa (de un estilo); null = "Llenar" o "Logo centrado" a mano
    this.estilo = null; this.vari = 0; this.pal = null; this.cat = '';
    this.fuente = 'anton'; this.fuente2 = 'barlow'; this.esp2 = 0.18; this.may2 = true; this.colorTexto = '#111111'; this.t1Vertical = false;
    this.capas = [];          // CAPAS LIBRES: textos e imágenes que se mueven, giran y cambian de tamaño (como la taza y la camiseta)
    this.selId = 'fondo'; this._cid = 0;
    this._rt = {};            // texto ya dibujado (caché de la vista previa)
    this.img = null;          // HTMLImageElement si hay vista previa
    this.zoom = 1;
    this.vista = null;        // { x, y, w } de la imagen, en cm sobre la caja de corte
    this.cant = 1;
    this.ocupado = false;
    this.pintarUI();
    this.iniciarCrea();
    this.pintarBases();
    this.montarEnGaleria();
    this.montarFull();
    this.dibujar();
    this.actualizar();
    this.iniciarHistoria();
    this.arranque();
  }

  Bandera.prototype.claveForma = function () {
    if (this.esPancarta) {
      var d = String(this.talla).match(/(\d+)\s*[×x]\s*(\d+)/);
      return 'pancarta_' + (d ? d[1] + 'x' + d[2] : '100x50');
    }
    var letra = String(this.talla).split(/[\s·]/)[0].toLowerCase();
    return this.cfg.forma + '_' + letra;
  };
  Bandera.prototype.forma = function () {
    var c = this.claveForma();
    if (!this.formas[c] && this.esPancarta) {
      // pancarta rectangular: el corte es la medida; 3 cm por dentro queda la zona de dobladillo y ollaos
      var m = c.match(/pancarta_(\d+)x(\d+)/), w = Number(m[1]), h = Number(m[2]), q = this.esPhoto ? 6 : 3;
      this.formas[c] = { w: w, h: h,
        cut: 'M0 0L' + w + ' 0L' + w + ' ' + h + 'L0 ' + h + 'Z',
        safe: 'M' + q + ' ' + q + 'L' + (w - q) + ' ' + q + 'L' + (w - q) + ' ' + (h - q) + 'L' + q + ' ' + (h - q) + 'Z',
        safeBox: [q, q, w - 2 * q, h - 2 * q] };
    }
    return this.formas[c];
  };
  Bandera.prototype.variante = function () {
    var self = this;
    return this.cfg.variantes.filter(function (v) {
      return v.opts[self.iTalla] === self.talla && v.opts[self.iBase] === self.base;
    })[0];
  };

  Bandera.prototype.pintarUI = function () {
    var self = this;
    var h = '';
    h += '<div class="bnd__paso" data-o="1"><p class="bnd__t bnd__paso-t"><i>1</i>' + (this.esPancarta ? 'Elige la medida <small>(ancho × alto)</small>' : 'Elige la talla') + '</p><div class="bnd__tallas" data-tallas></div><p class="bnd__medida" data-medida></p></div>';
    h += '<div class="bnd__paso" data-o="5"><p class="bnd__t bnd__paso-t"><i>3</i>' + (this.esPhoto ? 'Qué incluye' : (this.esMantel ? 'Elige la tela <small>(normal o impermeable)</small>' : this.esPancarta ? 'Elige el acabado <small>(tela y ollaos)</small>' : 'Elige la base <small>(la bandera necesita una para sostenerse)</small>')) + '</p>' +
         '<div class="bnd__bases" data-bases></div><p class="bnd__base-desc" data-base-desc></p></div>';
    h += '<div class="bnd__editor" data-editor data-o="2">';
    h += '<p class="bnd__t bnd__paso-t"><i>2</i>Diseña tu ' + this.obj + '</p>' +
         '<div class="bnd__via bnd__tabs" data-via role="tablist">' +
         '<button type="button" class="bnd__via-b is-on" data-via-b="crear" role="tab">Crear mi diseño</button>' +
         '<button type="button" class="bnd__via-b" data-via-b="propio" role="tab">Subir mi diseño</button></div>' +
         '<p class="bnd__plantilla" data-plantilla hidden><a data-plantilla-a href="#" download>⬇ Descargar la guía de esta talla (PDF)</a>' +
         '<small>Línea amarilla = corte (el color llega hasta ella). Línea roja = zona segura. Entrégalo sin las líneas.</small></p>' +
         '<div class="bnd__cta" data-cta><button type="button" class="bnd__cta-b" data-abrir-full><b>🎨 Diseñar mi ' + this.obj + '</b><span data-cta-t>Pantalla completa: más sitio para diseñar</span></button></div>';
    h += '<div class="bnd__paso" data-lienzo-paso data-o="2">' +
         '<p class="bnd__t">Así queda tu ' + this.obj + ' <small data-ayuda>pulsa para subir tu diseño</small></p>' +
         '<div class="bnd__lienzo-wrap"><div class="bnd__vista" data-vista hidden>' +
         '<button type="button" class="is-on" data-ver="diseno">Mi diseño</button><button type="button" data-ver="foto">Foto del producto</button></div>' +
         '<div class="bnd__zoombtns" data-zoombtns><button type="button" data-zm="1" aria-label="Acercar">＋</button><button type="button" data-zm="-1" aria-label="Alejar">－</button></div>' +
         '<div class="bnd__lienzo"><div class="bnd__cv"><canvas class="bnd__canvas is-vacio" data-canvas></canvas><div class="bnd__tactil" data-tactil hidden></div></div>' +
         '<div class="bnd__leyenda"><span><i class="corte"></i>Línea de corte</span><span><i class="seg"></i>Zona segura: nada importante fuera</span></div>' +
         '</div><div class="bnd__aviso" data-aviso hidden></div></div></div>';
    h += '<div class="bnd__paso" data-crea-paso data-o="3"><p class="bnd__sub">Plantillas de ejemplo <small>(traen fondo y textos: un clic y luego lo cambias todo)</small></p><div class="bnd__cats" data-cats></div><div class="bnd__ejemplos" data-ejemplos></div></div>';
    h += '<div class="bnd__herr" data-herr data-o="3">' +
         '<div class="bnd__zoom" data-zoomfila hidden><span>Zoom del diseño</span><input type="range" min="100" max="400" value="100" step="1" data-zoom><span data-zoomv>100 %</span></div>' +
         '<div class="bnd__modos" data-modos hidden><button type="button" class="is-on" data-modo="cubrir">Llenar la ' + this.obj + '</button><button type="button" data-modo="logo">Logo centrado</button></div></div>';
    h += '<div class="bnd__paso bnd__capas-paso" data-capas-paso data-o="3"><p class="bnd__sub">Lo que has añadido <small>(el fondo, y encima tus textos e imágenes: arrastra, gira y cambia el tamaño como quieras)</small></p><div class="bnd__capas" data-capas></div></div>';
    h += '<div hidden data-fondo-holder><div class="bnd__fondo-caja" data-fondo-caja>' +
         '<p class="bnd__sub">Fondos <small>(cada uno con 4 combinaciones de color; solo cambian el fondo, tus textos se quedan)</small></p><div class="bnd__estilos" data-estilos></div>' +
         '<p class="bnd__sub">O monta el tuyo</p>' +
         '<div class="bnd__fondo"><span class="bnd__fondo-t">Color de fondo</span><div class="bnd__sw" data-sw></div>' +
         '<label class="bnd__pers" title="Otro color">Otro <input type="color" value="#1fb324" data-color></label></div>' +
         '<div class="bnd__fondo"><span class="bnd__fondo-t">Degradados</span><div class="bnd__sw" data-sg></div></div>' +
         '<div class="bnd__fondo"><span class="bnd__fondo-t">Texturas</span><div class="bnd__sw" data-stx></div>' +
         '<span class="bnd__tono" data-tono hidden><button type="button" data-tn="c">Clara</button><button type="button" data-tn="o">Oscura</button></span></div>' +
         '<label class="bnd__check" data-adornos-fila><input type="checkbox" data-adornos checked> Adornos del estilo (franjas, olas…)</label></div></div>';
    h += '<div class="bnd__paso" data-sube-paso data-o="4"><p class="bnd__t" data-sube-t>Sube tu logo <small>(opcional)</small></p>' +
         '<label class="bnd__drop" data-drop><input type="file" accept=".png,.jpg,.jpeg,.webp,.pdf,.ai,.eps,.psd,image/png,image/jpeg,image/webp" data-file>' +
         '<strong>Sube tu logo</strong><span>JPG, PNG o WEBP hasta ' + this.cfg.maxMbImagen + ' MB · PDF, AI, EPS o PSD hasta ' + this.cfg.maxMb + ' MB</span></label>' +
         '<div class="bnd__archivo" data-archivo hidden><span class="bnd__archivo-n" data-nombre></span>' +
         '<button type="button" data-cambiar>Cambiar</button><button type="button" class="bnd__quitar" data-quitar>Quitar diseño</button></div>' +
         '</div>';
    h += '</div>';
    h += '<p class="bnd__t bnd__paso-t" data-o="6"><i>4</i>Tu pedido</p>';
    h += '<div class="bnd__paso" data-o="6"><p class="bnd__sub">Observaciones <small>(opcional)</small></p>' +
         '<textarea class="bnd__obs" data-obs placeholder="Por ejemplo: el logo arriba, estos colores exactos, el texto en dos líneas…"></textarea></div>';
    h += '<div class="bnd__paso bnd__fila" data-o="7"><label class="bnd__cant">Cantidad <input type="number" min="1" max="99" value="1" data-cant></label>' +
         '<div class="bnd__precio" data-precio></div></div>';
    h += '<button type="button" class="bnd__comprar" data-comprar data-o="8">Añadir al carrito</button>';
    if (this.cfg.presupuestoUrl) {
      h += '<button type="button" class="bnd__presupuesto" data-presupuesto data-o="8">Crear presupuesto</button>' +
           '<p class="bnd__presupuesto-nota" data-presupuesto-nota data-o="8" hidden></p>';
    }
    h += '<p class="bnd__plazo" data-o="9">Entrega estimada: <strong>' + this.cfg.plazo + '</strong>. Envío incluido. ' + (this.esPhoto ? 'Estructura de aluminio y bolsa de transporte incluidas.' : (this.esMantel ? 'Con dobladillo cosido alrededor.' : this.esPancarta ? 'Cada pancarta lleva la etiqueta imprimirlo.com.' : 'Cada bandera lleva la etiqueta imprimirlo.com cosida.')) + '</p>';
    var prod = (document.title || '').split('|')[0].trim();
    h += '<p class="bnd__wa" data-o="9"><a target="_blank" rel="noopener" href="https://wa.me/34934358257?text=' + encodeURIComponent('Hola, quiero presupuesto para varias unidades o una medida especial de: ' + prod) + '">💬 ¿Varias unidades, empresa o medida especial? Pide presupuesto por WhatsApp</a></p>';
    h += '<p class="bnd__error" data-error data-o="10" hidden></p>';
    this.app.innerHTML = h;

    // la caja de la vista previa puede estar fuera de la app (en la columna de la foto): se busca también ahí
    this.$ = function (s) { return self.app.querySelector(s) || (self.ov && self.ov.querySelector(s)) || (self.lienzoPaso && self.lienzoPaso.querySelector(s)) || (self.rail && self.rail.querySelector(s)) || (self.modal && self.modal.querySelector(s)) || (self.modalF && self.modalF.querySelector(s)); };
    this.raices = function () { return [self.app, self.lienzoPaso, self.ov, self.rail, self.modal, self.modalF].filter(Boolean); };
    this.lienzoPaso = this.$('[data-lienzo-paso]');
    this.cv = this.$('[data-canvas]');
    this.cv.addEventListener('click', function () { if (self.via === 'propio' && !self.img) self.$('[data-file]').click(); });
    [].forEach.call(this.app.querySelectorAll('[data-ver]'), function () {});
    this.ctx = this.cv.getContext('2d');
    [].forEach.call(this.lienzoPaso.querySelectorAll('[data-zm]'), function (b) { b.addEventListener('click', function () { self.zoomBoton(Number(b.getAttribute('data-zm'))); }); });

    var cont = this.$('[data-tallas]');
    this.tallas.forEach(function (t) {
      var partes = self.esPancarta ? String(t).replace(/\s*cm$/, '|cm').split('|') : String(t).split('·');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bnd__talla'; b.setAttribute('data-t', t);
      var esVela = self.cfg.forma === 'gota' || self.cfg.forma === 'surf';       // en gota y surf la cifra es la altura TOTAL con mástil
      b.innerHTML = '<b>' + partes[0].trim() + '</b><span>' + (partes[1] || '').trim() + (esVela && partes[1] ? '<small class="bnd__tot"> total</small>' : '') + '</span>';
      b.addEventListener('click', function () { self.cambiarTalla(t); });
      cont.appendChild(b);
    });
    this.$('[data-file]').addEventListener('change', function (e) { if (e.target.files[0]) { self.cargar(e.target.files[0]); e.target.value = ''; } });
    this.$('[data-zoom]').addEventListener('input', function (e) { self.cambiarZoom(Number(e.target.value) / 100); });
    this.$('[data-cant]').addEventListener('input', function (e) {
      self.cant = Math.max(1, Math.min(99, Math.floor(Number(e.target.value)) || 1)); self.actualizar();
    });
    this.$('[data-comprar]').addEventListener('click', function () { self.alCarrito(); });
    var bPres = this.$('[data-presupuesto]');
    if (bPres) bPres.addEventListener('click', function () { self.alCarrito('pres'); });
    var sw = this.$('[data-sw]');
    ['#ffffff', '#111111', '#1fb324', '#ffe500', '#e31b23', '#1d4ed8', '#f97316', '#6b7280'].forEach(function (c) {
      var bt = document.createElement('button');
      bt.type = 'button'; bt.className = 'bnd__color' + (c === '#ffffff' ? ' is-on' : ''); bt.style.background = c; bt.setAttribute('data-c', c); bt.title = c;
      bt.addEventListener('click', function () { self.ponerFondo(c); });
      sw.appendChild(bt);
    });
    this.$('[data-color]').addEventListener('input', function (e) { self.ponerFondo(e.target.value); });
    var sg = this.$('[data-sg]');
    DEGRADADOS.forEach(function (par) {
      var bt = document.createElement('button');
      bt.type = 'button'; bt.className = 'bnd__color bnd__color--g'; bt.setAttribute('data-g', par.c.join(','));
      bt.style.background = cssDeg(par); bt.title = 'Degradado';
      bt.addEventListener('click', function () { self.ponerDegradado(par); });
      sg.appendChild(bt);
    });
    var stx = this.$('[data-stx]');
    [['', 'Sin textura']].concat(TEXTURAS).forEach(function (t) {
      var bt = document.createElement('button');
      bt.type = 'button'; bt.className = 'bnd__color bnd__tex' + (t[0] ? '' : ' is-on'); bt.setAttribute('data-tx', t[0]); bt.title = t[1];
      if (t[0]) {
        var cv = document.createElement('canvas'); cv.width = cv.height = 60; var x = cv.getContext('2d');
        x.fillStyle = '#6b7280'; x.fillRect(0, 0, 60, 60);
        pintarTextura(x, 60, 60, { t: t[0], c: '#ffffff', a: 0.5 });
        bt.appendChild(cv);
      } else bt.textContent = '✕';
      bt.addEventListener('click', function () { self.ponerTextura(t[0]); });
      stx.appendChild(bt);
    });
    [].forEach.call(this.$('[data-tono]').querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () { self.tono = b.getAttribute('data-tn'); self.marcarFondo(); self.dibujar(); });
    });
    [].forEach.call(this.$('[data-modos]').querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () {
        self.modo = b.getAttribute('data-modo'); self.layout = null; self.estilo = null; self.marcarCrea();
        [].forEach.call(b.parentNode.querySelectorAll('button'), function (x) { x.classList.toggle('is-on', x === b); });
        if (self.img) { self.zoom = 1; self.$('[data-zoom]').value = 100; self.$('[data-zoomv]').textContent = '100 %'; self.encajar(); self.dibujar(); self.actualizar(); }
      });
    });
    this.$('[data-cambiar]').addEventListener('click', function () { self.$('[data-file]').click(); });
    this.$('[data-quitar]').addEventListener('click', function () { self.quitar(); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      self.$('[data-drop]').addEventListener(ev, function (e) { e.preventDefault(); });
    });
    this.$('[data-drop]').addEventListener('drop', function (e) {
      e.preventDefault(); if (e.dataTransfer.files[0]) self.cargar(e.dataTransfer.files[0]);
    });
    // CAPAS LIBRES: se elige una capa tocándola; sus 4 esquinas mueven (arriba izq.), giran (arriba dcha.), cambian el tamaño
    // (abajo dcha.) y borran (abajo izq.). En el móvil, el dedo solo agarra sobre la FORMA de la bandera (el resto baja la página);
    // por eso el panel de debajo tiene también el tamaño, el giro y los botones.
    var g = null;
    this.tactil = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    this.cv.style.touchAction = 'pan-y';
    this.capa = this.$('[data-tactil]');
    var capa = this.capa;
    capa.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var dedos = {}, pinza = null, vacio = null;
    function dist2() { var k = Object.keys(dedos); if (k.length < 2) return null; var a = dedos[k[0]], b = dedos[k[1]]; return { d: Math.hypot(b.x - a.x, b.y - a.y) || 1, an: Math.atan2(b.y - a.y, b.x - a.x), mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 }; }
    capa.addEventListener('pointerdown', function (e) {
      if (self.via === 'propio') { e.preventDefault(); return self.empezarLegacy(e); }
      e.preventDefault();
      // móvil, vista pequeña de la ficha: tocar la bandera abre el editor a pantalla completa (ahí se diseña y se acerca)
      if (!self.full && self.ov && window.matchMedia && window.matchMedia('(max-width: 989px)').matches) { self.abrirFull(); return; }
      dedos[e.pointerId] = { x: e.clientX, y: e.clientY };
      var cs = self.capaSel();
      if (Object.keys(dedos).length === 2 && cs) {                    // dos dedos: pellizcar cambia tamaño y giro, y se mueve con los dos
        var m = dist2(); g = null; vacio = null;
        pinza = { id: cs.id, d0: m.d, a0: m.an, mx: m.mx, my: m.my, w0: cs.w, r0: cs.rot || 0, ox: cs.cx, oy: cs.cy };
        try { capa.setPointerCapture(e.pointerId); } catch (x) { /* nada */ }
        return;
      }
      var pt = self.aCm(e), sel = self.capaSel(), asa = sel ? self.asaEn(sel, pt) : null;
      if (asa === 'borrar') { self.borrarCapa(sel); return; }
      if (asa) {
        var d0 = Math.hypot(pt.x - sel.cx, pt.y - sel.cy) || 1;
        g = { modo: asa, id: sel.id, sx: e.clientX, sy: e.clientY, ox: sel.cx, oy: sel.cy, d0: d0, w0: sel.w, a0: Math.atan2(pt.y - sel.cy, pt.x - sel.cx), r0: sel.rot || 0 };
        capa.setPointerCapture(e.pointerId); return;
      }
      var c = self.capaEn(pt);
      if (!c) {
        // tocar el hueco quita la selección y aleja al soltar; si se desliza con la vista cerca, mueve la vista
        if (self.selId == null && !(self.vz && self.vz.z > 1.001)) return;
        vacio = { x: e.clientX, y: e.clientY };
        try { capa.setPointerCapture(e.pointerId); } catch (x) { /* nada */ }
        return;
      }
      if (self.selId !== c.id) { self.selId = c.id; self.pintarPanel(); self.zoomCapa(c); }
      else if (!(self.vz && self.vz.z > 1.001)) self.zoomCapa(c);
      g = { modo: 'mover', id: c.id, sx: e.clientX, sy: e.clientY, ox: c.cx, oy: c.cy };
      capa.setPointerCapture(e.pointerId);
      self.dibujar();
    });
    capa.addEventListener('pointermove', function (e) {
      if (self.via === 'propio') return self.moverLegacy(e);
      if (dedos[e.pointerId]) dedos[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (pinza) {
        var pc = self.capaPorId(pinza.id), m2 = dist2(); if (!pc || !m2) return;
        var fo2 = self.forma(), k2 = self.escala, f2 = self.factorCss();
        pc.w = Math.max(2, Math.min(Math.max(fo2.w, fo2.h) * 1.6, pinza.w0 * m2.d / pinza.d0));
        pc.rot = pinza.r0 + (m2.an - pinza.a0);
        pc.cx = Math.max(0, Math.min(fo2.w, pinza.ox + (m2.mx - pinza.mx) * f2 / k2)); pc.cy = Math.max(0, Math.min(fo2.h, pinza.oy + (m2.my - pinza.my) * f2 / k2));
        pc.auto = false; pc.cubrir = false; self.sincPanel(); self.dibujar(); return;
      }
      if (vacio && self.vz && self.vz.z > 1.001 && Math.hypot(e.clientX - vacio.x, e.clientY - vacio.y) > 10) {
        g = { modo: 'panear', sx: vacio.x, sy: vacio.y, fx0: self.vz.fx, fy0: self.vz.fy }; vacio = null;
      }
      if (g && g.modo === 'panear') {
        cancelAnimationFrame(self._raf);
        self.vz.fx = g.fx0 - (e.clientX - g.sx) * self.factorCss() / self.escala; self.vz.fy = g.fy0 - (e.clientY - g.sy) * self.factorCss() / self.escala;
        self.dibujar(); return;
      }
      if (!g) return;
      var c = self.capaPorId(g.id); if (!c) return;
      var k = self.escala, f = self.factorCss(), fo = self.forma(), pt = self.aCm(e);
      if (g.modo === 'mover') {
        c.cx = Math.max(0, Math.min(fo.w, g.ox + (e.clientX - g.sx) * f / k)); c.cy = Math.max(0, Math.min(fo.h, g.oy + (e.clientY - g.sy) * f / k));
      } else if (g.modo === 'girar') {
        var r = g.r0 + (Math.atan2(pt.y - c.cy, pt.x - c.cx) - g.a0), paso = Math.PI / 12, q = Math.round(r / paso) * paso;
        c.rot = Math.abs(r - q) < 0.07 ? q : r;                         // se pega a los giros de 15°
      } else if (g.modo === 'tamano') {
        c.w = Math.max(2, Math.min(Math.max(fo.w, fo.h) * 1.6, g.w0 * (Math.hypot(pt.x - c.cx, pt.y - c.cy) / g.d0)));
      }
      c.auto = false; c.cubrir = false;
      self.sincPanel(); self.dibujar();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      capa.addEventListener(ev, function (e) {
        if (self.via === 'propio') self.soltarLegacy(e);
        delete dedos[e.pointerId];
        if (vacio && ev === 'pointerup' && Math.hypot(e.clientX - vacio.x, e.clientY - vacio.y) < 10) { vacio = null; self.selId = null; self.pintarPanel(); self.vistaA(1); return; }
        vacio = null;
        if (pinza) { if (Object.keys(dedos).length < 2) { pinza = null; self.actualizar(); } return; }
        if (g) { g = null; self.actualizar(); }
      });
    });
    // doble clic: en un texto, escribir; en una imagen, cambiarla por otra
    capa.addEventListener('dblclick', function (e) {
      if (self.via === 'propio') { self.$('[data-file]').click(); return; }
      var c = self.capaEn(self.aCm(e)); if (!c) return;
      self.selId = c.id; self.pintarPanel(); self.dibujar();
      if (c.tipo === 'img') { self._reemplazar = c.id; var fi = self.$('[data-file-capa]'); if (fi) fi.click(); }
      else { var ta = self.$('[data-o-texto]'); if (ta) { ta.focus(); ta.select(); } }
    });
    // Suprimir / Borrar quita la capa elegida; las flechas la mueven (Mayús = más)
    document.addEventListener('keydown', function (e) {
      var el = document.activeElement;
      if (el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable)) return;
      if (self.via === 'propio') { if ((e.key === 'Delete' || e.key === 'Backspace') && self.img) { e.preventDefault(); self.quitar(); } return; }
      var c = self.capaSel(); if (!c) return;
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); self.borrarCapa(c); return; }
      var m = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
      if (m) { e.preventDefault(); var st = e.shiftKey ? 5 : 0.5; c.cx += m[0] * st; c.cy += m[1] * st; c.auto = false; self.dibujar(); self.actualizar(); }
    });
    // tocar fuera de la bandera y del panel quita la selección
    document.addEventListener('pointerdown', function (e) {
      if (self.via === 'propio' || self.selId == null) return;
      var dentro = (e.target.closest && e.target.closest('.qf, .bnd-velo, .bnd__rail, .bnd__modal')) || (self.capa && self.capa.contains(e.target)) || self.raiz.contains(e.target) || (self.ov && self.ov.contains(e.target)) || (self.lienzoPaso && self.lienzoPaso.contains(e.target));
      if (!dentro) { self.selId = null; self.pintarPanel(); self.dibujar(); }
    });
    capa.addEventListener('wheel', function (e) {
      if (self.via === 'propio') { if (!self.img) return; e.preventDefault(); self.cambiarZoom(self.zoom * (e.deltaY < 0 ? 1.06 : 1 / 1.06)); return; }
      var c = self.capaSel(); if (!c) return;
      e.preventDefault();
      c.w = Math.max(2, Math.min(Math.max(self.forma().w, self.forma().h) * 1.6, c.w * (e.deltaY < 0 ? 1.06 : 1 / 1.06))); c.auto = false; c.cubrir = false;
      self.sincPanel(); self.dibujar();
    }, { passive: false });
  };


  /* ------------------------------------------------------------------ CREA TU BANDERA (estilos y texto) ------ */

  /* ================================================================ CAPAS LIBRES ======================================
     Cada capa es un texto o una imagen con su centro (cx, cy), su ancho (w, en cm), su giro (rot, radianes) y su orden
     (el de la lista: la última queda encima). Las del estilo (slot t1, t2, logo, con auto) se recolocan solas al cambiar
     de estilo o de talla; en cuanto el cliente las toca, pasan a ser suyas. */
  Bandera.prototype.esReal = function (c) { return !c.oculta && (c.tipo === 'img' || (!c.muestra && !!String(c.texto || '').trim())); };
  Bandera.prototype.esFantasma = function (c) { return c.tipo === 'txt' && (c.muestra || !String(c.texto || '').trim()); };
  Bandera.prototype.capaPorId = function (id) { for (var i = 0; i < this.capas.length; i++) if (this.capas[i].id === id) return this.capas[i]; return null; };
  Bandera.prototype.capaSel = function () { return this.selId != null ? this.capaPorId(this.selId) : null; };
  Bandera.prototype.capaSlot = function (slot) { for (var i = 0; i < this.capas.length; i++) if (this.capas[i].slot === slot) return this.capas[i]; return null; };
  Bandera.prototype.textoReal = function () { return this.capas.some(function (c) { return c.tipo === 'txt' && !c.muestra && !!String(c.texto || '').trim(); }); };
  Bandera.prototype.hayDiseno = function () {
    if (this.via === 'propio') return !!this.archivo;
    return this.capas.some(this.esReal, this);
  };
  Bandera.prototype.textoCapa = function (c) {
    var t = String(c.texto || '').replace(/[ \t]+/g, ' ').replace(/\n{3,}/g, '\n\n').trim();
    return t || (c.muestra ? MUESTRA : 'Escribe aquí');
  };
  Bandera.prototype.nuevaCapaTxt = function (o) {
    var c = { id: ++this._cid, tipo: 'txt', texto: '', fuente: this.fuente, color: this.colorTexto, grosor: 1, esp: 0, mayus: false, sub: false,
      slot: null, auto: false, muestra: false, cx: 0, cy: 0, w: 10, rot: 0 };
    for (var k in o) c[k] = o[k];
    return c;
  };
  // un texto dibujado (con la letra, el grosor y el color de SU capa); se guarda para no repetirlo en cada movimiento
  Bandera.prototype.rcapa = function (c) {
    var txt = this.textoCapa(c);
    var key = [txt, c.fuente, c.color, c.grosor, c.esp, c.mayus ? 1 : 0, c.sub ? 1 : 0].join('|');
    if (c._k !== key) {
      var r = window.Texto && Texto.pinta(txt, this.opcCapa(c, { cajaCm: [60, 60], ppp: 60 }));
      c._c = r ? r.lienzo : null; c._k = key;
    }
    return c._c;
  };
  Bandera.prototype.opcCapa = function (c, base) {
    var o = base || {};
    o.fuentes = FUENTES_B; o.fuente = c.fuente; o.color = c.color; o.maxLineas = 3;
    o.grosor = GROSORES[c.grosor == null ? 1 : c.grosor][c.sub ? 1 : 0];
    o.espaciado = c.esp || 0; o.mayus = !!c.mayus;
    return o;
  };
  Bandera.prototype.dimCapa = function (c) {
    if (c.tipo === 'img') return { w: c.w, h: c.w * c.nh / c.nw };
    var k = this.rcapa(c); return { w: c.w, h: k ? c.w * k.height / k.width : 0 };
  };

  // las letras se descargan la primera vez que alguien las toca (no antes: casi todos suben un logo y ya)
  Bandera.prototype.cargarFuentes = function () {
    var self = this;
    if (this._fuentesOk || !window.Texto) return;
    this._fuentesOk = true;
    function refrescar() { self.capas.forEach(function (c) { c._k = null; }); self.pintarEstilos(); self.disponer(); self.dibujar(); }
    Texto.cargar(FUENTES_B).then(function () {
      self._fontsListas = true;
      if (self._velFuentes) { self._velFuentes = false; self.progreso(100, '¡Letras listas!'); setTimeout(function () { self.progreso(false); }, 250); }
      refrescar();
      // si alguna tipografía tardó más de lo esperado (móvil lento), se vuelve a dibujar cuando estén todas
      if (document.fonts && document.fonts.load) {
        Promise.all(FUENTES_B.map(function (f) { return document.fonts.load((f.peso || '400') + ' 40px "' + Texto.familia(f) + '"').catch(function () { return null; }); })).then(refrescar);
      }
    });
  };

  /* «Subir mi diseño»: la imagen es la bandera entera y se arrastra de una vez; es el camino de siempre. */
  Bandera.prototype.empezarLegacy = function (e) {
    if (!this.img || !this.vista) return;
    this._lg = { sx: e.clientX, sy: e.clientY, ox: this.vista.x, oy: this.vista.y };
    this.capa.setPointerCapture(e.pointerId);
  };
  Bandera.prototype.moverLegacy = function (e) {
    var g = this._lg; if (!g || !this.vista) return;
    var k = this.escala, f = this.factorCss();
    this.vista.x = g.ox + (e.clientX - g.sx) * f / k; this.vista.y = g.oy + (e.clientY - g.sy) * f / k;
    this.dibujar();
  };
  Bandera.prototype.soltarLegacy = function () { this._lg = null; };

  /* El perfil de la zona segura: para cada altura (cada cm), dónde empieza y dónde acaba la bandera. Se calcula UNA vez
     por talla; luego "cuánto ancho hay entre estas dos alturas" es mirar la lista. */
  Bandera.prototype.perfil = function () {
    var fo = this.forma(), sb = fo.safeBox, clave = this.claveForma();
    this._perf = this._perf || {};
    if (this._perf[clave]) return this._perf[clave];
    var path = new Path2D(fo.safe), c = this._ctxT || (this._ctxT = document.createElement('canvas').getContext('2d'));
    var filas = [];
    for (var y = sb[1]; y <= sb[1] + sb[3]; y += 1) {
      var l = null, r = null;
      for (var x = sb[0]; x <= sb[0] + sb[2]; x += 0.5) { if (c.isPointInPath(path, x, y)) { if (l === null) l = x; r = x; } }
      filas.push({ y: y, l: l, r: r });
    }
    return (this._perf[clave] = filas);
  };
  Bandera.prototype.zona = function (yA, yB) {
    var fo = this.forma(), sb = fo.safeBox, filas = this.perfil();
    var x0 = -1e9, x1 = 1e9, mejor = null;
    filas.forEach(function (f) {
      if (f.l === null || f.y < yA - 0.5 || f.y > yB + 0.5) return;
      if (f.l > x0) x0 = f.l; if (f.r < x1) x1 = f.r;
      if (!mejor || f.r - f.l > mejor.w) mejor = { x0: f.l, x1: f.r, w: f.r - f.l };
    });
    if (x1 <= x0) { if (mejor) { x0 = mejor.x0; x1 = mejor.x1; } else { x0 = sb[0]; x1 = sb[0] + sb[2]; } }
    if (this._xr) { x0 = Math.max(x0, this._xr[0]); x1 = Math.min(x1, this._xr[1]); if (x1 <= x0) { x0 = this._xr[0]; x1 = this._xr[1]; } }
    return { x0: x0, x1: x1, cx: (x0 + x1) / 2, w: x1 - x0 };
  };

  /* Un elemento horizontal (texto o logo) dentro de una banda: busca la altura donde cabe más grande, mirando solo las
     filas que ocupa de verdad (no toda la banda). aspecto = alto / ancho del elemento; relleno = cuánto del ancho libre. */
  Bandera.prototype.ajusteH = function (yA, yB, aspecto, relleno) {
    var mejor = null, paso = Math.max(1, (yB - yA) / 24), self = this;
    for (var yc = yA; yc <= yB + 0.01; yc += paso) {
      // el mayor ancho w tal que, con su alto, el elemento cabe en lo que la forma deja libre a esas filas
      var tope = Math.min((yB - yA) / aspecto * 0.95, 2 * Math.min(yc - yA, yB - yc) / aspecto + 0.001);
      if (tope <= 0) continue;
      var lo = 0, hi = tope;
      for (var n = 0; n < 16; n++) {
        var w = (lo + hi) / 2, h = w * aspecto, z = self.zona(yc - h / 2, yc + h / 2);
        if (w <= z.w * relleno) lo = w; else hi = w;
      }
      var hf = lo * aspecto, zf = self.zona(yc - hf / 2, yc + hf / 2);
      if (!mejor || lo > mejor.w + 0.01) mejor = { w: lo, cx: zf.cx, cy: yc };
    }
    return mejor || { w: 1, cx: this.forma().safeBox[0] + this.forma().safeBox[2] / 2, cy: (yA + yB) / 2 };
  };

  /* ¿Cabe un rectángulo (largo L, grosor L*r, girado ang) en la zona segura? Mira el perfil por filas (rápido). */
  Bandera.prototype.cabeRot = function (cx, cy, L, r, phi, yMin, yMax) {
    var fo = this.forma(), sb = fo.safeBox, filas = this.perfil(), co = Math.cos(phi), si = Math.sin(phi), T = L * r;
    var hy = Math.abs(L / 2 * si) + Math.abs(T / 2 * co);
    if (cy - hy < yMin || cy + hy > yMax) return false;
    var nu = 6, nv = 2, i, j;
    for (i = 0; i <= nu; i++) for (j = 0; j <= nv; j++) {
      var u = (i / nu - 0.5) * L, v = (j / nv - 0.5) * T;
      var x = cx + u * co - v * si, y = cy + u * si + v * co, f = filas[Math.round(y - sb[1])];
      if (!f || f.l === null || x < f.l || x > f.r) return false;
    }
    return true;
  };
  /* El mayor texto vertical, con la inclinación que mejor siga la forma (ángulo extra sobre la vertical, en radianes). */
  Bandera.prototype.inclinar = function (r, yMin, yMax) {
    var sb = this.forma().safeBox, filas = this.perfil(), self = this, mejor = null, angs = [-24, -16, -8, 8, 16, 24];
    for (var cy = yMin; cy <= yMax; cy += Math.max(1, (yMax - yMin) / 14)) {
      var f = filas[Math.round(cy - sb[1])]; if (!f || f.l === null) continue;
      var cxs = [(f.l + f.r) / 2 - (f.r - f.l) * 0.1, (f.l + f.r) / 2, (f.l + f.r) / 2 + (f.r - f.l) * 0.1];
      for (var ci = 0; ci < cxs.length; ci++) for (var ai = 0; ai < angs.length; ai++) {
        var rot = angs[ai] * Math.PI / 180, phi = -Math.PI / 2 + rot, lo = 0, hi = yMax - yMin;
        if (mejor && !self.cabeRot(cxs[ci], cy, mejor.L * 1.01, r, phi, yMin, yMax)) continue;     // ni el mejor hasta ahora cabe: ni mirar
        for (var n = 0; n < 12; n++) { var m = (lo + hi) / 2; if (self.cabeRot(cxs[ci], cy, m, r, phi, yMin, yMax)) lo = m; else hi = m; }
        if (!mejor || lo > mejor.L) mejor = { L: lo, cx: cxs[ci], cy: cy, rot: rot };
      }
    }
    return mejor;
  };

  /* Dónde va cada cosa en una composición. it = lo que hay: { logo: proporción | null, t1: {r, vert}, t2: {r} } (r = alto
     / ancho del texto). Devuelve centros y anchos en cm. El texto vertical busca el tramo de la bandera donde cabe más
     grande: en una gota, la parte ancha de arriba y no la cola. */
  Bandera.prototype.colocar = function (nombre, it, escala) {
    var fo = this.forma(), sb = fo.safeBox, H = sb[3], self = this, out = {}, tabla = this.esPancarta ? LAYOUTS_ANCHO : ((this.cfg.forma === 'gota') ? LAYOUTS_GOTA : LAYOUTS);
    if (this.esPancarta && !tabla[nombre]) nombre = 'texto-grande';
    var slots = tabla[nombre] || [];
    var hay = {}; slots.forEach(function (c) { hay[c.l] = c; });
    slots.forEach(function (c) {
      if (c.l === 'logo') {
        if (!it.logo) return;
        var yA = sb[1] + c.b[0] * H, yB = sb[1] + c.b[1] * H;
        self._xr = c.x ? [sb[0] + c.x[0] * sb[2], sb[0] + c.x[1] * sb[2]] : null;
        var m = self.ajusteH(yA, yB, 1 / it.logo, 0.85); self._xr = null;
        out.logo = { cx: m.cx, cy: m.cy, w: m.w };
        return;
      }
      var q = it[c.l]; if (!q) return;
      if (q.vert) {
        var desde = 0.08;                                       // debajo de lo que ya esté arriba
        if (hay.logo && it.logo) desde = Math.max(desde, hay.logo.b[1] + 0.02);
        if (hay.t2 && it.t2) desde = Math.max(desde, hay.t2.b[1] + 0.02);
        var mejor = null;
        for (var y1 = desde; y1 <= 0.46; y1 += 0.04) {
          for (var y2 = y1 + 0.2; y2 <= 0.70; y2 += 0.04) {
            var a = sb[1] + y1 * H, b2 = sb[1] + y2 * H, z2 = self.zona(a, b2);
            var L = Math.min((b2 - a) * 0.95, z2.w * 0.9 / q.r);
            if (!mejor || L > mejor.L + 0.01) mejor = { L: L, cx: z2.cx, cy: (a + b2) / 2, rot: 0 };
          }
        }
        // el texto sigue el eje de la bandera: si inclinándolo (hasta 24°) cabe claramente más grande, se inclina
        var inc = self.inclinar(q.r, sb[1] + desde * H, sb[1] + 0.72 * H);
        if (inc && inc.L > mejor.L * 1.04) mejor = inc;
        out[c.l] = { cx: mejor.cx, cy: mejor.cy, w: mejor.L * escala, vert: true, rot: mejor.rot };
      } else {
        var yA2 = sb[1] + c.b[0] * H, yB2 = sb[1] + c.b[1] * H;
        var xx = c.x ? (it.logo ? c.x : [0.03, 0.97]) : null;       // sin logo, el texto usa todo el ancho
        self._xr = xx ? [sb[0] + xx[0] * sb[2], sb[0] + xx[1] * sb[2]] : null;
        var m2 = self.ajusteH(yA2, yB2, q.r, 0.92); self._xr = null;
        out[c.l] = { cx: m2.cx, cy: m2.cy, w: m2.w * escala, vert: false };
      }
    });
    return out;
  };

  /* Coloca logo y textos según la composición, con el tamaño que deja la forma de ESTA bandera. Lo que el cliente ya haya
     movido a mano se respeta (solo se reescala). */
  Bandera.prototype.disponer = function () {
    var fo = this.forma(); if (!fo || !fo.safeBox || !this.layout) return;
    var self = this, it = {}, L = {};
    ['t1', 't2', 'logo'].forEach(function (id) {
      var c = self.capaSlot(id); if (!c || !c.auto) return;
      L[id] = c;
      if (id === 'logo') { if (c.tipo === 'img') it.logo = c.nw / c.nh; return; }
      var k = self.rcapa(c); if (k) it[id] = { r: k.height / k.width, vert: id === 't1' && !!self.t1Vertical };
    });
    var pl = this.colocar(this.layout, it, 1);
    ['t1', 't2', 'logo'].forEach(function (id) {
      var c = L[id], q = pl[id]; if (!c) return;
      if (!q) { return; }
      c.cx = q.cx; c.cy = q.cy; c.w = q.w; c.rot = (q.vert ? -Math.PI / 2 : 0) + (q.rot || 0);
    });
  };

  Bandera.prototype.verDiseno = function () {     // si estaba la foto del producto, pasa al diseño al tocar cualquier opción
    if (this.ponerVista && this.verFoto) { this._vistaAuto = false; this.ponerVista(false); }
  };
  Bandera.prototype.aplicarEstilo = function (id, vi) {
    this.verDiseno();
    var e = ESTILOS.filter(function (x) { return x.id === id; })[0]; if (!e) return;
    vi = vi || 0; var v = e.vars[vi] || e.vars[0], self = this;
    this.estilo = id; this.vari = vi; this.pal = { P: v.p, S: v.s };
    this.layout = e.layout; this.modo = 'cubrir';
    var fs = fuentesDe(e.id); this.fuente = fs.f1; this.fuente2 = fs.f2; this.esp2 = fs.esp; this.may2 = fs.may; this.colorTexto = v.t; this.t1Vertical = (e.layout === 'vertical') && !this.esPancarta;
    // las capas del estilo (titular, subtítulo, logo) toman su letra y su color; las que el cliente haya añadido, no se tocan
    var t1 = this.capaSlot('t1');
    if (!t1) { t1 = this.nuevaCapaTxt({ slot: 't1', auto: true, muestra: true }); this.capas.push(t1); }
    var t2 = this.capaSlot('t2');
    [[t1, fs.f1, 0, false, false], [t2, fs.f2, fs.esp, fs.may, true]].forEach(function (q) {
      var c = q[0]; if (!c) return;
      c.fuente = q[1]; c.esp = q[2]; c.mayus = q[3]; c.sub = q[4]; c.color = v.t; c.auto = true; c.grosor = 1;
    });
    this.capas.forEach(function (c) { if (c.slot === 'logo') c.auto = true; });
    this.cargarFuentes();
    this.marcarCrea();
    var dg = degDe(e, v), tx = texDe(e, dg.c);
    this.textura = tx ? tx.t : ''; this.texF = tx ? tx.f : 1; this.tono = 'a';
    this.ponerDegradado(dg);
    this.disponer(); if (this.selId !== 'fondo') this.pintarPanel(); else this.refrescarChips(); this.dibujar(); this.actualizar();
  };

  // los adornos del estilo en centímetros sobre ESTA bandera (lo mismo que se pinta y lo que viaja al pedido)
  Bandera.prototype.decoCm = function (id, fo, pal) {
    var lista = (this.esPancarta && DECO_P[id]) || DECO[id] || [], out = [];
    pal = pal || this.pal || { P: '#ffffff', S: '#ffffff' };
    // en una pancarta (apaisada) los adornos de la mitad de abajo se comprimen en el tramo inferior, para no pisar el texto
    var esP = this.esPancarta, my = esP ? function (y) { return y > 0.5 ? 0.72 + (y - 0.5) * 0.56 : y; } : function (y) { return y; };
    lista.forEach(function (d) {
      if (d.k === 'tablero') {
        var sq = Math.min(fo.w, fo.h) / d.n / (esP ? 1.6 : 1), yy = my(d.y0) * fo.h, rr, cc, nc = Math.ceil(fo.w / sq);
        for (rr = 0; rr < d.rows; rr++) for (cc = 0; cc < nc + 1; cc++) {
          if ((rr + cc) % 2) continue;
          var xq = cc * sq, ya = yy + rr * sq;
          out.push({ k: 'poly', c: pal[d.c] || d.c, a: d.a, p: [[xq, ya], [xq + sq, ya], [xq + sq, ya + sq], [xq, ya + sq]] });
        }
        return;
      }
      if (d.k === 'banderines') {
        var wd = Math.min(fo.w, fo.h) / d.n, sz = wd * 1.15, cuerda = my(d.y) * fo.h, i3, nb = Math.ceil(fo.w / wd);
        for (i3 = 0; i3 < nb + 1; i3++) {
          var xa = (i3 - 0.5) * wd, ym = cuerda + d.sag * fo.h * Math.sin(Math.PI * (i3 / nb));
          out.push({ k: 'poly', c: (i3 + (d.off || 0)) % 2 ? pal.S : pal.P, a: 1, p: [[xa, ym], [xa + wd * 0.92, ym], [xa + wd * 0.46, ym + sz]] });
        }
        return;
      }
      var u = Math.min(fo.w, fo.h), W0 = fo.w, H0 = fo.h, col = pal[d.c] || d.c;
      if (d.k === 'monte') {                       // cordillera: picos de distinta altura
        var pm = [], NN = 48, ii;
        for (ii = 0; ii <= NN; ii++) {
          var xn = -0.05 + 1.1 * ii / NN, vv = xn * d.n + d.seed, kk = Math.floor(vv), ff = vv - kk, hg = 0.45 + 0.55 * hs(kk, d.seed + 1);
          pm.push([xn * W0, my(d.y) * H0 - d.h * u * hg * (1 - Math.abs(2 * ff - 1))]);
        }
        pm.push([1.05 * W0, 1.05 * H0]); pm.push([-0.05 * W0, 1.05 * H0]);
        out.push({ k: 'poly', c: col, a: d.a, p: pm }); return;
      }
      if (d.k === 'ciudad') {                      // edificios con ventanas encendidas
        var nb = d.n, bw = W0 / nb, yb = my(d.y) * H0, bi, wc = d.win ? (pal[d.win] || d.win) : null;
        for (bi = 0; bi < nb; bi++) {
          var bx = bi * bw, bwid = bw * (0.72 + 0.28 * hs(bi, 1)), bh = d.h * u * (0.35 + 0.65 * hs(bi, 2)), top = yb - bh;
          out.push({ k: 'poly', c: col, a: d.a, p: [[bx, top], [bx + bwid, top], [bx + bwid, 1.05 * H0], [bx, 1.05 * H0]] });
          if (wc) for (var wy = top + bw * 0.22; wy < yb - bw * 0.1; wy += bw * 0.3) for (var wxi = 0; wxi < 2; wxi++) {
            if (hs(bi * 31 + wxi * 7 + Math.round(wy), 4) < 0.5) continue;
            var wx = bx + bwid * (0.2 + wxi * 0.42), ws = bw * 0.12;
            out.push({ k: 'poly', c: wc, a: 0.85, p: [[wx, wy], [wx + ws, wy], [wx + ws, wy + ws * 1.2], [wx, wy + ws * 1.2]] });
          }
        }
        return;
      }
      if (d.k === 'casa') {                        // casita con tejado y chimenea
        var cs = d.s * u, cx0 = d.x * W0, cy0 = my(d.y) * H0;
        out.push({ k: 'poly', c: col, a: d.a, p: [[cx0, cy0], [cx0 + cs, cy0], [cx0 + cs, cy0 - cs * 0.55], [cx0, cy0 - cs * 0.55]] });
        out.push({ k: 'poly', c: col, a: d.a, p: [[cx0 - cs * 0.08, cy0 - cs * 0.53], [cx0 + cs * 0.5, cy0 - cs * 0.98], [cx0 + cs * 1.08, cy0 - cs * 0.53]] });
        out.push({ k: 'poly', c: col, a: d.a, p: [[cx0 + cs * 0.72, cy0 - cs * 0.95], [cx0 + cs * 0.88, cy0 - cs * 0.95], [cx0 + cs * 0.88, cy0 - cs * 0.78], [cx0 + cs * 0.72, cy0 - cs * 0.7]] });
        if (d.win) { var wcol = pal[d.win] || d.win; out.push({ k: 'poly', c: wcol, a: 0.9, p: [[cx0 + cs * 0.16, cy0 - cs * 0.42], [cx0 + cs * 0.36, cy0 - cs * 0.42], [cx0 + cs * 0.36, cy0 - cs * 0.22], [cx0 + cs * 0.16, cy0 - cs * 0.22]] }); }
        return;
      }
      if (d.k === 'pino') {                        // abeto: tres triángulos y tronco
        var ps = d.s * u, px = d.x * W0, py = my(d.y) * H0, ti;
        out.push({ k: 'poly', c: col, a: d.a, p: [[px - ps * 0.05, py], [px + ps * 0.05, py], [px + ps * 0.05, py - ps * 0.18], [px - ps * 0.05, py - ps * 0.18]] });
        for (ti = 0; ti < 3; ti++) {
          var tw = ps * (0.5 - ti * 0.12), tb = py - ps * (0.12 + ti * 0.26), tt2 = tb - ps * 0.42;
          out.push({ k: 'poly', c: col, a: d.a, p: [[px - tw, tb], [px + tw, tb], [px, tt2]] });
        }
        return;
      }
      if (d.k === 'palmera') {                     // tronco curvo y hojas caídas
        var S0 = d.s * u, fl = d.flip ? -1 : 1, bx0 = d.x * W0, by0 = my(d.y) * H0, tl = [], tr = [], tq, topx = bx0 + fl * 0.22 * S0, topy = by0 - S0;
        for (tq = 0; tq <= 10; tq++) {
          var t0 = tq / 10, qx = bx0 + fl * 0.22 * S0 * t0 * t0, qy = by0 - S0 * t0, wd0 = S0 * (0.045 - 0.02 * t0);
          tl.push([qx - wd0, qy]); tr.push([qx + wd0, qy]);
        }
        out.push({ k: 'poly', c: col, a: d.a, p: tl.concat(tr.reverse()) });
        [-165, -135, -105, -75, -45, -15].forEach(function (ang, ai) {
          var an = (fl < 0 ? 180 - ang : ang) * Math.PI / 180, L = S0 * (0.5 + 0.1 * (ai % 2)), a1 = [], a2 = [], qq;
          for (qq = 0; qq <= 8; qq++) {
            var tt3 = qq / 8, fx = topx + L * tt3 * Math.cos(an), fy = topy + L * tt3 * Math.sin(an) + 0.55 * L * tt3 * tt3, w3 = 0.1 * L * Math.sin(Math.PI * tt3) + 0.01 * L;
            a1.push([fx, fy - w3]); a2.push([fx, fy + w3]);
          }
          out.push({ k: 'poly', c: col, a: d.a, p: a1.concat(a2.reverse()) });
        });
        return;
      }
      if (d.k === 'nube') {                        // nube de círculos
        var nr = d.s * u, nx = d.x * W0, ny = my(d.y) * H0;
        [[0, 0, 1], [0.9, 0.18, 0.75], [-0.9, 0.2, 0.7], [0.35, 0.3, 0.8], [-0.4, 0.32, 0.7]].forEach(function (cc) { out.push({ k: 'circ', c: col, a: d.a, x: nx + cc[0] * nr, y: ny + cc[1] * nr, r: nr * cc[2] }); });
        return;
      }
      var c = { k: d.k, c: pal[d.c] || d.c, a: d.a };
      if (d.k === 'franja') { c.k = 'poly'; c.p = [[-0.05 * fo.w, my(d.y0) * fo.h], [1.05 * fo.w, my(d.y0) * fo.h], [1.05 * fo.w, my(d.y1) * fo.h], [-0.05 * fo.w, my(d.y1) * fo.h]]; }
      else if (d.k === 'poly') { c.p = d.p.map(function (q) { return [q[0] * fo.w, my(q[1]) * fo.h]; }); }
      else if (d.k === 'circ') { c.x = d.x * fo.w; c.y = my(d.y) * fo.h; c.r = d.r * Math.min(fo.w, fo.h); }
      else if (d.k === 'linea') {
        c.k = 'poly'; c.p = []; var N = 48, i2, nx2, g = d.g;
        for (i2 = 0; i2 <= N; i2++) { nx2 = -0.05 + 1.1 * i2 / N; c.p.push([nx2 * fo.w, my(d.y + d.amp * Math.sin(2 * Math.PI * d.ciclos * nx2)) * fo.h]); }
        for (i2 = N; i2 >= 0; i2--) { nx2 = -0.05 + 1.1 * i2 / N; c.p.push([nx2 * fo.w, my(d.y + g + d.amp * Math.sin(2 * Math.PI * d.ciclos * nx2)) * fo.h]); }
      }
      else if (d.k === 'ola') {
        c.k = 'poly'; c.p = [];
        for (var i = 0; i <= 48; i++) { var nx = -0.05 + 1.1 * i / 48; c.p.push([nx * fo.w, my(d.y + d.amp * Math.sin(2 * Math.PI * d.ciclos * nx)) * fo.h]); }
        c.p.push([1.05 * fo.w, 1.05 * fo.h]); c.p.push([-0.05 * fo.w, 1.05 * fo.h]);
      }
      out.push(c);
    });
    return out;
  };
  Bandera.prototype.pintarDeco = function (ctx, prims) {
    prims.forEach(function (d) {
      ctx.save(); ctx.globalAlpha = d.a; ctx.fillStyle = d.c; ctx.beginPath();
      if (d.k === 'circ') ctx.arc(d.x, d.y, d.r, 0, 6.2832);
      else { d.p.forEach(function (q, i) { if (i) ctx.lineTo(q[0], q[1]); else ctx.moveTo(q[0], q[1]); }); ctx.closePath(); }
      ctx.fill(); ctx.restore();
    });
  };

  // marca lo elegido en estilos, letras y colores
  Bandera.prototype.marcarCrea = function () {
    var self = this;
    this.raices().forEach(function (raiz) {
      [].forEach.call(raiz.querySelectorAll('[data-estilo]'), function (c) {
        var on = c.getAttribute('data-estilo') === self.estilo;
        c.classList.toggle('is-on', on);
        [].forEach.call(c.querySelectorAll('.bnd__var'), function (v, i) { v.classList.toggle('is-on', on && i === self.vari); });
      });
    });
  };

  Bandera.prototype.elegirVia = function (v) {
    this.via = v;
    var propio = v === 'propio';
    [].forEach.call(this.raizVia.querySelectorAll('[data-via-b]'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-via-b') === v); });
    var crea = this.$('[data-crea-paso]'); if (crea) crea.hidden = propio;
    var cp = this.$('[data-capas-paso]'); if (cp) cp.hidden = propio;
    var zb = this.lienzoPaso && this.lienzoPaso.querySelector('[data-zoombtns]'); if (zb) zb.hidden = propio;
    this.raiz.classList.toggle('is-propio', propio);
    // ordenador: la columna de herramientas y la ventana de plantillas también viven fuera de .bnd
    if (this.rail) { this.rail.classList.toggle('is-propio', propio); this.modal.classList.toggle('is-propio', propio); this.modalF.classList.toggle('is-propio', propio); this.railBtn.hidden = propio; }
    var pl = this.$('[data-plantilla]'); if (pl) pl.hidden = !(propio && (this.cfg.plantillas || {})[this.claveForma()]);
    var t = this.$('[data-sube-t]');
    if (t) t.innerHTML = 'Sube tu diseño ya preparado';
    var dr = this.$('[data-drop] strong'); if (dr) dr.textContent = 'Sube tu diseño';
    if (propio) {                         // el diseño es del cliente, entero: sin estilo ni capas
      this.layout = null; this.estilo = null; this.selId = null; this.vz = null;
      this.modo = 'cubrir'; this.marcarCrea();
      if (this.img) { this.zoom = 1; this.$('[data-zoom]').value = 100; this.$('[data-zoomv]').textContent = '100 %'; this.encajar(); }
    }
    this.enlacePlantilla(); this.pintarPanel(); this.dibujar(); this.actualizar();
  };
  Bandera.prototype.enlacePlantilla = function () {
    var a = this.$('[data-plantilla-a]'); if (!a) return;
    var u = (this.cfg.plantillas || {})[this.claveForma()];
    if (u) { a.href = u; a.setAttribute('download', 'plantilla-' + this.claveForma().replace('_', '-') + '.pdf'); }
    var pb = this.$('[data-plantilla]'); if (pb) pb.hidden = !(u && this.via === 'propio');
  };

  Bandera.prototype.iniciarCrea = function () {
    var self = this;
    this.raizVia = this.$('[data-via]');
    [].forEach.call(this.raizVia.querySelectorAll('[data-via-b]'), function (b) {
      b.addEventListener('click', function () { self.elegirVia(b.getAttribute('data-via-b')); });
    });
    this.enlacePlantilla();
    setTimeout(function () { self.cargarFuentes(); }, 400);          // las letras se piden al montar: al elegir un ejemplo ya están y no sale la de repuesto (fina)
    this.$('[data-adornos]').addEventListener('change', function (e) { self.adornos = e.target.checked; self.dibujar(); self.actualizar(); });
    this.pintarEstilos();
    this.pintarPanel();
  };

  // las miniaturas de los estilos, con la forma real de la bandera elegida
  /* Dibujo pequeño de una bandera/pancarta con un estilo, una combinación de color y sus textos. */
  Bandera.prototype.miniatura = function (e, vi, t1, t2, fo, maxW, maxH) {
    var self = this, v0 = e.vars[vi] || e.vars[0], k = Math.min(maxW / fo.w, maxH / fo.h), c = document.createElement('canvas');
    c.width = Math.round(fo.w * k + 4); c.height = Math.round(fo.h * k + 4);
    var x = c.getContext('2d');
    x.setTransform(k, 0, 0, k, 2, 2);
    var path = new Path2D(fo.cut);
    x.save(); x.clip(path);
    var dg0 = degDe(e, v0); rellenarDeg(x, fo.w, fo.h, dg0.c, dg0.t);
    var tx0 = texDe(e, dg0.c); if (tx0) pintarTextura(x, fo.w, fo.h, tx0);
    self.pintarDeco(x, self.decoCm(e.id, fo, { P: v0.p, S: v0.s }));
    try {
      // las miniaturas se colocan con el mismo cálculo que la bandera de verdad
      var vert = e.layout === 'vertical' && !self.esPancarta;
      var fs = fuentesDe(e.id);
      var r1 = Texto.pinta(t1, { fuente: fs.f1, fuentes: FUENTES_B, color: v0.t, cajaCm: [40, 40], ppp: 40, maxLineas: 1, grosor: GROSORES[1][0] });
      var it = { logo: t1 === 'TU MARCA' ? 1 : null, t1: { r: r1.lienzo.height / r1.lienzo.width, vert: vert } };
      var r2 = null;
      if (t2) { r2 = Texto.pinta(t2, { fuente: fs.f2, fuentes: FUENTES_B, espaciado: fs.esp, mayus: fs.may, color: v0.t, cajaCm: [40, 40], ppp: 40, maxLineas: 1, grosor: GROSORES[1][1] }); it.t2 = { r: r2.lienzo.height / r2.lienzo.width, vert: false }; }
      var pl = self.colocar(e.layout, it, 1);
      if (pl.logo) { x.fillStyle = v0.t; x.globalAlpha = 0.9; x.beginPath(); x.arc(pl.logo.cx, pl.logo.cy, pl.logo.w / 2, 0, 6.2832); x.fill(); x.globalAlpha = 1; }
      [['t1', r1], ['t2', r2]].forEach(function (par) {
        var q = pl[par[0]], rt = par[1]; if (!q || !rt) return;
        var wcm = q.w, hcm = wcm * rt.lienzo.height / rt.lienzo.width;
        x.save();
        if (q.vert) { x.translate(q.cx, q.cy); x.rotate(-Math.PI / 2 + (q.rot || 0)); x.drawImage(rt.lienzo, -wcm / 2, -hcm / 2, wcm, hcm); }
        else x.drawImage(rt.lienzo, q.cx - wcm / 2, q.cy - hcm / 2, wcm, hcm);
        x.restore();
      });
    } catch (err) { /* sin letra todavía: queda el color */ }
    x.restore();
    return c;
  };
  /* Los ejemplos listos: tarjetas con el texto ya puesto; un clic lo aplica todo. */
  Bandera.prototype.pintarEjemplos = function () {
    var self = this, cont = this.$('[data-ejemplos]'), fo = this.forma();
    if (!cont || !fo) return;
    cont.innerHTML = '';
    var lista = this.esMantel ? EJ_MANTEL : (this.esPhoto ? EJ_PHOTOCALL : (this.esPancarta ? EJ_PANCARTA : EJ_BANDERA));
    var maxW = this.esPancarta ? 190 : 86, maxH = this.esPancarta ? 100 : 150;
    lista.forEach(function (ej) {
      if (self.cat && ej[0] !== self.cat) return;
      var e = ESTILOS.filter(function (x) { return x.id === ej[3]; })[0]; if (!e) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bnd__ej';
      b.appendChild(self.miniatura(e, ej[4], ej[1], ej[2], fo, maxW, maxH));
      var n = document.createElement('span'); n.textContent = ej[1]; b.appendChild(n);
      b.addEventListener('click', function () { self.aplicarEjemplo(ej); });
      cont.appendChild(b);
    });
  };
  // la primera vez, si las letras aún no han llegado, una barra lo dice (mejor un momento de espera que un texto con la letra de repuesto)
  Bandera.prototype.esperarLetras = function () {
    this.cargarFuentes();
    if (this._fontsListas || this._velFuentes) return;
    this._velFuentes = true; this.progreso(null, 'Cargando las letras…');
  };
  Bandera.prototype.aplicarEjemplo = function (ej) {
    this.esperarLetras();
    // un ejemplo trae su propio titular y subtítulo: los textos de antes se cambian; las imágenes del cliente se quedan
    this.capas = this.capas.filter(function (c) { return c.tipo === 'img'; });
    var t1 = this.nuevaCapaTxt({ slot: 't1', auto: true, texto: ej[1] }), t2 = ej[2] ? this.nuevaCapaTxt({ slot: 't2', auto: true, texto: ej[2], sub: true }) : null;
    this.capas.push(t1); if (t2) this.capas.push(t2);
    this.selId = null;
    this.aplicarEstilo(ej[3], ej[4]);
    if (this.full) this.pestanaFull('diseno');
  };
  Bandera.prototype.pintarEstilos = function () {
    var self = this, cont = this.$('[data-estilos]'), fo = this.forma();
    if (!cont || !fo) return;
    cont.innerHTML = '';
    var cats = this.$('[data-cats]');
    if (cats && !cats.firstChild) {
      (self.esPhoto ? CATS_PHOTOCALL : (self.esMantel ? CATS_MANTEL : (self.esPancarta ? CATS_PANCARTA : CATS_BANDERA))).forEach(function (c) {
        var cb = document.createElement('button'); cb.type = 'button'; cb.textContent = c[1]; cb.setAttribute('data-cat', c[0]);
        cb.className = 'bnd__cat' + (c[0] === self.cat ? ' is-on' : '');
        cb.addEventListener('click', function () {
          self.cat = c[0];
          [].forEach.call(cats.querySelectorAll('button'), function (x) { x.classList.toggle('is-on', x === cb); });
          self.pintarEstilos();
        });
        cats.appendChild(cb);
      });
    }
    this.pintarEjemplos();
    var catE = this.esMantel ? (CAT_ESTILO_MANTEL[this.cat] || '') : this.esPhoto ? (CAT_ESTILO_PHOTO[this.cat] || '') : (this.esPancarta && this.cat in CAT_ESTILO ? CAT_ESTILO[this.cat] : this.cat);
    ESTILOS.forEach(function (e) {
      if (catE && e.cat !== catE) return;
      if (e.solo && self.esPancarta) return;                 // los diseños integrales son para banderas con forma
      var v0 = e.vars[0];
      var card = document.createElement('div');
      card.className = 'bnd__estilo' + (self.estilo === e.id ? ' is-on' : ''); card.setAttribute('data-estilo', e.id);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bnd__estilo-b';
      var c = self.miniatura(e, 0, 'TU MARCA', '', fo, 86, 150);
      b.appendChild(c);
      b.addEventListener('click', function () { self.aplicarEstilo(e.id, 0); });
      card.appendChild(b);
      // las cuatro combinaciones de color
      var sws = document.createElement('div'); sws.className = 'bnd__vars';
      e.vars.forEach(function (v, vi) {
        var s2 = document.createElement('button'); s2.type = 'button';
        s2.className = 'bnd__var' + (self.estilo === e.id && self.vari === vi ? ' is-on' : '');
        var c1 = v.deg ? v.deg[0] : v.f, c2 = v.deg ? v.deg[v.deg.length - 1] : v.p;
        s2.style.background = 'linear-gradient(to bottom,' + c1 + ' 50%,' + c2 + ' 50%)'; s2.title = 'Combinación ' + (vi + 1);
        s2.addEventListener('click', function () { self.aplicarEstilo(e.id, vi); });
        sws.appendChild(s2);
      });
      card.appendChild(sws);
      var n = document.createElement('span'); n.className = 'bnd__estilo-n'; n.textContent = e.nombre; card.appendChild(n);
      cont.appendChild(card);
    });
  };

  // de la posición del dedo/ratón a centímetros sobre la bandera
  Bandera.prototype.factorCss = function () {
    var r = this.cv.getBoundingClientRect(); return parseFloat(this.cv.style.width) / (r.width || 1);
  };
  Bandera.prototype.aCm = function (e) {
    var r = this.cv.getBoundingClientRect(), f = this.factorCss(), k = this.escala;
    var tf = this._tf || { ox: MARGEN, oy: MARGEN };
    return { x: ((e.clientX - r.left) * f - tf.ox) / k, y: ((e.clientY - r.top) * f - tf.oy) / k };
  };
  // las capas con su caja en cm: textos primero (están encima) y luego el logo
  /* ¿Algo (texto o logo) se sale de la zona segura (línea roja)? Ahí va la costura o el dobladillo y se perdería. */
  Bandera.prototype.fueraDeZona = function () {
    var fo = this.forma(); if (!fo || !fo.safe) return [];
    var path = new Path2D(fo.safe), c = this._ctxT || (this._ctxT = document.createElement('canvas').getContext('2d')), self = this, fuera = [];
    this.capasCaja().forEach(function (b) {
      var tol = 0.4, us = [-b.lw + tol, 0, b.lw - tol], vs = [-b.lh + tol, 0, b.lh - tol], co = Math.cos(b.phi), si = Math.sin(b.phi), mal = false;
      us.forEach(function (u) { vs.forEach(function (v) { if (!c.isPointInPath(path, b.cx + u * co - v * si, b.cy + u * si + v * co)) mal = true; }); });
      if (mal) fuera.push(b.nombre);
    });
    return fuera;
  };
  Bandera.prototype.capasCaja = function () {
    var self = this, out = [], nt = 0, ni = 0;
    if (this.via === 'propio') return out;
    this.capas.forEach(function (c) {
      var d = self.dimCapa(c);
      if (c.tipo === 'txt') nt++; else ni++;
      if (!self.esReal(c) || !d.h) return;
      if (c.tipo === 'img' && (c.cubrir || d.w >= self.forma().w * 0.98 && d.h >= self.forma().h * 0.98)) return;   // una imagen que llena la bandera sale a sangre a propósito
      out.push({ id: c.id, cx: c.cx, cy: c.cy, phi: c.rot || 0, lw: d.w / 2, lh: d.h / 2,
        nombre: c.tipo === 'img' ? 'la imagen' + (self.capas.filter(function (x) { return x.tipo === 'img'; }).length > 1 ? ' ' + ni : '') : 'el texto «' + String(c.texto).trim().replace(/\s+/g, ' ').slice(0, 18) + '»' });
    });
    return out;
  };
  /* Las esquinas de la capa elegida: el centro de cada asa, en cm (arriba izq. mover, arriba dcha. girar, abajo dcha. tamaño, abajo izq. borrar). */
  Bandera.prototype.asas = function (c) {
    var d = this.dimCapa(c), co = Math.cos(c.rot || 0), si = Math.sin(c.rot || 0), hw = d.w / 2, hh = d.h / 2;
    return [['mover', -hw, -hh, '✥'], ['girar', hw, -hh, '↻'], ['tamano', hw, hh, '⤡'], ['borrar', -hw, hh, '✕']].map(function (q) {
      return { n: q[0], x: c.cx + q[1] * co - q[2] * si, y: c.cy + q[1] * si + q[2] * co, g: q[3] };
    });
  };
  Bandera.prototype.asaEn = function (c, pt) {
    var r = (this.tactil ? 26 : 17) / this.escala, a = this.asas(c);
    for (var i = 0; i < a.length; i++) if (Math.hypot(pt.x - a[i].x, pt.y - a[i].y) <= r) return a[i].n;
    return null;
  };
  Bandera.prototype.capaEn = function (pt) {
    var tol = 8 / this.escala;
    for (var i = this.capas.length - 1; i >= 0; i--) {         // la de más arriba primero
      var c = this.capas[i], d = this.dimCapa(c); if (!d.h || c.oculta) continue;
      var dx = pt.x - c.cx, dy = pt.y - c.cy, co = Math.cos(c.rot || 0), si = Math.sin(c.rot || 0);
      if (Math.abs(dx * co + dy * si) <= d.w / 2 + tol && Math.abs(-dx * si + dy * co) <= d.h / 2 + tol) return c;
    }
    return null;
  };

  // las bases que existen para la talla elegida (la de pared no va en L, XL ni XXL)
  Bandera.prototype.basesDe = function (talla) {
    var self = this;
    return this.bases.filter(function (b) {
      return self.cfg.variantes.some(function (v) { return v.opts[self.iTalla] === talla && v.opts[self.iBase] === b; });
    });
  };
  Bandera.prototype.precioDe = function (talla, base) {
    var self = this;
    var v = this.cfg.variantes.filter(function (x) { return x.opts[self.iTalla] === talla && x.opts[self.iBase] === base; })[0];
    return v ? v.precio : null;
  };
  Bandera.prototype.pintarBases = function () {
    var self = this, cont = this.$('[data-bases]');
    var lista = this.basesDe(this.talla);
    if (lista.indexOf(this.base) === -1) this.base = lista[0];
    var minimo = Math.min.apply(null, lista.map(function (b) { return self.precioDe(self.talla, b); }));
    cont.innerHTML = '';
    var dd = this.$('[data-base-desc]'); if (dd) dd.innerHTML = '<strong>' + this.base + ':</strong> ' + (DESC_BASE[this.base] || '');
    lista.forEach(function (b) {
      var extra = (self.precioDe(self.talla, b) - minimo) / 100;
      var el = document.createElement('button');
      el.type = 'button'; el.className = 'bnd__base' + (b === self.base ? ' is-on' : '');
      el.innerHTML = (self.cfg.imgBases[b] ? '<img src="' + self.cfg.imgBases[b] + '" alt="' + b + '" loading="lazy" width="96" height="96">' : '') +
        '<span class="bnd__base-t"><b>' + b + '</b>' + (extra > 0 ? '<em>+ ' + eur(extra) + '</em>' : '') +
        '<small>' + (DESC_BASE[b] || '') + '</small></span>';
      el.addEventListener('click', function () { self.base = b; self.pintarBases(); self.actualizar(); });
      cont.appendChild(el);
    });
  };

  /* En ordenador, la vista previa se muda a la columna de la foto del producto (como en las pegatinas) y, con el
     diseño puesto, es lo único que se ve ahí. En móvil se queda donde está: debajo del selector. */
  Bandera.prototype.montarEnGaleria = function () {
    var self = this, col = document.querySelector('.product__media-wrapper, .product__media-gallery');
    if (!col || !this.lienzoPaso) return;
    this.galeria = col;
    var caja = this.lienzoPaso, marca = document.createComment('previa-bandera');
    caja.parentNode.insertBefore(marca, caja);
    // la subida del diseño (recuadro, nombre del archivo y avisos) viaja con la vista previa (Xavi, 02/10)
    var sube = this.$('[data-sube-paso]'), marcaSube = document.createComment('sube-bandera');
    sube.parentNode.insertBefore(marcaSube, sube);
    var crea = this.$('[data-crea-paso]'), marcaCrea = document.createComment('crea-bandera');
    crea.parentNode.insertBefore(marcaCrea, crea);
    var via = this.$('[data-via]'), marcaVia = document.createComment('via-bandera');
    via.parentNode.insertBefore(marcaVia, via);
    var herr = this.$('[data-herr]'), marcaHerr = document.createComment('herr-bandera');
    herr.parentNode.insertBefore(marcaHerr, herr);
    var capasP = this.$('[data-capas-paso]'), marcaCapas = document.createComment('capas-bandera');
    capasP.parentNode.insertBefore(marcaCapas, capasP);
    var plant = this.$('[data-plantilla]'), marcaPlant = document.createComment('plantilla-bandera');
    plant.parentNode.insertBefore(marcaPlant, plant);
    this.ancha = window.matchMedia('(min-width: 990px)');
    /* ORDENADOR (Xavi, 03/10): como en las camisetas, todo lo que es DISEÑO va en una columna de herramientas junto al
       lienzo (pestañas, plantillas en una ventana, capas, subida) y a la derecha solo quedan las opciones del producto
       (medida, acabado, pedido). Los mismos elementos viajan entre sitios, y en móvil vuelven a su marca. */
    function montarRail() {
      if (self.rail) return;
      var rail = document.createElement('div'); rail.className = 'bnd bnd__rail'; rail.setAttribute('data-rail', '');
      var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'bnd__rail-b'; bt.setAttribute('data-abrir-plantillas', '');
      bt.innerHTML = '<span aria-hidden="true">🖼️</span><span class="bnd__rail-tx"><b>Plantillas</b><small>Diseños ya hechos para empezar</small></span>';
      var tit = document.createElement('p'); tit.className = 'bnd__rail-tit'; tit.textContent = 'Empieza aquí';
      var fb = document.createElement('button'); fb.type = 'button'; fb.className = 'bnd__rail-b'; fb.setAttribute('data-abrir-fondo', '');
      fb.innerHTML = '<span aria-hidden="true">🎨</span><span class="bnd__rail-tx"><b>Fondo</b><small>Color, degradado o textura</small></span>';
      fb.addEventListener('click', function () { self.selId = 'fondo'; self._abrirFondo = true; self.pintarPanel(); self._abrirFondo = false; self.dibujar(); });
      var subeL = document.createElement('div'); subeL.className = 'bnd__rail-sube';
      subeL.innerHTML = '<p>¿Ya tienes tu diseño hecho?</p><button type="button" class="bnd__rail-b">⬆ Súbelo aquí</button>';
      subeL.querySelector('button').addEventListener('click', function () { self.elegirVia('propio'); });
      var volver = document.createElement('button'); volver.type = 'button'; volver.className = 'bnd__rail-b bnd__rail-volver'; volver.textContent = '← Volver a diseñar aquí';
      volver.addEventListener('click', function () { self.elegirVia('crear'); });
      self.railExtra = [tit, volver, fb, subeL];
      /* Dos ventanas, porque son cosas distintas: las PLANTILLAS (diseños completos con sus textos) y los FONDOS (colores, degradados,
         texturas y estilos listos). Las dos son el mismo armazón. */
      function ventana(titulo, alCerrar, lado) {
        var m = document.createElement('div'); m.className = 'bnd bnd__modal' + (lado ? ' bnd__modal--lado' : ''); m.hidden = true;
        m.innerHTML = '<div class="bnd__modal-c" role="dialog" aria-modal="true" aria-label="' + titulo + '"><button type="button" class="bnd__modal-x" aria-label="Cerrar">×</button><div data-modal-cuerpo></div></div>';
        document.body.appendChild(m);
        var v = { el: m, cuerpo: m.querySelector('[data-modal-cuerpo]') };
        v.abrir = function () { m.hidden = false; if (!lado) document.documentElement.classList.add('bnd-modal-abierto'); };
        v.cerrar = function () {
          var estaba = !m.hidden; m.hidden = true;
          if (document.querySelectorAll('.bnd__modal:not(.bnd__modal--lado):not([hidden])').length === 0) document.documentElement.classList.remove('bnd-modal-abierto');
          if (estaba && alCerrar) alCerrar();
        };
        m.addEventListener('click', function (e) {
          if (e.target === m || e.target.closest('.bnd__modal-x')) { v.cerrar(); return; }
          // al elegir una plantilla o un estilo de fondo ya hecho se cierra la ventana (filtros y colores no la cierran)
          if (e.target.closest(v.cierraCon || '.bnd__ej, .bnd__estilo-b')) setTimeout(v.cerrar, 120);
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) v.cerrar(); });
        return v;
      }
      var vp = ventana('Plantillas de ejemplo');
      var vf = ventana('Fondos', function () {
        // al cerrar la ventana de fondos, el fondo deja de estar seleccionado
        if (self.selId === 'fondo') { self.selId = null; self.pintarPanel(); self.dibujar(); }
      }, true);      // panel lateral: deja a la vista la previa de la bandera mientras se prueban fondos
      vp.cierraCon = '.bnd__ej'; vf.cierraCon = '.bnd__no-cierra-solo';
      bt.addEventListener('click', vp.abrir);
      var modal = vp.el, cerrar = function () { vp.cerrar(); vf.cerrar(); };
      self.vp = vp; self.vf = vf; self.modalF = vf.el;
      self.rail = rail; self.modal = modal; self.railBtn = bt; self.cerrarModal = cerrar;
    }
    function volver(el, marca) { if (marca.parentNode && el.parentNode !== marca.parentNode) marca.parentNode.insertBefore(el, marca.nextSibling); }
    function numerar(pc) {
      var ns = [].slice.call(self.app.querySelectorAll('.bnd__paso-t > i')).filter(function (i) { return i.offsetParent !== null || !pc; });
      [].slice.call(self.app.querySelectorAll('.bnd__paso-t > i')).forEach(function (i) { if (i.dataset.n0 == null) i.dataset.n0 = i.textContent; i.textContent = i.dataset.n0; });
      if (!pc) return;
      var n = 0;
      [].slice.call(self.app.querySelectorAll('.bnd__paso-t > i')).forEach(function (i) {
        var t = i.parentNode; if (t.closest('[data-editor]') && !t.closest('[data-rail]')) { return; }
        n++; i.textContent = String(n);
      });
    }
    function colocar() {
      var prod = col.closest('.product');
      if (self.ancha.matches) {
        montarRail();
        // la columna de la foto pasa a ser una rejilla: herramientas a la izquierda; la vista y la foto del producto, una bajo otra, a su lado
        if (self.rail.parentNode !== col) col.insertBefore(self.rail, col.firstChild);
        if (caja.parentNode !== col) col.insertBefore(caja, self.rail.nextSibling);
        caja.classList.add('bnd__paso--media');
        [via, plant, self.railBtn, herr, capasP, sube].concat(self.railExtra).forEach(function (el) { if (el.parentNode !== self.rail) self.rail.appendChild(el); });
        var cuerpo = self.vp.cuerpo;
        if (crea.parentNode !== cuerpo) cuerpo.appendChild(crea);
        if (prod) prod.classList.add('product--bnd');
        self.railBtn.hidden = self.via === 'propio';
        if (self.selId === 'fondo' && self.pintarPanel) { self.selId = null; self.pintarPanel(); }
        [self.rail, self.modal, self.modalF].forEach(function (el) { el.classList.toggle('is-propio', self.via === 'propio'); });
        numerar(true);
      } else {
        if (caja.parentNode === col) marca.parentNode.insertBefore(caja, marca.nextSibling);
        caja.classList.remove('bnd__paso--media');
        volver(via, marcaVia); volver(plant, marcaPlant); volver(herr, marcaHerr); volver(crea, marcaCrea); volver(capasP, marcaCapas); volver(sube, marcaSube);
        if (self.rail && self.rail.parentNode) self.rail.parentNode.removeChild(self.rail);
        if (self.cerrarModal) self.cerrarModal();
        if (prod) prod.classList.remove('product--bnd');
        numerar(false);
      }
      if (self.full) { self._hist = false; self._cerrarFull(); return; }
      self.dibujar(); self.actualizar();
    }
    if (this.ancha.addEventListener) this.ancha.addEventListener('change', colocar); else this.ancha.addListener(colocar);
    var btns = caja.querySelector('[data-vista]');
    btns.hidden = false;
    // vista: la foto del producto o el diseño. Se enseña la foto al entrar y, en cuanto el cliente elige algo, pasa al diseño.
    this.ponerVista = function (foto) {
      self.verFoto = !!foto;
      [].forEach.call(btns.querySelectorAll('button'), function (x) { x.classList.toggle('is-on', (x.getAttribute('data-ver') === 'foto') === self.verFoto); });
      caja.classList.toggle('is-foto', self.verFoto);
      self.dibujar(); self.actualizar();
    };
    [].forEach.call(btns.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () { self._vistaAuto = false; self.ponerVista(b.getAttribute('data-ver') === 'foto'); });
    });
    this._vistaAuto = true;
    if (this.ancha && this.ancha.matches) { this.verFoto = true; btns.querySelector('[data-ver="foto"]').classList.add('is-on'); btns.querySelector('[data-ver="diseno"]').classList.remove('is-on'); caja.classList.add('is-foto'); }
    colocar();
  };

  /* ================================================================ PANTALLA COMPLETA (MÓVIL) ============================
     En el móvil la ficha no da sitio para diseñar: un botón abre el editor a pantalla completa, con la bandera arriba (grande)
     y un panel abajo con dos pestañas (Capas / Ejemplos). Se mueven los mismos elementos de la ficha, y al cerrar vuelven. */
  Bandera.prototype.montarFull = function () {
    var self = this;
    var ov = document.createElement('div'); ov.className = 'bnd__full'; ov.setAttribute('data-full', ''); ov.hidden = true;
    ov.innerHTML = '<div class="bnd__full-top"><button type="button" class="bnd__full-ok" data-full-ok>✓ Listo</button><span class="bnd__full-t">Diseña tu ' + this.obj + '</span>' +
      '<button type="button" class="bnd__full-exp" data-full-exp aria-label="Ampliar o reducir el panel">⇕</button></div>' +
      '<div class="bnd__full-canvas" data-full-canvas></div>' +
      '<div class="bnd__full-sheet t-diseno" data-full-sheet><div class="bnd__full-tabs"><button type="button" class="is-on" data-ft="diseno">Capas</button><button type="button" data-ft="ejemplos">Ejemplos</button></div>' +
      '<div class="bnd__full-body" data-full-body></div></div>';
    document.body.appendChild(ov);          // en el body: dentro de la ficha, un transform del tema (animaciones) rompe el position: fixed
    this.ov = ov;
    var cta = this.$('[data-abrir-full]'); if (cta) cta.addEventListener('click', function () { self.abrirFull(); });
    ov.querySelector('[data-full-ok]').addEventListener('click', function () { self.cerrarFull(); });
    ov.querySelector('[data-full-exp]').addEventListener('click', function () {
      ov.querySelector('[data-full-sheet]').classList.toggle('is-alto'); setTimeout(function () { self.dibujar(); }, 230);
    });
    [].forEach.call(ov.querySelectorAll('[data-ft]'), function (b) { b.addEventListener('click', function () { self.pestanaFull(b.getAttribute('data-ft')); }); });
    window.addEventListener('popstate', function () { if (self.full) { self._hist = false; self._cerrarFull(); } });
    document.addEventListener('keydown', function (e) { if (self.full && e.key === 'Escape') self.cerrarFull(); });
    // la bandera se redibuja siempre que el hueco cambie de tamaño (teclado, panel ampliado, giro del móvil): si no, se quedaba diminuta
    if (window.ResizeObserver) {
      var pend = null;
      new ResizeObserver(function () { if (!self.full) return; cancelAnimationFrame(pend); pend = requestAnimationFrame(function () { self.dibujar(); }); }).observe(ov.querySelector('[data-full-canvas]'));
    }
    // el teclado lo gestiona el navegador (interactive-widget=resizes-content en el viewport): el editor, que es fixed, se acorta solo y la ResizeObserver redibuja la bandera
  };
  // hueco que se deja bajo la bandera para un aviso importante (con el teclado abierto no hay aviso: se necesita todo el espacio)
  Bandera.prototype.reservaAviso = function () {
    if (!this.ov) return 0;
    var av = this.ov.querySelector('[data-aviso]');
    return (av && !av.hidden && av.classList.contains('warn')) ? 70 : 0;
  };
  Bandera.prototype.pestanaFull = function (t) {
    var sh = this.ov.querySelector('[data-full-sheet]');
    sh.classList.toggle('t-diseno', t === 'diseno'); sh.classList.toggle('t-ejemplos', t === 'ejemplos');
    [].forEach.call(this.ov.querySelectorAll('[data-ft]'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-ft') === t); });
  };
  Bandera.prototype.abrirFull = function () {
    if (this.full || this.via === 'propio' || !this.ov) return;
    var self = this, caja = this.lienzoPaso, crea = this.$('[data-crea-paso]'), capas = this.$('[data-capas-paso]');
    this._fullPos = [caja, crea, capas].map(function (n) { return { n: n, padre: n.parentNode, sig: n.nextSibling }; });
    this.vz = null; this.full = true; this.raiz.classList.add('is-full'); document.documentElement.classList.add('bnd-bloqueo');
    this.ov.querySelector('[data-full-canvas]').appendChild(caja);
    var body = this.ov.querySelector('[data-full-body]'); body.appendChild(crea); body.appendChild(capas);
    this.ov.hidden = false;
    this.pestanaFull(this.hayDiseno() || this.estilo ? 'diseno' : 'ejemplos');
    try { history.pushState({ bndFull: 1 }, ''); this._hist = true; } catch (e) { this._hist = false; }
    this.dibujar(); setTimeout(function () { self.dibujar(); }, 120);
  };
  Bandera.prototype.cerrarFull = function () {
    if (!this.full) return;
    if (this._hist) { try { history.back(); return; } catch (e) { /* sigue */ } }
    this._cerrarFull();
  };
  Bandera.prototype._cerrarFull = function () {
    if (!this.full) return;
    this._fullPos.slice().reverse().forEach(function (q) { q.padre.insertBefore(q.n, q.sig && q.sig.parentNode === q.padre ? q.sig : null); });
    this.vz = null; this.full = false; this.raiz.classList.remove('is-full'); document.documentElement.classList.remove('bnd-bloqueo');
    this.ov.hidden = true;
    this.dibujar(); this.actualizar();
    var t = this.$('[data-lienzo-paso]'); if (t && t.scrollIntoView) t.scrollIntoView({ block: 'start' });
  };

  /* PROCESO DE CARGA: mientras llegan las letras (lo único lento) se enseña la barra con «Cargando las letras (12 de 32)». Al
     terminar, se vuelven a pintar las miniaturas con las letras buenas y se quita la pantalla de carga. Tope: 7 s. */
  Bandera.prototype.arranque = function () {
    var self = this, total = FUENTES_B.length, hechas = 0, fin = false;
    this.cargarFuentes();
    this.progreso(30, 'Cargando las letras (0 de ' + total + ')…');
    function terminar() {
      if (fin) return; fin = true;
      self._fontsListas = true;
      self.capas.forEach(function (c) { c._k = null; });
      self.pintarEstilos(); self.disponer(); self.dibujar();
      self.progreso(100, '¡Listo para diseñar!');
      setTimeout(function () { self.progreso(false); }, 280);
    }
    var link = document.querySelector('link[data-texto-fuentes]');
    var css = new Promise(function (ok) {
      if (!link || link.sheet) return ok();
      link.addEventListener('load', ok); link.addEventListener('error', ok); setTimeout(ok, 4500);
    });
    css.then(function () {
      FUENTES_B.forEach(function (f) {
        var p; try { p = document.fonts.load((f.peso || '400') + ' 40px "' + Texto.familia(f) + '"'); } catch (e) { p = null; }
        Promise.resolve(p).catch(function () { return null; }).then(function () {
          hechas++;
          if (!fin) self.progreso(30 + 62 * hechas / total, 'Cargando las letras (' + hechas + ' de ' + total + ')…');
          if (hechas >= total) terminar();
        });
      });
    });
    setTimeout(terminar, 7000);
  };

  /* ================================================================ DESHACER Y REHACER ====================================
     Una «foto» del diseño (capas y fondo) cada vez que se termina un cambio: se juntan los cambios seguidos (escribir, arrastrar)
     en uno solo. Ctrl+Z / Ctrl+Y y los botones ↶ ↷ de la bandera. Las imágenes se guardan por referencia: no pesa. */
  Bandera.prototype.foto = function () {
    var self = this;
    return {
      capas: this.capas.map(function (c) { var n = {}; for (var k in c) if (k !== '_c' && k !== '_k') n[k] = c[k]; return n; }),
      selId: this.selId,
      fondo: this.fondo, degradado: this.degradado && this.degradado.slice(), gradTipo: this.gradTipo, textura: this.textura, texF: this.texF, tono: this.tono,
      estilo: this.estilo, vari: this.vari, pal: this.pal && { P: this.pal.P, S: this.pal.S }, adornos: this.adornos, layout: this.layout, fondoElegido: this.fondoElegido,
      fuente: this.fuente, fuente2: this.fuente2, esp2: this.esp2, may2: this.may2, colorTexto: this.colorTexto, t1Vertical: this.t1Vertical
    };
  };
  Bandera.prototype.firma = function (f) {
    return JSON.stringify(f, function (k, v) { if (k === 'selId') return undefined; return (k === 'img' || k === 'file' || k === 'orig' || k === 'antes' || k === 'fileOrig') ? (v ? (v.name || v.width || 1) : 0) : v; });
  };
  Bandera.prototype.iniciarHistoria = function () {
    var self = this;
    this._h = []; this._f = []; this._hpend = null;
    var f = this.foto(); this._h.push({ f: f, s: this.firma(f) });
    var tb = this.lienzoPaso && this.lienzoPaso.querySelector('[data-zoombtns]');
    if (tb) {
      var d = document.createElement('div'); d.className = 'bnd__undobtns'; d.setAttribute('data-undobtns', '');
      d.innerHTML = '<button type="button" data-un="deshacer" aria-label="Deshacer" title="Deshacer (Ctrl+Z)">↶</button><button type="button" data-un="rehacer" aria-label="Rehacer" title="Rehacer (Ctrl+Y)">↷</button>';
      tb.parentNode.insertBefore(d, tb);
      [].forEach.call(d.querySelectorAll('[data-un]'), function (b) { b.addEventListener('click', function () { self[b.getAttribute('data-un')](); }); });
    }
    document.addEventListener('keydown', function (e) {
      if (!(e.ctrlKey || e.metaKey) || self.via === 'propio') return;
      var el = document.activeElement; if (el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) return;
      var k = String(e.key || '').toLowerCase();
      if (k === 'z' && !e.shiftKey) { e.preventDefault(); self.deshacer(); }
      else if (k === 'y' || (k === 'z' && e.shiftKey)) { e.preventDefault(); self.rehacer(); }
    });
    this.botonesHistoria();
  };
  // se llama al terminar cualquier cambio; guarda la foto un instante después (junta lo que va seguido)
  Bandera.prototype.punto = function () {
    if (!this._h || this._restaurando) return;
    var self = this; clearTimeout(this._hpend);
    this._hpend = setTimeout(function () { self.confirmarPunto(); }, 450);
  };
  Bandera.prototype.confirmarPunto = function () {
    clearTimeout(this._hpend); this._hpend = null;
    if (!this._h || this._restaurando) return;
    var f = this.foto(), s = this.firma(f);
    if (s === this._h[this._h.length - 1].s) return;
    this._h.push({ f: f, s: s }); if (this._h.length > 60) this._h.shift();
    this._f = [];
    this.botonesHistoria();
  };
  Bandera.prototype.botonesHistoria = function () {
    var self = this;
    this.raices().forEach(function (r) {
      [].forEach.call(r.querySelectorAll('[data-un]'), function (b) {
        b.disabled = self.via === 'propio' || (b.getAttribute('data-un') === 'deshacer' ? !(self._h && self._h.length > 1) : !(self._f && self._f.length));
      });
    });
  };
  Bandera.prototype.restaurar = function (reg) {
    var f = reg.f, self = this;
    this._restaurando = true;
    this.capas = f.capas.map(function (c) { var n = {}; for (var k in c) n[k] = c[k]; return n; });
    ['fondo', 'gradTipo', 'textura', 'texF', 'tono', 'estilo', 'vari', 'adornos', 'layout', 'fondoElegido', 'fuente', 'fuente2', 'esp2', 'may2', 'colorTexto', 't1Vertical'].forEach(function (k) { self[k] = f[k]; });
    this.degradado = f.degradado && f.degradado.slice(); this.pal = f.pal && { P: f.pal.P, S: f.pal.S };
    this.selId = this.capaPorId(f.selId) || f.selId === 'fondo' ? f.selId : null;
    var ad = this.$('[data-adornos]'); if (ad) ad.checked = !!this.adornos;
    this.marcarCrea(); this.marcarFondo(); this.pintarPanel(); this.dibujar(); this.actualizar();
    this._restaurando = false;
    this.botonesHistoria();
  };
  Bandera.prototype.deshacer = function () {
    this.confirmarPunto();
    if (!this._h || this._h.length < 2) return;
    this._f.push(this._h.pop());
    this.restaurar(this._h[this._h.length - 1]);
  };
  Bandera.prototype.rehacer = function () {
    this.confirmarPunto();
    if (!this._f || !this._f.length) return;
    var r = this._f.pop(); this._h.push(r);
    this.restaurar(r);
  };

  /* ================================================================ ZOOM DE LA VISTA ====================================
     Lo que se está modificando se acerca solo (en el móvil); tocar fuera lo aleja; arrastrar el hueco con la vista cerca la
     mueve; y hay botones ＋ y －. La vista (z, fx, fy) solo afecta al dibujo: las capas siguen en cm. */
  Bandera.prototype.vistaA = function (z, fx, fy) {
    var fo = this.forma(); if (!fo || this.via === 'propio') return;
    var self = this, v = this.vz = this.vz || { z: 1, fx: fo.w / 2, fy: fo.h / 2 };
    var de = { z: v.z, fx: v.fx, fy: v.fy }, t0 = (window.performance && performance.now()) || 0;
    z = Math.max(1, Math.min(6, z));
    if (z <= 1.001) { fx = fo.w / 2; fy = fo.h / 2; }
    cancelAnimationFrame(this._raf);
    var paso = function (ahora) {
      var p = Math.min(1, ((ahora || t0 + 999) - t0) / 190), e = 1 - Math.pow(1 - p, 3);
      v.z = de.z + (z - de.z) * e; v.fx = de.fx + (fx - de.fx) * e; v.fy = de.fy + (fy - de.fy) * e;
      if (p >= 1 && z <= 1.001) v.z = 1;
      self.dibujar();
      if (p < 1) self._raf = requestAnimationFrame(paso);
    };
    this._raf = requestAnimationFrame(paso);
  };
  Bandera.prototype.zoomCapa = function (c) {
    var fo = this.forma(); if (!fo) return;
    if (!c) return this.vistaA(1);
    var d = this.dimCapa(c), co = Math.abs(Math.cos(c.rot || 0)), si = Math.abs(Math.sin(c.rot || 0)), bw = d.w * co + d.h * si, bh = d.w * si + d.h * co, kf = this._kFit || 1;
    var z = Math.min((this._vw || 300) * 0.58 / (Math.max(bw, 1) * kf), (this._vh || 400) * 0.45 / (Math.max(bh, 1) * kf));
    z = Math.max(1, Math.min(4, z));
    this.vistaA(z < 1.25 ? 1 : z, c.cx, c.cy);
  };
  Bandera.prototype.zoomBoton = function (dir) {
    var fo = this.forma(), v = this.vz || { z: 1, fx: fo.w / 2, fy: fo.h / 2 }, c = this.capaSel();
    var z = dir > 0 ? v.z * 1.6 : v.z / 1.6;
    if (z < 1.05) return this.vistaA(1);
    if (dir > 0 && v.z <= 1.001) return this.vistaA(Math.max(z, 1.6), c ? c.cx : fo.w / 2, c ? c.cy : fo.h / 2);
    this.vistaA(z, v.fx, v.fy);
  };

  Bandera.prototype.cambiarTalla = function (t) {
    var antes = this.forma();
    // el perfil de la talla de antes (ancho de la zona segura en cada altura), para llevar las capas a la nueva por filas
    var perfA = (antes && antes.safe && antes.safeBox && this.via !== 'propio') ? this.perfil() : null;
    this.vz = null;
    this.talla = t;
    var fo = this.forma();
    // las capas que ha movido el cliente se llevan a la nueva forma; las del estilo se recolocan solas
    if (antes && fo && this.via !== 'propio') {
      var kx = fo.w / antes.w, ky = fo.h / antes.h;
      var perfB = (perfA && fo.safe && fo.safeBox) ? this.perfil() : null;
      /* Cada banderas tiene su propia forma (la gota se estrecha y se curva distinto según la talla): escalar x e y por
         separado dejaba los textos fuera de la tela. Se mantiene la altura relativa y la posición relativa DENTRO del ancho
         que tiene la bandera a esa altura, y el tamaño sigue el ancho de esa fila. */
      var fila = function (filas, sb, ty) {
        var i = Math.max(0, Math.min(filas.length - 1, Math.round(ty * sb[3])));
        for (var d = 0; d < filas.length; d++) {
          var a = filas[i + d], b = filas[i - d];
          if (a && a.l !== null) return a;
          if (b && b.l !== null) return b;
        }
        return null;
      };
      var sbA = antes.safeBox, sbB = fo.safeBox;
      this.capas.forEach(function (c) {
        if (c.auto) return;
        var ty = (c.cy - sbA[1]) / sbA[3], fa = perfA && perfB && fila(perfA, sbA, ty), fb = fa && fila(perfB, sbB, ty);
        if (fa && fb && fa.r - fa.l > 1 && fb.r - fb.l > 1) {
          var rel = (c.cx - fa.l) / (fa.r - fa.l);
          c.cx = fb.l + rel * (fb.r - fb.l); c.cy = sbB[1] + ty * sbB[3]; c.w *= (fb.r - fb.l) / (fa.r - fa.l);
        } else { c.cx *= kx; c.cy *= ky; c.w *= Math.min(kx, ky); }
      });
    }
    this.pintarBases();
    this.pintarEstilos();
    this.enlacePlantilla();
    this.marcarCrea();
    this.disponer();
    if (this.img) this.encajar();
    this.dibujar();
    this.actualizar();
  };

  Bandera.prototype.error = function (t) {
    var e = this.$('[data-error]');
    e.hidden = !t; e.textContent = t || '';
  };

  Bandera.prototype.aviso = function (clase, t) {
    var a = this.$('[data-aviso]');
    a.hidden = !t; a.className = 'bnd__aviso ' + (clase || ''); a.innerHTML = t || '';
  };

  /* La barra de carga. pct = número (0-100) -> barra con porcentaje; null -> barra en movimiento (no se sabe cuánto
     falta, como al leer un archivo grande); false -> se esconde. */
  Bandera.prototype.progreso = function (pct, texto) {
    var v = this.velo;
    if (pct === false) { if (v) v.hidden = true; document.documentElement.classList.remove('bnd-bloqueado'); return; }
    if (!v) {
      v = this.velo = document.createElement('div');
      v.className = 'bnd-velo'; v.hidden = true;
      v.setAttribute('role', 'alertdialog'); v.setAttribute('aria-live', 'polite'); v.setAttribute('aria-label', 'Cargando');
      v.innerHTML = '<div class="bnd-velo__card"><div class="bnd-velo__rueda" aria-hidden="true"></div>' +
        '<div class="bnd-velo__t" data-v-t></div><div class="bnd-velo__b"><i data-v-i></i></div>' +
        '<div class="bnd-velo__p" data-v-p></div></div>';
      document.body.appendChild(v);
    }
    v.hidden = false;
    document.documentElement.classList.add('bnd-bloqueado');
    v.classList.toggle('is-indet', pct === null);
    v.querySelector('[data-v-i]').style.width = pct === null ? '' : Math.max(2, Math.min(100, pct)) + '%';
    v.querySelector('[data-v-t]').textContent = texto || '';
    v.querySelector('[data-v-p]').textContent = pct === null ? 'Un momento…' : Math.round(pct) + ' %';
  };

  /* Tres etapas a la vista, cada una con su barra: leer, analizar y colocar. El análisis es de verdad: busca el fondo
     transparente (en la tela saldría blanco) y mira cuánto de la imagen se recorta al cubrir la bandera. */
  Bandera.prototype.preparar = async function (f) {
    var self = this, pausa = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
    var pinta = function () { return window.Cargando && Cargando.pinta ? Cargando.pinta() : pausa(30); };
    var mio = this._carga = (this._carga || 0) + 1;      // si el cliente sube otro mientras tanto, esta se descarta
    try {
      this.progreso(8, 'Leyendo tu diseño…'); await pinta();
      var url = URL.createObjectURL(f);
      var im = await new Promise(function (ok, mal) { var x = new Image(); x.onload = function () { ok(x); }; x.onerror = mal; x.src = url; });
      if (mio !== this._carga || this.archivo !== f) return;
      this.progreso(40, 'Analizando tu imagen…'); await pinta(); await pausa(250);
      var transp = 0;
      try {
        var k = Math.min(1, 240 / Math.max(im.naturalWidth, im.naturalHeight));
        var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(im.naturalWidth * k)); c.height = Math.max(1, Math.round(im.naturalHeight * k));
        var cx = c.getContext('2d', { willReadFrequently: true }); cx.drawImage(im, 0, 0, c.width, c.height);
        var d = cx.getImageData(0, 0, c.width, c.height).data, n = 0;
        for (var q = 3; q < d.length; q += 4) { if (d[q] < 250) n++; }
        transp = n / (d.length / 4);
      } catch (e1) { /* sin análisis: no pasa nada */ }
      if (mio !== this._carga || this.archivo !== f) return;
      this.progreso(75, 'Colocándola en tu bandera…'); await pinta(); await pausa(250);
      this.img = im; this.verDiseno(); this.zoom = 1; this.$('[data-zoom]').value = 100; this.$('[data-zoomv]').textContent = '100 %';
      this.cv.classList.remove('is-vacio');
      this.$('[data-zoomfila]').hidden = false;
      this.encajar(); this.dibujar(); this.actualizar();
      // lo que ha visto el análisis
      var fo = this.forma(), notas = [];
      this.transp = transp;
      this.$('[data-modos]').hidden = false;
      if (fo) {
      }
      if (this.grande) notas.push('Tu archivo pesa <strong>' + (f.size / 1048576).toFixed(0) + ' MB</strong>. No te preocupes: al añadirlo al carrito lo optimizamos manteniendo la mayor calidad posible (hasta 300 ppp, nunca por debajo del mínimo de 150).');
      this.notasAnalisis = notas;
      this.actualizar();
      this.progreso(100, '¡Listo!');
      setTimeout(function () { if (mio === self._carga) self.progreso(false); }, 450);
    } catch (e) {
      this.progreso(false); this.archivo = null; this.$('[data-archivo]').hidden = true;
      this.aviso('warn', 'No he podido leer esa imagen. Prueba con otra o mándanosla por WhatsApp.');
      this.actualizar();
    }
  };

  /* ================================================================ PANEL DE CAPAS ====================================
     Arriba: «Añadir texto» y «Añadir imagen». Debajo, una ficha por capa (se elige tocándola) y las opciones de la elegida. */
  Bandera.prototype.pintarPanel = function () {
    var self = this, cont = this.$('[data-capas]'); if (!cont) return;
    var sel = this.capaSel(), fo = this.forma(), h = '', enFondo = this.selId === 'fondo', holder = this.$('[data-fondo-holder]'), caja = this.$('[data-fondo-caja]');
    if (caja && holder && caja.parentNode !== holder) holder.appendChild(caja);      // se guarda antes de rehacer el panel
    h += '<div class="bnd__tb"><button type="button" class="bnd__add" data-add="t"><b>＋</b> Añadir texto</button>' +
         '<button type="button" class="bnd__add" data-add="i"><b>＋</b> Añadir imagen o logo</button></div>' +
         '<input type="file" hidden accept=".png,.jpg,.jpeg,.webp,image/png,image/jpeg,image/webp" data-file-capa>';
    {
      h += '<div class="bnd__chips">' + this.capas.slice().reverse().map(function (c) {
        var et = c.tipo === 'img' ? '🖼 ' + (c.nombre || 'Imagen').slice(0, 16) : 'T ' + (String(c.texto || '').trim().replace(/\s+/g, ' ').slice(0, 16) || (c.muestra ? 'Tu marca aquí' : 'Texto vacío'));
        return '<button type="button" class="bnd__chip' + (c.id === self.selId ? ' is-on' : '') + '" data-sel="' + c.id + '">' + et.replace(/</g, '&lt;') + '</button>';
      }).join('') + (!this.fondoElegido && !enFondo && this.rail && this.ancha && this.ancha.matches ? '' : '<button type="button" class="bnd__chip bnd__chip--fondo' + (enFondo ? ' is-on' : '') + '" data-sel="fondo"><i style="background:' + (this.degradado ? cssDeg({ c: this.degradado, t: this.gradTipo }) : this.fondo) + '"></i> Fondo</button>') + '</div>';      // ordenador: el fondo sale en la lista cuando el cliente lo elige
    }
    if (this.capas.length > 1) {
      h += '<details class="bnd__lista"><summary>Ordenar y ocultar</summary>' + this.capas.slice().reverse().map(function (c) {
        var et = c.tipo === 'img' ? '🖼 ' + (c.nombre || 'Imagen') : 'T ' + (String(c.texto || '').trim().replace(/\s+/g, ' ') || (c.muestra ? 'Tu marca aquí' : 'Texto vacío'));
        return '<div class="bnd__fila' + (c.oculta ? ' is-oculta' : '') + '" data-fila="' + c.id + '"><button type="button" data-lo="ojo" title="Mostrar u ocultar">' + (c.oculta ? '🚫' : '👁') + '</button>' +
          '<span class="bnd__fila-n" data-lo="sel">' + et.replace(/</g, '&lt;').slice(0, 30) + '</span>' +
          '<button type="button" data-lo="sube" title="Más arriba (delante)">▲</button><button type="button" data-lo="baja" title="Más abajo (detrás)">▼</button><button type="button" data-lo="borra" title="Borrar">🗑</button></div>';
      }).join('') + '</details>';
    }
    if (sel) {
      var base = Math.max(fo.w, fo.h);
      h += '<div class="bnd__opc" data-opc>';
      if (sel.tipo === 'txt') {
        h += '<textarea class="bnd__in" rows="2" maxlength="90" data-o-texto placeholder="Escribe tu texto (hasta 3 líneas)">' + String(sel.muestra ? '' : sel.texto).replace(/</g, '&lt;') + '</textarea>' +
             '<div class="bnd__ideas" data-ideas></div>' +
             '<p class="bnd__sub">Letra</p><div class="bnd__fuentes" data-fuentes></div>' +
             '<p class="bnd__sub">Grosor de la letra</p><div class="bnd__grosor" data-grosor><button type="button" data-g="0">Normal</button><button type="button" data-g="1">Grueso</button><button type="button" data-g="2">Extra grueso</button></div>' +
             '<p class="bnd__sub">Color del texto</p><div class="bnd__sw" data-swt></div>';
      } else {
        h += '<p class="bnd__sub">' + (sel.nombre || 'Imagen').replace(/</g, '&lt;') + '</p>' +
             '<div class="bnd__calidad" data-calidad><div class="bnd__cal-t"><b data-cal-n></b><span data-cal-r></span></div><div class="bnd__cal-b"><i data-cal-i></i></div><p class="bnd__cal-m" data-cal-m></p>' +
             '<div class="bnd__btns" data-cal-btns><button type="button" data-ac="nitido">Ajustar a tamaño nítido</button><button type="button" data-ac="suavizar" data-cal-suav>Suavizar bordes</button>' +
             '<a class="bnd__wa-b" target="_blank" rel="noopener" data-cal-wa>💬 Envíanos tu logo original</a></div></div>' +
             '<div class="bnd__btns"><button type="button" data-ac="voltear">⇋ Voltear</button><button type="button" data-ac="cubrir">Llenar la ' + this.obj + '</button><button type="button" data-ac="cambiar">Cambiar imagen</button></div>' +
             '<div class="bnd__btns"><button type="button" data-ac="qfondo">' + (sel.sinFondo ? '↩ Volver a poner el fondo' : '✂ Quitar fondo') + '</button></div>';
      }
      h += '<label class="bnd__fila-r">Tamaño <input type="range" min="3" max="160" step="1" value="' + Math.round(sel.w / base * 100) + '" data-o-w><span data-o-wv></span></label>' +
           '<label class="bnd__fila-r">Giro <input type="range" min="-180" max="180" step="1" value="' + Math.round((sel.rot || 0) * 180 / Math.PI) + '" data-o-rot><span data-o-rotv></span></label>' +
           '<div class="bnd__btns"><button type="button" data-ac="centrar">Centrar</button><button type="button" data-ac="dup">Duplicar</button>' +
           '<button type="button" data-ac="sube">▲ Delante</button><button type="button" data-ac="baja">▼ Detrás</button><button type="button" class="bnd__del" data-ac="borrar">Borrar</button></div></div>';
    } else if (enFondo) {
      h += '<div class="bnd__opc" data-opc-fondo></div>';
    } else if (!this.capas.length) {
      h += '<p class="bnd__pista">Añade tu texto o tu logo, o empieza desde un ejemplo.</p>';
    } else {
      h += '<p class="bnd__pista">Toca un texto o una imagen (en la bandera o aquí) para cambiarlo.</p>';
    }
    cont.innerHTML = h;
    this.sincPanel();
    [].forEach.call(cont.querySelectorAll('[data-add]'), function (b) {
      b.addEventListener('click', function () { if (b.getAttribute('data-add') === 't') self.anadirTexto(); else { self._reemplazar = null; self.$('[data-file-capa]').click(); } });
    });
    var fi = cont.querySelector('[data-file-capa]');
    fi.addEventListener('change', function (e) { var f = e.target.files[0]; e.target.value = ''; if (f) self.cargarCapa(f); });
    [].forEach.call(cont.querySelectorAll('[data-sel]'), function (b) {
      b.addEventListener('click', function () { var v = b.getAttribute('data-sel'); self.selId = v === 'fondo' ? 'fondo' : Number(v); self._abrirFondo = v === 'fondo'; self.pintarPanel(); self._abrirFondo = false; self.dibujar(); self.zoomCapa(self.capaSel()); });
    });
    [].forEach.call(cont.querySelectorAll('[data-fila]'), function (fila) {
      var c = self.capaPorId(Number(fila.getAttribute('data-fila')));
      [].forEach.call(fila.querySelectorAll('[data-lo]'), function (b) {
        b.addEventListener('click', function () {
          var a = b.getAttribute('data-lo'), i = self.capas.indexOf(c);
          if (a === 'ojo') c.oculta = !c.oculta;
          else if (a === 'sel') { self.selId = c.id; self.zoomCapa(c); }
          else if (a === 'sube' && i < self.capas.length - 1) { self.capas.splice(i, 1); self.capas.splice(i + 1, 0, c); }
          else if (a === 'baja' && i > 0) { self.capas.splice(i, 1); self.capas.splice(i - 1, 0, c); }
          else if (a === 'borra') return self.borrarCapa(c);
          var abierta = cont.querySelector('.bnd__lista'); var o = abierta && abierta.open;
          self.pintarPanel(); var l2 = self.$('.bnd__lista'); if (l2 && o) l2.open = true;
          self.dibujar(); self.actualizar();
        });
      });
    });
    if (enFondo) {
      if (this.vf && this.ancha && this.ancha.matches && caja) {      // ordenador: ventana de fondos, solo si el cliente la ha pedido
        this.vf.cuerpo.appendChild(caja);
        if (this._abrirFondo) this.vf.abrir();
        else { this.selId = null; this.pintarPanel(); return; }       // estado inicial: el fondo no está «abierto»
      }
      else { var of = cont.querySelector('[data-opc-fondo]'); if (of && caja) of.appendChild(caja); }
    } else if (this.vf && !this.vf.el.hidden) { this.vf.cerrar(); }
    if (!sel) return;
    var rw = cont.querySelector('[data-o-w]'), rr = cont.querySelector('[data-o-rot]');
    rw.addEventListener('input', function () { sel.w = Number(rw.value) / 100 * Math.max(fo.w, fo.h); sel.auto = false; sel.cubrir = false; self.sincPanel(); self.dibujar(); });
    rw.addEventListener('change', function () { self.actualizar(); });
    rr.addEventListener('input', function () { sel.rot = Number(rr.value) * Math.PI / 180; sel.auto = false; self.sincPanel(); self.dibujar(); });
    rr.addEventListener('change', function () { self.actualizar(); });
    [].forEach.call(cont.querySelectorAll('[data-ac]'), function (b) {
      b.addEventListener('click', function () { self.accionCapa(sel, b.getAttribute('data-ac')); });
    });
    if (sel.tipo === 'txt') {
      var ta = cont.querySelector('[data-o-texto]');
      ta.addEventListener('focus', function () { self.cargarFuentes(); if (self.full) setTimeout(function () { var bd = ta.closest('.bnd__full-body'); if (bd) bd.scrollTop += ta.getBoundingClientRect().top - bd.getBoundingClientRect().top - 8; }, 350); });
      ta.addEventListener('input', function () { self.cambiarTexto(sel, ta.value); });
      var ideas = cont.querySelector('[data-ideas]');
      (IDEAS_CAT[self.cat] || IDEAS).forEach(function (t) {
        var ib = document.createElement('button'); ib.type = 'button'; ib.textContent = t;
        ib.addEventListener('click', function () { ta.value = t; self.cambiarTexto(sel, t); });
        ideas.appendChild(ib);
      });
      var fu = cont.querySelector('[data-fuentes]');
      FUENTES_B.slice(0, 29).forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bnd__fu' + (f.id === sel.fuente ? ' is-on' : ''); b.setAttribute('data-fu', f.id); b.textContent = f.nombre; b.style.fontFamily = f.css;
        b.addEventListener('click', function () {
          sel.fuente = f.id; self.cargarFuentes(); self.reajustar(sel);
          [].forEach.call(fu.querySelectorAll('.bnd__fu'), function (x) { x.classList.toggle('is-on', x === b); });
          self.dibujar(); self.actualizar();
        });
        fu.appendChild(b);
      });
      [].forEach.call(cont.querySelectorAll('[data-g]'), function (b) {
        b.classList.toggle('is-on', Number(b.getAttribute('data-g')) === (sel.grosor == null ? 1 : sel.grosor));
        b.addEventListener('click', function () {
          sel.grosor = Number(b.getAttribute('data-g')); self.reajustar(sel);
          [].forEach.call(cont.querySelectorAll('[data-g]'), function (x) { x.classList.toggle('is-on', x === b); });
          self.dibujar(); self.actualizar();
        });
      });
      var sw = cont.querySelector('[data-swt]');
      self.coloresTexto(sel).forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bnd__color' + (c.toLowerCase() === String(sel.color).toLowerCase() ? ' is-on' : ''); b.style.background = c; b.setAttribute('data-ct', c); b.title = c;
        b.addEventListener('click', function () {
          sel.color = c; self.colorTexto = c;
          [].forEach.call(sw.querySelectorAll('.bnd__color'), function (x) { x.classList.toggle('is-on', x === b); });
          self.dibujar(); self.actualizar();
        });
        sw.appendChild(b);
      });
      var otro = document.createElement('label'); otro.className = 'bnd__pers'; otro.innerHTML = 'Otro <input type="color" value="' + (/^#[0-9a-f]{6}$/i.test(sel.color) ? sel.color : '#ffffff') + '">';
      otro.querySelector('input').addEventListener('input', function (e) { sel.color = e.target.value; self.colorTexto = e.target.value; self.dibujar(); self.actualizar(); });
      sw.appendChild(otro);
    }
  };
  /* Los colores que se ofrecen para un texto: los de la plantilla elegida (letra, adornos y fondo) y, si quieren otro, «Otro».
     Sin plantilla, unos básicos. El color que ya lleva la capa siempre está. */
  Bandera.prototype.coloresTexto = function (c) {
    var l = [];
    if (this.estilo && this.pal) {
      l.push(this.colorTexto, this.pal.P, this.pal.S);
      (this.degradado || [this.fondo]).forEach(function (x) { l.push(x); });
    } else if (this.fondoElegido) {
      l.push(this.colorTexto); (this.degradado || [this.fondo]).forEach(function (x) { l.push(x); });
      l.push('#ffffff', '#111111');
    } else l = COLORES_TEXTO.slice();
    if (c && c.color) l.unshift(c.color);
    var vistos = {}, out = [];
    l.forEach(function (x) { x = String(x || '').toLowerCase(); if (/^#[0-9a-f]{6}$/.test(x) && !vistos[x]) { vistos[x] = 1; out.push(x); } });
    return out.length ? out : COLORES_TEXTO.slice();
  };
  /* QUITAR EL FONDO 2.0 (el mismo de las pegatinas): ventana con previa, tolerancia, «solo el fondo / todo ese color» y varita
     para elegir qué colores se quitan. Siempre se parte del archivo ORIGINAL, y se puede volver atrás. */
  Bandera.prototype.quitarFondo = async function (c) {
    var self = this;
    if (c.sinFondo && c.antes) {                                   // volver a poner el fondo
      var a0 = c.antes; c.img = a0.img; c.file = a0.file; c.nw = a0.nw; c.nh = a0.nh; c.nw0 = a0.nw0; c.transp = a0.transp; c.grande = a0.grande;
      c.sinFondo = false; c.antes = null; c.fileOrig = null; c.mejorada = false; c.orig = null;
      this.pintarPanel(); this.dibujar(); this.actualizar(); return;
    }
    if (!window.QuitarFondo || !window.ImgArreglo) return this.aviso('warn', 'Quitar el fondo no está disponible ahora. Recarga la página o mándanos el logo por WhatsApp.');
    var bmp;
    try { this.progreso(30, 'Abriendo la imagen…'); bmp = await createImageBitmap(c.file); }
    catch (e) { this.progreso(false); return this.aviso('warn', 'No he podido abrir esa imagen para quitarle el fondo.'); }
    var lz = document.createElement('canvas'); lz.width = bmp.width; lz.height = bmp.height;
    lz.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0); if (bmp.close) bmp.close();
    this.progreso(false);
    QuitarFondo.abrir({
      lienzo: lz,
      alCancelar: function () { /* nada */ },
      alAplicar: async function (res) {
        try {
          self.progreso(25, 'Quitando el fondo…');
          var nuevo = await ImgArreglo.aFichero(res, c.file.name.replace(/\.[^.]+$/, '') + '-sin-fondo.png');
          self.progreso(65, 'Colocando tu imagen…');
          var url = URL.createObjectURL(nuevo);
          var im = await new Promise(function (ok, mal) { var x = new Image(); x.onload = function () { ok(x); }; x.onerror = mal; x.src = url; });
          c.antes = { img: c.img, file: c.file, nw: c.nw, nh: c.nh, nw0: c.nw0, transp: c.transp, grande: c.grande };
          c.fileOrig = c.file; c.file = nuevo; c.img = im; c.nw = c.nw0 = im.naturalWidth; c.nh = im.naturalHeight; c.transp = 0.3; c.sinFondo = true;
          c.mejorada = false; c.orig = null; c.grande = nuevo.size > self.cfg.maxMb * 1048576;
          self.progreso(100, '¡Fondo quitado!'); setTimeout(function () { self.progreso(false); }, 400);
          self.pintarPanel(); self.dibujar(); self.actualizar();
        } catch (e2) { self.progreso(false); self.aviso('warn', 'No he podido quitar el fondo. Prueba con otra tolerancia o mándanos el logo por WhatsApp.'); }
      }
    });
  };
  /* BARRA DE CALIDAD de una imagen: puntos por pulgada reales (con los píxeles del archivo original) frente al mínimo y al ideal. */
  Bandera.prototype.pintarCalidad = function (c, cont) {
    if (!c || c.tipo !== 'img') return;
    var q = cont.querySelector('[data-calidad]'); if (!q) return;
    var ppp = c.nw0 / (c.w / 2.54), min = this.cfg.pppAviso, ideal = this.cfg.pppIdeal;
    var clase = ppp < min ? 'is-baja' : (ppp < ideal ? 'is-buena' : 'is-alta');
    q.className = 'bnd__calidad ' + clase;
    q.querySelector('[data-cal-n]').textContent = Math.round(ppp) + ' ppp';
    q.querySelector('[data-cal-r]').textContent = 'mínimo ' + min + ' · ideal ' + ideal;
    q.querySelector('[data-cal-i]').style.width = Math.max(4, Math.min(100, ppp / ideal * 100)) + '%';
    var max = c.nw0 / min * 2.54;
    q.querySelector('[data-cal-m]').innerHTML = ppp < min
      ? 'Con este archivo, el tamaño <b>nítido</b> llega a unos <b>' + (Math.round(max * 10) / 10).toLocaleString('es-ES') + ' cm</b> de ancho.' + (c.mejorada ? ' Está suavizada: los bordes se ven menos cuadrados, pero no gana detalle.' : '')
      : (ppp < ideal ? 'Calidad buena para imprimir.' : 'Calidad excelente.');
    var baja = ppp < min;
    [].forEach.call(q.querySelectorAll('[data-ac="nitido"], [data-cal-wa]'), function (b) { b.hidden = !baja; });
    var su = q.querySelector('[data-cal-suav]'); if (su) { su.hidden = !baja && !c.mejorada; su.textContent = c.mejorada ? 'Quitar suavizado' : 'Suavizar bordes'; }
    var wa = q.querySelector('[data-cal-wa]'); if (wa) wa.href = 'https://wa.me/34934358257?text=' + encodeURIComponent('Hola, mi logo tiene poca calidad para: ' + (document.title || '').split('|')[0].trim() + '. Os lo mando por aquí para que lo miréis.');
  };
  /* Suavizar: amplía la imagen en pasos de ×2 con escalado de calidad, para que no se vea cuadriculada. No añade detalle:
     se avisa. Se guarda la original para poder quitarlo y para mandarla en el pedido. */
  Bandera.prototype.suavizar = async function (c) {
    if (c.mejorada && c.orig) {
      c.img = c.orig.img; c.nw = c.orig.nw; c.nh = c.orig.nh; c.mejorada = false; c.orig = null;
      this.pintarPanel(); this.dibujar(); this.actualizar(); return;
    }
    var pausa = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
    var pinta = function () { return window.Cargando && Cargando.pinta ? Cargando.pinta() : pausa(30); };
    try {
      this.progreso(15, 'Suavizando tu imagen…'); await pinta();
      var f = 4; while (f > 1 && c.nw * f * c.nh * f > 60e6) f /= 2;
      if (f < 2) { this.progreso(false); return this.aviso('warn', 'Esta imagen ya es demasiado grande para suavizarla.'); }
      var cur = c.img, w = c.nw, h = c.nh, pasos = Math.log2(f), q;
      for (q = 1; q <= pasos; q++) {
        w *= 2; h *= 2;
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var cx = cv.getContext('2d'); cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = 'high'; cx.drawImage(cur, 0, 0, w, h);
        cur = cv; this.progreso(15 + 70 * q / pasos, 'Suavizando tu imagen…'); await pinta();
      }
      c.orig = { img: c.img, nw: c.nw, nh: c.nh }; c.img = cur; c.nw = w; c.nh = h; c.mejorada = true;
      this.progreso(100, '¡Listo!'); setTimeout(function () { this.progreso(false); }.bind(this), 350);
      this.pintarPanel(); this.dibujar(); this.actualizar();
    } catch (e) { this.progreso(false); this.aviso('warn', 'No he podido suavizar esa imagen. Prueba con una más grande o mándanosla por WhatsApp.'); }
  };
  // pone al día los números de los deslizadores (sin rehacer el panel)
  Bandera.prototype.sincPanel = function () {
    var c = this.capaSel(), cont = this.$('[data-capas]'); if (!c || !cont) return;
    var fo = this.forma(), base = Math.max(fo.w, fo.h), rw = cont.querySelector('[data-o-w]'), rr = cont.querySelector('[data-o-rot]');
    if (!rw) return;
    var pct = Math.round(c.w / base * 100), gr = Math.round(((c.rot || 0) * 180 / Math.PI + 540) % 360 - 180);
    rw.value = pct; rr.value = gr;
    cont.querySelector('[data-o-wv]').textContent = Math.round(c.w) + ' cm de ancho';
    cont.querySelector('[data-o-rotv]').textContent = gr + '°';
    this.pintarCalidad(c, cont);
  };
  /* Tras cambiar la letra o el grosor de un texto, su proporción cambia: se mantiene el alto (la letra no salta de tamaño)
     salvo en las capas del estilo, que se vuelven a ajustar a la forma. */
  Bandera.prototype.reajustar = function (c) {
    if (c.slot && c.auto) { this.disponer(); return; }
    var antes = c._k ? { w: c._c.width, h: c._c.height } : null, h0 = antes ? c.w * antes.h / antes.w : null, k = this.rcapa(c);
    if (h0 && k) { c.w = h0 * k.width / k.height; this.limitarAncho(c); }
  };
  Bandera.prototype.limitarAncho = function (c) {
    var fo = this.forma(); if (!fo || Math.abs(Math.sin(c.rot || 0)) > 0.5) return;
    var d = this.dimCapa(c), tope = fo.safeBox[2] * 0.98;
    if (c.w > tope) c.w = tope;
  };
  Bandera.prototype.cambiarTexto = function (c, v) {
    this.cargarFuentes(); this.verDiseno();
    var antes = this.rcapa(c), h0 = antes ? c.w * antes.height / antes.width : null;
    c.texto = v; c.muestra = false;
    if (c.slot && c.auto) this.disponer();
    else { var k = this.rcapa(c); if (h0 && k) { c.w = h0 * k.width / k.height; this.limitarAncho(c); } }
    this.refrescarChips(); this.sincPanel(); this.dibujar(); this.actualizar();
  };
  Bandera.prototype.refrescarChips = function () {
    var self = this;
    this.raices().forEach(function (r) { [].forEach.call(r.querySelectorAll('[data-sel]'), function (b) {
      var c = self.capaPorId(Number(b.getAttribute('data-sel'))); if (!c || c.tipo !== 'txt') return;
      b.textContent = 'T ' + (String(c.texto || '').trim().replace(/\s+/g, ' ').slice(0, 16) || 'Texto vacío');
    }); });
  };
  Bandera.prototype.anadirTexto = function () {
    var fo = this.forma(), sb = fo.safeBox, n = this.capas.filter(function (c) { return c.tipo === 'txt'; }).length, self = this;
    this.esperarLetras(); this.verDiseno();
    var c = this.nuevaCapaTxt({ texto: 'Tu texto', fuente: this.fuente, color: this.colorTexto });
    var k = this.rcapa(c), r = k ? k.height / k.width : 0.3;
    var cy = sb[1] + sb[3] * (0.3 + 0.12 * (n % 5)), w = Math.min(sb[2] * 0.8, sb[3] * 0.25 / r);
    var z = this.zona(cy - w * r / 2, cy + w * r / 2);
    c.w = Math.min(w, z.w * 0.92); c.cx = z.cx; c.cy = cy;
    this.capas.push(c); this.selId = c.id;
    this.pintarPanel(); this.dibujar(); this.actualizar();
    this.zoomCapa(c);
    var ta = this.$('[data-o-texto]'); if (ta && !this.tactil) { ta.focus(); ta.select(); }
  };
  Bandera.prototype.borrarCapa = function (c) {
    if (!c) return;
    this.capas = this.capas.filter(function (x) { return x !== c; });
    if (this.selId === c.id) this.selId = null;
    this.pintarPanel(); this.vistaA(1); this.actualizar();
  };
  Bandera.prototype.accionCapa = function (c, a) {
    var fo = this.forma(), i = this.capas.indexOf(c), self = this;
    if (a === 'borrar') return this.borrarCapa(c);
    if (a === 'centrar') { c.cx = fo.w / 2; c.cy = fo.h / 2; c.auto = false; }
    else if (a === 'voltear') { c.flip = !c.flip; }
    else if (a === 'nitido') { c.w = Math.max(2, c.nw0 / this.cfg.pppAviso * 2.54); c.auto = false; c.cubrir = false; }
    else if (a === 'suavizar') { return this.suavizar(c); }
    else if (a === 'qfondo') { return this.quitarFondo(c); }
    else if (a === 'cambiar') { this._reemplazar = c.id; this.$('[data-file-capa]').click(); return; }
    else if (a === 'cubrir') {
      c.w = Math.max(fo.w, fo.h * c.nw / c.nh); c.cx = fo.w / 2; c.cy = fo.h / 2; c.rot = 0; c.auto = false; c.cubrir = true;
      this.capas.splice(i, 1); this.capas.unshift(c);           // llena la bandera: queda al fondo
    }
    else if (a === 'dup') {
      var n = {}; for (var k in c) n[k] = c[k]; n.id = ++this._cid; n.slot = null; n.auto = false; n.cx = c.cx + 4; n.cy = c.cy + 4; n.cubrir = false;
      this.capas.splice(i + 1, 0, n); this.selId = n.id;
    }
    else if (a === 'sube' && i < this.capas.length - 1) { this.capas.splice(i, 1); this.capas.splice(i + 1, 0, c); }
    else if (a === 'baja' && i > 0) { this.capas.splice(i, 1); this.capas.splice(i - 1, 0, c); }
    this.pintarPanel(); this.dibujar(); this.actualizar();
  };
  /* Añadir una imagen (o cambiar una): JPG, PNG o WEBP. Los PDF, AI, EPS y PSD van por «Subir mi diseño». */
  Bandera.prototype.cargarCapa = async function (f) {
    var self = this, rem = this._reemplazar; this._reemplazar = null;
    this.error('');
    if (!/\.(png|jpe?g|webp)$/i.test(f.name) && !/^image\/(png|jpe?g|webp)$/.test(f.type)) {
      return this.aviso('warn', 'Aquí valen JPG, PNG o WEBP. Si tienes el diseño en PDF, AI, EPS o PSD, usa la pestaña «Subir mi diseño».');
    }
    if (f.size > this.cfg.maxMbImagen * 1048576) return this.aviso('warn', f.name + ' pesa más de ' + this.cfg.maxMbImagen + ' MB. Mándanoslo por WhatsApp o por correo y lo montamos igual.');
    var pausa = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
    var pinta = function () { return window.Cargando && Cargando.pinta ? Cargando.pinta() : pausa(30); };
    try {
      this.progreso(15, 'Leyendo tu imagen…'); await pinta();
      var url = URL.createObjectURL(f);
      var im = await new Promise(function (ok, mal) { var x = new Image(); x.onload = function () { ok(x); }; x.onerror = mal; x.src = url; });
      this.progreso(60, 'Analizando tu imagen…'); await pinta();
      var transp = 0;
      try {
        var q = Math.min(1, 240 / Math.max(im.naturalWidth, im.naturalHeight));
        var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(im.naturalWidth * q)); cv.height = Math.max(1, Math.round(im.naturalHeight * q));
        var cx = cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(im, 0, 0, cv.width, cv.height);
        var d = cx.getImageData(0, 0, cv.width, cv.height).data, n = 0;
        for (var j = 3; j < d.length; j += 4) { if (d[j] < 250) n++; }
        transp = n / (d.length / 4);
      } catch (e1) { /* sin análisis */ }
      var fo = this.forma(), sb = fo.safeBox, ratio = im.naturalWidth / im.naturalHeight;
      var c = rem != null ? this.capaPorId(rem) : null;
      this.verDiseno();
      if (c && c.tipo === 'img') {                                       // cambiar una imagen: misma caja, otra imagen
        var h0 = c.w * c.nh / c.nw; c.img = im; c.file = f; c.nw = c.nw0 = im.naturalWidth; c.nh = im.naturalHeight; c.mejorada = false; c.orig = null; c.nombre = f.name; c.transp = transp; c.grande = f.size > this.cfg.maxMb * 1048576;
        c.w = h0 * ratio;
        if (c.slot === 'logo' && c.auto) this.disponer();
      } else {
        c = { id: ++this._cid, tipo: 'img', img: im, file: f, nw: im.naturalWidth, nw0: im.naturalWidth, nh: im.naturalHeight, mejorada: false, nombre: f.name, transp: transp, grande: f.size > this.cfg.maxMb * 1048576,
          slot: null, auto: false, cx: sb[0] + sb[2] / 2, cy: sb[1] + sb[3] * 0.3, w: Math.min(sb[2] * 0.7, sb[3] * 0.4 * ratio), rot: 0, flip: false, cubrir: false };
        var hayLogo = this.capas.some(function (x) { return x.slot === 'logo'; });
        if (this.layout && !hayLogo && this.estilo) { c.slot = 'logo'; c.auto = true; }
        this.capas.push(c);
        // los textos del estilo van por encima del logo
        if (c.slot) { this.capas.splice(this.capas.indexOf(c), 1); this.capas.unshift(c); }
        if (c.slot) this.disponer();
        else { var z = this.zona(c.cy - c.w / ratio / 2, c.cy + c.w / ratio / 2); c.w = Math.min(c.w, z.w * 0.9); c.cx = z.cx; }
      }
      this.selId = c.id;
      this.pintarPanel(); this.dibujar(); this.actualizar();
      this.zoomCapa(c);
      this.progreso(100, '¡Listo!');
      setTimeout(function () { self.progreso(false); }, 450);
    } catch (e) {
      this.progreso(false);
      this.aviso('warn', 'No he podido leer esa imagen. Prueba con otra o mándanosla por WhatsApp.');
    }
  };

  /* Archivo de más de 20 MB: se reduce a la resolución a la que imprime el proveedor (150 ppp sobre el ancho al que
     se ve en la bandera), como JPG de calidad alta, y si aún pesa de más, a 120, 100 y 72 ppp. Nunca por encima del
     original. Devuelve { blob, ppp, ancho, alto } o null si no cabe. */
  Bandera.prototype.optimizar = async function (img, anchoCm) {
    var im = img || this.img, v = anchoCm ? { w: anchoCm } : this.vista, limite = this.cfg.maxMb * 1048576 * 0.95;
    var pinta = function () { return window.Cargando && Cargando.pinta ? Cargando.pinta() : Promise.resolve(); };
    var objetivos = [this.cfg.pppIdeal, 250, 200, this.cfg.pppAviso];   // 300 si cabe; nunca por debajo del mínimo (150)
    var naturalPpp = im.naturalWidth / (v.w / 2.54);
    for (var k = 0; k < objetivos.length; k++) {
      var tw = Math.min(im.naturalWidth, Math.round(v.w / 2.54 * objetivos[k]));
      var th = Math.round(tw * im.naturalHeight / im.naturalWidth);
      var lim = Math.min(1, 16000 / Math.max(tw, th), Math.sqrt(150e6 / (tw * th)));   // tope de lienzo del navegador
      tw = Math.max(1, Math.round(tw * lim)); th = Math.max(1, Math.round(th * lim));
      this.progreso(15 + k * 20, 'Optimizando tu diseño para subirlo…'); await pinta();
      try {
        var c = document.createElement('canvas'); c.width = tw; c.height = th;
        var cx = c.getContext('2d'); cx.fillStyle = '#ffffff'; cx.fillRect(0, 0, tw, th);
        cx.imageSmoothingQuality = 'high'; cx.drawImage(im, 0, 0, tw, th);
        var blob = await new Promise(function (ok) { c.toBlob(ok, 'image/jpeg', 0.92); });
        c.width = c.height = 1;
        var pppReal = tw / (v.w / 2.54);
        if (pppReal < Math.min(this.cfg.pppAviso, naturalPpp) - 1) continue;      // el tope del lienzo lo dejaría por debajo del mínimo
        if (blob && blob.size <= limite) return { blob: blob, ppp: Math.round(pppReal), ancho: tw, alto: th };
      } catch (e) { /* se prueba con menos */ }
    }
    return null;
  };

  Bandera.prototype.ponerDegradado = function (par) {
    this.verDiseno();
    var cols = par.c || par;
    this.degradado = cols; this.gradTipo = par.t || 'v'; this.fondo = cols[0]; this.fondoElegido = true;
    this.marcarFondo(); this.dibujar(); this.actualizar();
  };
  Bandera.prototype.marcarFondo = function () {
    var self = this, raices = this.raices();
    raices.forEach(function (r) { [].forEach.call(r.querySelectorAll('.bnd__chip--fondo i'), function (i) { i.style.background = self.degradado ? cssDeg({ c: self.degradado, t: self.gradTipo }) : self.fondo; }); });
    raices.forEach(function (r) {
      if (!r) return;
      [].forEach.call(r.querySelectorAll('.bnd__color[data-c]'), function (b) { b.classList.toggle('is-on', !self.degradado && b.getAttribute('data-c') === self.fondo); });
      [].forEach.call(r.querySelectorAll('.bnd__color[data-g]'), function (b) { b.classList.toggle('is-on', !!self.degradado && b.getAttribute('data-g') === self.degradado.join(',')); });
      [].forEach.call(r.querySelectorAll('.bnd__tex'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-tx') === self.textura); });
      var tn = r.querySelector('[data-tono]');
      if (tn) { tn.hidden = !self.textura; [].forEach.call(tn.querySelectorAll('button'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-tn') === self.tonoReal()); }); }
    });
  };
  Bandera.prototype.tonoReal = function () {
    if (this.tono !== 'a') return this.tono;
    var l = this.degradado ? (luminosidad(this.degradado[0]) + luminosidad(this.degradado[this.degradado.length - 1])) / 2 : luminosidad(this.fondo);
    return l < 0.55 ? 'c' : 'o';
  };
  Bandera.prototype.texturaActual = function () {
    if (!this.textura) return null;
    var c = this.tonoReal() === 'c';
    return { t: this.textura, c: c ? '#ffffff' : '#000000', a: (c ? 0.18 : 0.13) * (this.texF || 1) };
  };
  Bandera.prototype.ponerTextura = function (t) {
    this.verDiseno();
    this.textura = t; this.tono = 'a'; this.texF = 1;
    this.marcarFondo(); this.dibujar(); this.actualizar();
  };
  Bandera.prototype.ponerFondo = function (c) {
    this.verDiseno();
    this.degradado = null;
    this.fondo = c; this.fondoElegido = true; this.tono = 'a';
    this.marcarFondo(); this.dibujar(); this.actualizar();
  };

  // quitar el diseño (por si te has equivocado): vuelve a la bandera vacía
  Bandera.prototype.quitar = function () {
    this._carga = (this._carga || 0) + 1; this.notasAnalisis = [];
    this.archivo = null; this.img = null; this.vista = null; this.zoom = 1;
    this.$('[data-file]').value = '';
    this.$('[data-zoomfila]').hidden = true;
    this.$('[data-zoom]').value = 100; this.$('[data-zoomv]').textContent = '100 %';
    this.$('[data-archivo]').hidden = true;
    this.progreso(false);
    this.cv.classList.add('is-vacio');
    this.aviso('', '');
    this.error('');
    this.dibujar(); this.actualizar();
  };

  Bandera.prototype.cargar = function (f) {
    var self = this;
    this.error('');
    if (!EXT_OK.test(f.name)) { return this.aviso('warn', 'Ese formato no vale. Usa JPG, PNG, WEBP, PDF, AI, EPS o PSD.'); }
    var esImagen = VISTAS.test(f.type) || /\.(png|jpe?g|webp)$/i.test(f.name);
    var tope = esImagen ? this.cfg.maxMbImagen : this.cfg.maxMb;
    if (f.size > tope * 1048576) {
      return this.aviso('warn', f.name + ' pesa más de ' + tope + ' MB. Mándanoslo por WhatsApp o por correo y lo montamos igual.');
    }
    this.grande = esImagen && f.size > this.cfg.maxMb * 1048576;   // se optimiza al añadir al carrito
    this.archivo = f; this.img = null;
    this.$('[data-zoomfila]').hidden = true;
    this.$('[data-nombre]').textContent = f.name;
    this.$('[data-archivo]').hidden = false;
    if (VISTAS.test(f.type) || /\.(png|jpe?g|webp)$/i.test(f.name)) {
      this.preparar(f);
    } else {
      this.cv.classList.add('is-vacio');
      this.dibujar();
      this.aviso('info', '<strong>' + f.name + '</strong> recibido. Este formato no se puede previsualizar aquí: lo montamos nosotros sobre la plantilla de tu bandera y te lo enseñamos antes de imprimir.');
      this.actualizar();
    }
  };

  // la imagen cubre la caja de corte (como "cover") y se centra; el zoom la agranda desde el centro
  Bandera.prototype.encajar = function () {
    var fo = this.forma(); if (!fo || !this.img) return;
    if (this.layout) { this.disponer(); return; }
    var ratio = this.img.naturalWidth / this.img.naturalHeight;
    var sb = fo.safeBox || [0, 0, fo.w, fo.h];          // caja de la zona segura (x, y, ancho, alto)
    var base, cx, cy;
    if (this.modo === 'logo') {                          // pequeño y centrado en la zona segura
      base = Math.min(sb[2] * 0.7, sb[3] * 0.7 * ratio);
      cx = sb[0] + sb[2] / 2; cy = sb[1] + sb[3] / 2;
    } else {                                             // llena la caja de corte
      base = Math.max(fo.w, fo.h * ratio);
      cx = fo.w / 2; cy = fo.h / 2;
    }
    this.baseW = base;
    var w = base * this.zoom, h = w / ratio;
    this.vista = { x: cx - w / 2, y: cy - h / 2, w: w };
  };

  Bandera.prototype.cambiarZoom = function (z) {
    if (!this.img) return;
    z = Math.max(1, Math.min(4, z));
    var ratio = this.img.naturalWidth / this.img.naturalHeight;
    var v = this.vista, cx = v.x + v.w / 2, cy = v.y + v.w / ratio / 2;
    this.zoom = z;
    v.w = this.baseW * z;
    v.x = cx - v.w / 2; v.y = cy - v.w / ratio / 2;
    this.$('[data-zoom]').value = Math.round(z * 100);
    this.$('[data-zoomv]').textContent = Math.round(z * 100) + ' %';
    this.dibujar(); this.actualizar();
  };

  Bandera.prototype.dibujar = function () {
    var fo = this.forma(), cv = this.cv, ctx = this.ctx;
    if (!fo) return;
    var dpr = this.dpr = Math.min(window.devicePixelRatio || 1, 2);
    var enGaleria = this.lienzoPaso && this.lienzoPaso.classList.contains('bnd__paso--media');
    var ancho = (this.lienzoPaso && this.lienzoPaso.clientWidth) || this.app.clientWidth;
    var maxW = Math.max(240, Math.min(ancho - 40, enGaleria ? 720 : 560));
    var maxH = enGaleria ? Math.max(300, Math.min(780, window.innerHeight - (this.rail ? 330 : 190))) : Math.max(240, Math.min(420, Math.round(window.innerHeight * 0.38)));
    var cf = this.full && this.ov && this.ov.querySelector('[data-full-canvas]');
    if (cf && cf.clientWidth > 50) {          // pantalla completa: la bandera llena el hueco que deja el panel
      var rs = this.reservaAviso();   // un aviso importante deja su hueco abajo
      maxW = cf.clientWidth - 8; maxH = cf.clientHeight - 14 - rs;
      var pasoF = cf.querySelector('.bnd__paso'); if (pasoF) pasoF.style.paddingBottom = rs + 'px';
      this._rs = rs;
    }   // en móvil queda fijo arriba: más pequeño
    var margen = MARGEN;
    var kFit = Math.min((maxW - 2 * margen) / fo.w, (maxH - 2 * margen) / fo.h);   // px CSS por cm, la bandera entera
    this._kFit = kFit; this._vw = maxW; this._vh = maxH;
    // ZOOM de la vista (como en la taza y la camiseta): se acerca a lo que se está tocando; el lienzo llena todo el hueco
    var vz = (this.via !== 'propio' && this.vz && this.vz.z > 1.001) ? this.vz : null;
    var k = kFit, cssW, cssH, ox = margen, oy = margen;
    if (vz) {
      k = kFit * vz.z; cssW = Math.round(maxW); cssH = Math.round(maxH);
      var hW = cssW / 2 / k, hH = cssH / 2 / k, loX = hW - margen / k, hiX = fo.w - hW + margen / k, loY = hH - margen / k, hiY = fo.h - hH + margen / k;
      vz.fx = loX > hiX ? fo.w / 2 : Math.max(loX, Math.min(hiX, vz.fx));
      vz.fy = loY > hiY ? fo.h / 2 : Math.max(loY, Math.min(hiY, vz.fy));
      ox = cssW / 2 - vz.fx * k; oy = cssH / 2 - vz.fy * k;
    } else {
      cssW = Math.round(fo.w * k + 2 * margen); cssH = Math.round(fo.h * k + 2 * margen);
    }
    this.escala = k; this._tf = { ox: ox, oy: oy };
    cv.style.width = cssW + 'px';
    cv.style.height = cssH + 'px';
    cv.width = Math.round(cssW * dpr);
    cv.height = Math.round(cssH * dpr);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(k * dpr, 0, 0, k * dpr, ox * dpr, oy * dpr);
    if (this.capa) {
      this.capa.hidden = this.via === 'propio' ? !this.img : false;
      // con ratón la capa táctil cubre todo (las asas quedan fuera de la forma); con dedo, solo la forma: fuera baja la página
      this.capa.style.clipPath = !(this.via === 'propio' || (this.tactil && !this.full)) ? 'none' : "path('" + fo.cut.replace(/(-?\d+\.?\d*) (-?\d+\.?\d*)/g, function (m, x, y) {
        return (parseFloat(x) * k + ox).toFixed(1) + ' ' + (parseFloat(y) * k + oy).toFixed(1);
      }) + "')";
    }
    var corte = new Path2D(fo.cut), seg = new Path2D(fo.safe);
    ctx.save();
    ctx.clip(corte);
    if (this.degradado) rellenarDeg(ctx, fo.w, fo.h, this.degradado, this.gradTipo);
    else { ctx.fillStyle = this.fondo; ctx.fill(corte); }
    var tx = this.texturaActual(); if (tx) pintarTextura(ctx, fo.w, fo.h, tx);
    if (this.estilo && this.adornos) this.pintarDeco(ctx, this.decoCm(this.estilo, fo, this.pal));
    var propio = this.via === 'propio', self = this;
    if (propio && this.img && this.vista) {
      var w = this.vista.w, h = w / (this.img.naturalWidth / this.img.naturalHeight);
      ctx.drawImage(this.img, this.vista.x, this.vista.y, w, h);
    } else if ((propio && !this.img) || (!propio && !this.capas.length && !this.estilo)) {
      ctx.fillStyle = '#9a9aa2';
      ctx.font = (Math.max(fo.w, 30) / 9) + 'px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(propio ? 'Sube tu diseño' : 'Elige un fondo', fo.w / 2, fo.h / 2);
    }
    if (!propio) this.capas.forEach(function (c) {
      if (c.oculta) return;
      var d = self.dimCapa(c); if (!d.h) return;
      ctx.save();
      ctx.translate(c.cx, c.cy); ctx.rotate(c.rot || 0);
      if (c.flip) ctx.scale(-1, 1);
      if (c.tipo === 'img') ctx.drawImage(c.img, -d.w / 2, -d.h / 2, d.w, d.h);
      else { if (self.esFantasma(c)) ctx.globalAlpha = 0.5; ctx.drawImage(self.rcapa(c), -d.w / 2, -d.h / 2, d.w, d.h); }
      ctx.restore();
    });
    ctx.restore();
    ctx.lineJoin = 'round';
    ctx.lineWidth = 2.2 / k;
    ctx.strokeStyle = '#d9b800';
    ctx.stroke(corte);
    ctx.setLineDash([7 / k, 5 / k]);
    ctx.lineWidth = 1.8 / k;
    ctx.strokeStyle = '#e03030';
    ctx.stroke(seg);
    ctx.setLineDash([]);
    var sc = this.via !== 'propio' ? this.capaSel() : null;
    if (sc) {                                                // marco y asas de la capa elegida
      var dm = this.dimCapa(sc);
      ctx.save(); ctx.translate(sc.cx, sc.cy); ctx.rotate(sc.rot || 0);
      ctx.setLineDash([5 / k, 4 / k]); ctx.lineWidth = 1.6 / k; ctx.strokeStyle = '#2b8cff';
      ctx.strokeRect(-dm.w / 2, -dm.h / 2, dm.w, dm.h); ctx.restore(); ctx.setLineDash([]);
      this.asas(sc).forEach(function (a) {
        ctx.beginPath(); ctx.arc(a.x, a.y, (self.tactil ? 14 : 11) / k, 0, 6.2832);
        ctx.fillStyle = a.n === 'borrar' ? '#fde8e8' : '#ffffff'; ctx.fill();
        ctx.lineWidth = 1.6 / k; ctx.strokeStyle = a.n === 'borrar' ? '#d33' : '#2b8cff'; ctx.stroke();
        ctx.fillStyle = a.n === 'borrar' ? '#d33' : '#2b8cff'; ctx.font = ((self.tactil ? 16 : 13) / k) + 'px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(a.g, a.x, a.y + 0.5 / k);
      });
      ctx.textBaseline = 'alphabetic';
    }
  };

  // calidad: píxeles de la imagen que caen en cada pulgada de la bandera
  Bandera.prototype.ppp = function () {
    if (!this.img || !this.vista) return null;
    return this.img.naturalWidth / (this.vista.w / 2.54);
  };

  Bandera.prototype.actualizar = function () {
    var self = this, v = this.variante(), fo = this.forma();
    [].forEach.call(this.app.querySelectorAll('.bnd__talla'), function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-t') === self.talla);
    });
    var md = this.$('[data-medida]');                  // qué mide cada cosa: la lona impresa y, en gota y surf, el conjunto con mástil
    if (md && fo) {
      var tot = String(this.talla).split('·')[1], f0 = this.cfg.forma, lona = Math.round(fo.w) + ' × ' + Math.round(fo.h) + ' cm';
      var tela = Math.round(fo.w) + ' × ' + Math.round(fo.h) + ' cm';
      if (f0 === 'gota' || f0 === 'surf') md.innerHTML = '<b>Altura total con mástil:</b> ' + (tot || '').trim() + '<br><b>Tela (bandera):</b> ' + tela;
      else if (f0 === 'rectangular') md.innerHTML = '<b>Tela (bandera):</b> ' + String(this.talla).split('·')[1].trim() + ' (ancho × alto), sin contar el mástil ni la base';
      else if (this.esPancarta && !this.esPhoto && !this.esMantel) md.innerHTML = '<b>Tela (pancarta):</b> ' + tela + ' (ancho × alto), sin contar cuerdas ni soportes';
      else md.textContent = '';
    }
    if (this._vistaAuto && this.verFoto && this.ponerVista && (this.img || this.capas.length || this.estilo || this.fondoElegido)) {
      this._vistaAuto = false; this.ponerVista(false); return;     // eligió algo: pasa de la foto al diseño
    }
    if (this.galeria) this.galeria.classList.toggle('bnd-galeria-oculta', !this.verFoto && !!(this.ancha && this.ancha.matches));
    var ay = this.$('[data-ayuda]');
    var propio = this.via === 'propio', imgs = this.capas.filter(function (c) { return c.tipo === 'img'; });
    if (ay) ay.textContent = propio ? (this.img ? 'arrastra tu diseño para colocarlo' : 'sube tu diseño') :
      (this.capas.length ? (this.tactil ? 'toca una capa y arrástrala · tamaño y giro, en el panel de debajo' : 'arrastra · esquinas: girar, tamaño y borrar · Suprimir borra · doble clic cambia') : 'elige un fondo y añade tu texto o tu logo');
    var p = this.$('[data-precio]');
    p.innerHTML = v ? eur(v.precio / 100 * this.cant) + '<small>IVA incluido · envío gratis</small>' : '';
    var ctab = this.$('[data-cta-t]'), ctaB = this.$('[data-abrir-full] b'); if (ctab) { ctab.textContent = this.hayDiseno() ? 'Toca para cambiarlo: textos, imágenes y fondo' : 'Pantalla completa: más sitio para diseñar'; ctaB.textContent = (this.hayDiseno() ? '🎨 Seguir diseñando mi ' : '🎨 Diseñar mi ') + this.obj; }
    var listo = this.hayDiseno();    // el color es solo el fondo: hace falta un texto o un logo
    this.$('[data-comprar]').disabled = this.ocupado || !v || !listo;
    this.punto();
    this.$('[data-comprar]').textContent = listo ? 'Añadir al carrito' : (this.via === 'propio' ? 'Sube tu diseño para continuar' : 'Añade un texto o una imagen para continuar');
    var bPres = this.$('[data-presupuesto]');
    if (bPres) {
      bPres.disabled = this.ocupado || !v || !listo;
      bPres.textContent = this._presBusy ? 'Preparando presupuesto…' : 'Crear presupuesto';
    }
    var nt = (this.notasAnalisis || []).slice();
    var colorElegido = this.fondoElegido && this.fondo.toLowerCase() !== '#ffffff';
    var hayImg = propio ? !!this.img : imgs.length > 0;
    var transpMax = propio ? this.transp : imgs.reduce(function (m, c) { return Math.max(m, c.transp || 0); }, 0);
    if (hayImg) {
      if (transpMax > 0.02) {
        nt.unshift(colorElegido
          ? 'Las partes transparentes de tu imagen tomarán el <strong>color de fondo</strong> que has elegido.'
          : 'Tu imagen tiene <strong>partes transparentes</strong>: en la tela saldrán en <strong>blanco</strong>. Si quieres otro color, elígelo en «Color de fondo».');
      }
      if (propio && this.modo === 'cubrir' && !this.layout && fo && this.vista) {
        var ratioI = this.img.naturalWidth / this.img.naturalHeight, hI = this.vista.w / ratioI;
        var vis = (fo.w * fo.h) / (this.vista.w * hI);
        if (vis < 0.6) nt.push('Tu imagen es más ' + (ratioI > fo.w / fo.h ? 'ancha' : 'alta') + ' que la bandera y se recorta. Muévela o usa «Logo centrado» si es un logo.');
      }
    }
    if (colorElegido) nt.push('El color impreso puede variar un poco del de pantalla. Si necesitas uno exacto, dinos el código (Pantone o CMYK) en observaciones.');
    var fuera = this.fueraDeZona();
    if (fuera.length) nt.unshift('<strong>Cuidado:</strong> ' + fuera.join(' y ') + ' se sale de la línea roja (zona segura). Ahí va la costura y se podría perder: muévelo un poco hacia dentro.');
    var extra = nt.length ? '<br>' + nt.join('<br>') : '';
    if (hayImg) {
      var q = propio ? this.ppp() : imgs.reduce(function (m, c) { return Math.min(m, c.nw0 / (c.w / 2.54)); }, 1e9);
      if (q < this.cfg.pppAviso) {
        this.aviso('warn', propio
          ? '<strong>Calidad baja:</strong> tu imagen es pequeña para esta talla y puede verse borrosa. Prueba con una más grande, o súbela en PDF si tienes el logo en vector. Si es solo un logo, usa «Logo centrado» para ponerlo más pequeño.' + extra
          : '<strong>Calidad baja:</strong> una imagen puede verse borrosa. Toca la imagen y mira su barra de calidad: «Ajustar a tamaño nítido» la deja bien.' + extra);
      } else if (q < this.cfg.pppIdeal) {
        this.aviso('ok', '<strong>Calidad buena</strong> para imprimir. Mantén lo importante dentro de la línea roja discontinua.' + extra);
      } else {
        this.aviso('ok', '<strong>Calidad excelente.</strong> Mantén lo importante dentro de la línea roja discontinua.' + extra);
      }
    } else if (this.textoReal()) {
      if (fuera.length) this.aviso('warn', nt.join('<br>') + '<br>¿Quieres añadir tu logo? Pulsa «Añadir imagen o logo».');
      else this.aviso('ok', 'Tu texto queda dentro de la zona segura. ¿Quieres añadir tu logo? Pulsa «Añadir imagen o logo».' + extra);
    } else if (this.estilo) {
      this.aviso('info', 'Ahora cambia el texto de ejemplo por el tuyo (tócalo en la bandera o en «Añadir texto») y, si tienes logo, añádelo como imagen.' + extra);
    } else if (!this.archivo) {
      this.aviso('', '');
    }
    if (this.full && this.reservaAviso() !== this._rs) this.dibujar();
  };

  /* Un texto en alta resolución, como PNG transparente, para el archivo final. Se baja de 300 ppp solo si el navegador no
     da más de sí (un texto vertical de una bandera grande es larguísimo). Devuelve { blob, ppp, ancho_cm } o null. */
  Bandera.prototype.capaTexto = async function (c) {
    var c0 = this.rcapa(c); if (!c0 || !c.w) return null;
    var wcm = c.w, hcm = wcm * c0.height / c0.width;
    var intentos = [300, 220, 160, 120, 90, 60];
    for (var q = 0; q < intentos.length; q++) {
      var ppp = intentos[q], pw = wcm / 2.54 * ppp, ph = hcm / 2.54 * ppp;
      if (Math.max(pw, ph) > 15000 || pw * ph > 110e6) continue;
      var r = Texto.pinta(this.textoCapa(c), this.opcCapa(c, { cajaCm: [wcm, hcm], ppp: ppp }));
      if (!r) return null;
      var blob = await new Promise(function (ok) { r.lienzo.toBlob(ok, 'image/png'); });
      if (blob && blob.size < 18 * 1048576) return { blob: blob, ppp: Math.round(r.lienzo.width / (wcm / 2.54)), ancho_cm: r.lienzo.width * 2.54 / ppp };
    }
    return null;
  };

  /* `pres` = 'pres': en vez de añadir al carrito, las MISMAS líneas y archivos van al Worker de presupuestos (pedido borrador). */
  Bandera.prototype.alCarrito = async function (pres) {
    pres = pres === 'pres';
    if (this.via !== 'propio') return this.alCarritoCapas(pres);
    if (this.ocupado || !this.hayDiseno()) return;
    if (pres && (!window.Presupuesto || !this.cfg.presupuestoUrl)) return;
    var v = this.variante(), fo = this.forma(), self = this, btn = this.$(pres ? '[data-presupuesto]' : '[data-comprar]');
    if (!v) return this.error('Esa combinación no está disponible.');
    this.ocupado = true; this.error('');
    if (pres) this.empezarPres();
    try {
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', this.cant);
      fd.append('properties[' + this.etqTalla + ']', this.talla);
      fd.append('properties[' + this.etqBase + ']', this.base);
      var obs = this.$('[data-obs]').value.trim();
      if (obs) fd.append('properties[Observaciones]', obs);
      if (fo) fd.append('properties[Medida de corte]', cm(fo.w) + ' × ' + cm(fo.h));
      fd.append('properties[_plantilla]', this.claveForma());
      if (this.fondoElegido) fd.append('properties[Color de fondo]', (this.degradado ? 'Degradado ' + this.degradado.join(' → ') : this.fondo) + (this.textura ? ' · textura ' + this.textura : ''));
      if (this.img && this.vista) fd.append('properties[_ppp]', String(Math.round(this.ppp())));
      var pos = { plantilla: this.claveForma(), caja_cm: [fo.w, fo.h], fondo: this.fondo, degradado: this.degradado, degtipo: this.gradTipo, textura: this.texturaActual(), modo: this.modo, layout: this.layout, via: this.via, textos: [] };
      if (this.img && this.vista) {
        pos.x_cm = Math.round(this.vista.x * 100) / 100; pos.y_cm = Math.round(this.vista.y * 100) / 100;
        pos.ancho_cm = Math.round(this.vista.w * 100) / 100; pos.px = [this.img.naturalWidth, this.img.naturalHeight];
      }
      var capas = [];
      if (this.estilo && this.adornos) pos.deco = this.decoCm(this.estilo, fo, this.pal).map(function (d) { return d.k === 'circ' ? { k: 'circ', x: +d.x.toFixed(2), y: +d.y.toFixed(2), r: +d.r.toFixed(2), c: d.c, a: d.a } : { k: 'poly', p: d.p.map(function (q) { return [+q[0].toFixed(2), +q[1].toFixed(2)]; }), c: d.c, a: d.a }; });
      fd.append('properties[_posicion]', (this.archivo && !this.img) ? 'sin vista previa: montar sobre la plantilla' : JSON.stringify(pos));
      var mkL = await this.mockupBlob(900); if (mkL) capas.push(['properties[_Mockup]', mkL, 'mockup.jpg']);
      capas.forEach(function (c) { fd.append(c[0], c[1], c[2]); });
      var archivo = this.archivo, nombre = this.archivo ? this.archivo.name : '';
      if (this.grande && this.img) {
        this.progreso(10, 'Optimizando tu diseño para subirlo…');
        var opt = await this.optimizar();
        if (!opt) { this.progreso(false); throw new Error('grande'); }
        archivo = opt.blob; nombre = nombre.replace(/\.[^.]+$/, '') + '-optimizado.jpg';
        fd.append('properties[_optimizado]', 'Original ' + this.archivo.name + ' (' + (this.archivo.size / 1048576).toFixed(0) + ' MB, ' +
          this.img.naturalWidth + 'x' + this.img.naturalHeight + ' px) reducido a ' + opt.ancho + 'x' + opt.alto + ' px (' + opt.ppp + ' ppp), JPG');
        // la posición es la misma (en cm); solo cambian los píxeles
      }
      if (archivo) fd.append('properties[Diseño]', archivo, nombre);
      await this.enviarCarrito(fd, btn, pres);
    } catch (e) {
      this.ocupado = false; this._presBusy = false;
      this.progreso(false);
      if (window.Cargando && btn && btn._crgTxt != null) { try { Cargando.libre(btn); } catch (x) { /* nada */ } }
      this.error(e && e.message === 'grande' ? 'Tu archivo es demasiado grande incluso optimizado. Mándanoslo por WhatsApp o por correo y lo montamos igual.' : (e && e.message === 'texto' ? 'No he podido preparar tu texto. Prueba con un texto más corto o escríbenos por WhatsApp.' : (pres ? ((e && e.message) || 'No se ha podido preparar el presupuesto. Inténtalo otra vez o escríbenos por WhatsApp.') : 'No se ha podido añadir al carrito. Inténtalo de nuevo o escríbenos por WhatsApp.')));
      this.actualizar();
    }
  };

  /* Presupuesto: bloquea el botón (texto «Preparando presupuesto…») y esconde el anterior. */
  Bandera.prototype.empezarPres = function () {
    this._presBusy = true;
    var n = this.$('[data-presupuesto-nota]'); if (n) n.hidden = true;
    this.actualizar();
  };

  /* Presupuesto: manda las líneas del formulario a Presupuesto.crear y enseña el resultado (Copiar mensaje / WhatsApp). */
  Bandera.prototype.enviarPresupuesto = async function (fd) {
    var self = this, nota = this.$('[data-presupuesto-nota]');
    this.progreso(null, 'Preparando tu presupuesto…');
    var titulo = ((document.querySelector('h1') || document).textContent || '').replace(/\s+/g, ' ').trim();
    var datos = Presupuesto.desdeForm(fd);
    var creado;
    try { creado = await Presupuesto.crear(this.cfg.presupuestoUrl, { titulo: titulo.slice(0, 120), nota: '', lineas: datos.lineas, ficheros: datos.ficheros }); }
    finally { this.progreso(false); }
    var total = creado.total ? eur(parseFloat(creado.total)) : '';
    creado.totalTexto = total ? total + ' IVA incl.' : '';
    var texto = 'Presupuesto de Imprimirlo · ' + titulo + '\n' + (total ? 'Precio: ' + total + ' IVA incl.\n' : '') + (creado.landing ? 'Mira el montaje y págalo aquí: ' + creado.landing : 'Págalo aquí: ' + creado.url);
    var copiado = false;
    var fin = function () { Presupuesto.mostrar(nota, creado, texto, copiado); self.ocupado = false; self._presBusy = false; self.actualizar(); };
    if (!Presupuesto.esMovil() && navigator.clipboard) navigator.clipboard.writeText(texto).then(function () { copiado = true; fin(); }, fin); else fin();
  };

  /* MOCKUP del pedido: una foto del diseño (la bandera con todo puesto, sin líneas de guía) para verlo de un vistazo en el pedido,
     en el carrito y en el panel, como en el resto de productos (propiedad _Mockup). */
  Bandera.prototype.mockupBlob = async function (lado) {
    try {
      var fo = this.forma(); if (!fo) return null;
      lado = lado || 900;
      var m = 24, k = (lado - 2 * m) / Math.max(fo.w, fo.h), self = this, propio = this.via === 'propio';
      if (propio && !this.img) return null;
      var cv = document.createElement('canvas'); cv.width = Math.round(fo.w * k + 2 * m); cv.height = Math.round(fo.h * k + 2 * m);
      var ctx = cv.getContext('2d');
      ctx.fillStyle = '#f1f1f3'; ctx.fillRect(0, 0, cv.width, cv.height);
      ctx.setTransform(k, 0, 0, k, m, m);
      var corte = new Path2D(fo.cut);
      ctx.save(); ctx.clip(corte);
      if (this.degradado) rellenarDeg(ctx, fo.w, fo.h, this.degradado, this.gradTipo); else { ctx.fillStyle = this.fondo; ctx.fill(corte); }
      var tx = this.texturaActual(); if (tx) pintarTextura(ctx, fo.w, fo.h, tx);
      if (this.estilo && this.adornos && !propio) this.pintarDeco(ctx, this.decoCm(this.estilo, fo, this.pal));
      if (propio) { var w = this.vista.w, h = w / (this.img.naturalWidth / this.img.naturalHeight); ctx.drawImage(this.img, this.vista.x, this.vista.y, w, h); }
      else this.capas.forEach(function (c) {
        if (!self.esReal(c)) return;
        var d = self.dimCapa(c); if (!d.h) return;
        ctx.save(); ctx.translate(c.cx, c.cy); ctx.rotate(c.rot || 0); if (c.flip) ctx.scale(-1, 1);
        ctx.drawImage(c.tipo === 'img' ? c.img : self.rcapa(c), -d.w / 2, -d.h / 2, d.w, d.h);
        ctx.restore();
      });
      ctx.restore();
      ctx.lineJoin = 'round'; ctx.lineWidth = 1.5 / k; ctx.strokeStyle = 'rgba(0,0,0,.35)'; ctx.stroke(corte);
      return await new Promise(function (ok) { cv.toBlob(ok, 'image/jpeg', 0.86); });
    } catch (e) { return null; }
  };

  /* Sube el pedido al carrito (con barra de progreso) y va a la página del carrito. */
  Bandera.prototype.enviarCarrito = async function (fd, btn, pres) {
    if (pres) return this.enviarPresupuesto(fd);
    var self = this, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', res;
    if (window.Cargando) {
      Cargando.ocupar(btn, 'Subiendo el diseño…', true);
      this.progreso(0, 'Subiendo tu diseño…');
      res = await Cargando.subir(root + 'cart/add.js', fd, function (pct) {
        if (pct >= 100) { Cargando.ocupar(btn, 'Guardando el diseño…'); self.progreso(null, 'Guardando tu diseño en el carrito…'); }
        else { Cargando.pct(btn, pct, 'Subiendo el diseño'); self.progreso(pct, 'Subiendo tu diseño…'); }
      });
    } else {
      res = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    }
    if (!res.ok) throw new Error('cart');
    window.location.href = this.cfg.carrito || (root + 'cart');
  };

  /* Pedido con capas: cada texto va como PNG transparente a la mayor calidad que cabe, cada imagen con su archivo, y
     `_posicion` dice dónde está cada una (centro, ancho y giro, en cm sobre la caja de corte) y en qué orden se apilan. */
  Bandera.prototype.alCarritoCapas = async function (pres) {
    if (this.ocupado || !this.hayDiseno()) return;
    if (pres && (!window.Presupuesto || !this.cfg.presupuestoUrl)) return;
    var v = this.variante(), fo = this.forma(), self = this, btn = this.$(pres ? '[data-presupuesto]' : '[data-comprar]');
    if (!v) return this.error('Esa combinación no está disponible.');
    this.ocupado = true; this.error('');
    if (pres) this.empezarPres();
    try {
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', this.cant);
      fd.append('properties[' + this.etqTalla + ']', this.talla);
      fd.append('properties[' + this.etqBase + ']', this.base);
      var obs = this.$('[data-obs]').value.trim();
      if (obs) fd.append('properties[Observaciones]', obs);
      if (fo) fd.append('properties[Medida de corte]', cm(fo.w) + ' × ' + cm(fo.h));
      fd.append('properties[_plantilla]', this.claveForma());
      if (this.fondoElegido) fd.append('properties[Color de fondo]', (this.degradado ? 'Degradado ' + this.degradado.join(' → ') : this.fondo) + (this.textura ? ' · textura ' + this.textura : ''));
      var pos = { plantilla: this.claveForma(), caja_cm: [fo.w, fo.h], fondo: this.fondo, degradado: this.degradado, degtipo: this.gradTipo, textura: this.texturaActual(), via: 'crear', capas: [] };
      var reales = this.capas.filter(this.esReal, this), archivos = [], nT = 0, nI = 0, minPpp = null, nombresG = ['normal', 'grueso', 'extra'];
      for (var i = 0; i < reales.length; i++) {
        var c = reales[i], n = i + 1, giro = Math.round((c.rot || 0) * 18000 / Math.PI) / 100;
        if (c.tipo === 'txt') {
          this.progreso(5 + 55 * i / reales.length, 'Preparando el texto ' + (i + 1) + ' de ' + reales.length + '…');
          var ct = await this.capaTexto(c);
          if (!ct) { this.progreso(false); throw new Error('texto'); }
          var nombreF = (window.Texto && Texto.fuenteDe(c.fuente, FUENTES_B).nombre) || c.fuente;
          fd.append('properties[Texto ' + (++nT) + ']', '«' + String(c.texto).trim().replace(/\s*\n\s*/g, ' / ') + '» · ' + nombreF + ' · ' + c.color + ' · grosor ' + nombresG[c.grosor == null ? 1 : c.grosor] + (giro ? ' · girado ' + giro + '°' : ''));
          archivos.push(['properties[Capa ' + n + ' (texto)]', ct.blob, 'capa-' + n + '-texto.png']);
          pos.capas.push({ n: n, tipo: 'txt', texto: String(c.texto).trim(), fuente: c.fuente, color: c.color, grosor: nombresG[c.grosor == null ? 1 : c.grosor],
            cx_cm: Math.round(c.cx * 100) / 100, cy_cm: Math.round(c.cy * 100) / 100, ancho_cm: Math.round(ct.ancho_cm * 100) / 100, giro_grados: giro, ppp: ct.ppp });
        } else {
          var blobI = c.file, nombreI = c.file.name, pppI = c.nw0 / (c.w / 2.54), optI = null;
          if (c.sinFondo && !c.mejorada) archivos.push(['properties[Capa ' + n + ' (original)]', c.fileOrig, c.fileOrig.name]);
          if (c.mejorada) {
            this.progreso(5 + 55 * i / reales.length, 'Preparando tu imagen suavizada…');
            var conAlfa = (c.transp || 0) > 0.02;
            blobI = await new Promise(function (ok) { c.img.toBlob(ok, conAlfa ? 'image/png' : 'image/jpeg', 0.92); });
            nombreI = c.file.name.replace(/\.[^.]+$/, '') + '-suavizada.' + (conAlfa ? 'png' : 'jpg');
            archivos.push(['properties[Capa ' + n + ' (original)]', c.fileOrig || c.file, (c.fileOrig || c.file).name]);
          }
          if (c.grande) {
            this.progreso(5 + 55 * i / reales.length, 'Optimizando tu imagen para subirla…');
            optI = await this.optimizar(c.img, c.w);
            if (!optI) { this.progreso(false); throw new Error('grande'); }
            blobI = optI.blob; nombreI = nombreI.replace(/\.[^.]+$/, '') + '-optimizado.jpg'; pppI = optI.ppp;
            fd.append('properties[_optimizado ' + n + ']', 'Original ' + c.file.name + ' (' + (c.file.size / 1048576).toFixed(0) + ' MB, ' + c.nw + 'x' + c.nh + ' px) reducido a ' + optI.ancho + 'x' + optI.alto + ' px (' + optI.ppp + ' ppp), JPG');
          }
          fd.append('properties[Imagen ' + (++nI) + ']', c.file.name + ' · ' + Math.round(c.w) + ' cm de ancho · ' + Math.round(pppI) + ' ppp' + (c.flip ? ' · volteada' : '') + (c.sinFondo ? ' · SIN FONDO' : '') + ((c.mejorada || c.sinFondo) ? ' · original en «Capa ' + n + ' (original)»' : '') + (c.mejorada ? ' · SUAVIZADA' : '') + (c.cubrir ? ' · llena la ' + this.obj : '') + (giro ? ' · girada ' + giro + '°' : ''));
          archivos.push(['properties[Capa ' + n + ' (imagen)]', blobI, nombreI]);
          if (minPpp === null || pppI < minPpp) minPpp = pppI;
          pos.capas.push({ n: n, tipo: 'img', archivo: nombreI, cx_cm: Math.round(c.cx * 100) / 100, cy_cm: Math.round(c.cy * 100) / 100, ancho_cm: Math.round(c.w * 100) / 100,
            giro_grados: giro, flip: !!c.flip, px: [c.nw, c.nh], ppp: Math.round(pppI), cubrir: !!c.cubrir });
        }
      }
      if (minPpp !== null) fd.append('properties[_ppp]', String(Math.round(minPpp)));
      if (this.estilo && this.adornos) pos.deco = this.decoCm(this.estilo, fo, this.pal).map(function (d) { return d.k === 'circ' ? { k: 'circ', x: +d.x.toFixed(2), y: +d.y.toFixed(2), r: +d.r.toFixed(2), c: d.c, a: d.a } : { k: 'poly', p: d.p.map(function (q) { return [+q[0].toFixed(2), +q[1].toFixed(2)]; }), c: d.c, a: d.a }; });
      fd.append('properties[_posicion]', JSON.stringify(pos));
      this.progreso(62, 'Preparando la imagen del pedido…');
      var mk = await this.mockupBlob(900); if (mk) archivos.push(['properties[_Mockup]', mk, 'mockup.jpg']);
      archivos.forEach(function (c) { fd.append(c[0], c[1], c[2]); });
      await this.enviarCarrito(fd, btn, pres);
    } catch (e) {
      this.ocupado = false; this._presBusy = false;
      this.progreso(false);
      if (window.Cargando && btn && btn._crgTxt != null) { try { Cargando.libre(btn); } catch (x) { /* nada */ } }
      this.error(e && e.message === 'grande' ? 'Una de tus imágenes es demasiado grande incluso optimizada. Mándanosla por WhatsApp o por correo y lo montamos igual.' : (e && e.message === 'texto' ? 'No he podido preparar tu texto. Prueba con un texto más corto o escríbenos por WhatsApp.' : (pres ? ((e && e.message) || 'No se ha podido preparar el presupuesto. Inténtalo otra vez o escríbenos por WhatsApp.') : 'No se ha podido añadir al carrito. Inténtalo de nuevo o escríbenos por WhatsApp.')));
      this.actualizar();
    }
  };

  function arrancar() {
    [].forEach.call(document.querySelectorAll('[data-bandera]'), function (r) {
      if (!r._bnd) r._bnd = new Bandera(r);
    });
  }
  function cuando() {
    if (!window.BanderasFormas) { return setTimeout(cuando, 50); }
    arrancar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cuando); else cuando();
  window.addEventListener('resize', function () {
    [].forEach.call(document.querySelectorAll('[data-bandera]'), function (r) { if (r._bnd) r._bnd.dibujar(); });
  });
})();
